(function (factory) {
  typeof define === "function" && define.amd
    ? define("index", factory)
    : factory();
})(function () {
  "use strict";
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || !1;
      descriptor.configurable = !0;
      if ("value" in descriptor) descriptor.writable = !0;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: { value: subClass, writable: !0, configurable: !0 },
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf =
      Object.setPrototypeOf ||
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if (typeof Proxy === "function") return !0;
    try {
      Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {}),
      );
      return !0;
    } catch (e) {
      return !1;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError(
          "Super expression must either be null or a function",
        );
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called",
      );
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }

  function onYotpoReady(callback) {
    const interval = setInterval(() => {
      if (window.Yotpo && window.yotpo) {
        clearInterval(interval);
        callback();
      }
    }, 50); // check every 50ms
  }

  // Re-scan the page for Yotpo widgets that were inserted after its first scan.
  // The current Yotpo loader exposes `yotpoWidgetsContainer`; the legacy
  // `Yotpo.API` / `yotpo` pair that onYotpoReady waits for is never defined on
  // it, so that callback never runs. Waits (bounded) for the loader to arrive.
  function refreshYotpoWidgets() {
    let tries = 0;
    const timer = setInterval(() => {
      const container = window.yotpoWidgetsContainer;
      if (container && typeof container.initWidgets === "function") {
        clearInterval(timer);
        container.initWidgets();
      } else if (++tries > 200) {
        clearInterval(timer); // ~10s — Yotpo isn't on this page
      }
    }, 50);
  }

  // ── Legacy IndexedDB cleanup ──────────────────────────────────────────────
  // `wellowStoreDB` used to persist the PDP colour-swap caches (grouped_products,
  // color_dots_markup, related_products) plus a `meta` store holding the cache
  // version used to invalidate them. Every colour dot is now server-rendered by
  // snippets/product-color-dots.liquid and read straight off the DOM, so nothing
  // reads or writes that database any more. Drop it once so returning visitors
  // don't keep carrying the orphaned store around.
  (function dropLegacyPdpCache() {
    if (!window.indexedDB || !indexedDB.deleteDatabase) return;
    try {
      indexedDB.deleteDatabase("wellowStoreDB");
    } catch (_e) {
      /* incognito / blocked storage — nothing to clean up */
    }
  })();

  var Responsive = (function () {
    function Responsive() {
      var _this = this;
      _classCallCheck(this, Responsive);
      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener("resize", function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();
        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: _this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          }),
        );
        _this.currentBreakpoint = newBreakpoint;
      });
    }
    _createClass(Responsive, null, [
      {
        key: "matchesBreakpoint",
        value: function matchesBreakpoint(breakpoint) {
          switch (breakpoint) {
            case "phone":
              return window.matchMedia("screen and (max-width: 640px)").matches;
            case "tablet":
              return window.matchMedia(
                "screen and (min-width: 641px) and (max-width: 1007px)",
              ).matches;
            case "tablet-and-up":
              return window.matchMedia("screen and (min-width: 641px)").matches;
            case "pocket":
              return window.matchMedia("screen and (max-width: 1007px)")
                .matches;
            case "lap":
              return window.matchMedia(
                "screen and (min-width: 1008px) and (max-width: 1279px)",
              ).matches;
            case "lap-and-up":
              return window.matchMedia("screen and (min-width: 1008px)")
                .matches;
            case "desk":
              return window.matchMedia("screen and (min-width: 1280px)")
                .matches;
            case "widescreen":
              return window.matchMedia("screen and (min-width: 1600px)")
                .matches;
            case "supports-hover":
              return window.matchMedia("(hover: hover) and (pointer: fine)")
                .matches;
            case "no-supports-hover":
              return window.matchMedia("(hover: none) and (pointer: none)")
                .matches;
            case "supports-touch":
              return window.matchMedia("(hover: none) and (pointer: coarse)")
                .matches;
          }
        },
      },
      {
        key: "getCurrentBreakpoint",
        value: function getCurrentBreakpoint() {
          if (window.matchMedia("screen and (max-width: 640px)").matches) {
            return "phone";
          }
          if (
            window.matchMedia(
              "screen and (min-width: 641px) and (max-width: 1007px)",
            ).matches
          ) {
            return "tablet";
          }
          if (
            window.matchMedia(
              "screen and (min-width: 1008px) and (max-width: 1279px)",
            ).matches
          ) {
            return "lap";
          }
          if (window.matchMedia("screen and (min-width: 1280px)").matches) {
            return "desk";
          }
        },
      },
    ]);
    return Responsive;
  })();
  var Carousel = (function () {
    function Carousel(element) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var overrideSettings =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, Carousel);
      this.element = element;
      this.initialConfig = Object.assign(
        JSON.parse(element.getAttribute("data-flickity-config")),
        overrideSettings,
      );
      this.options = options;
      this._attachListeners();
      this._build();
    }
    _createClass(Carousel, [
      {
        key: "destroy",
        value: function destroy() {
          this.flickityInstance.destroy();
          if (this.initialConfig.breakpoints !== undefined) {
            document.removeEventListener(
              "breakpoint:changed",
              this._onBreakpointChangedListener,
            );
          }
        },
      },
      {
        key: "getFlickityInstance",
        value: function getFlickityInstance() {
          return this.flickityInstance;
        },
      },
      {
        key: "selectCell",
        value: function selectCell(index) {
          var shouldPause =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : !1;
          var shouldAnimate =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : !0;
          if (shouldPause) {
            this.flickityInstance.pausePlayer();
          }
          this.flickityInstance.select(index, !1, !shouldAnimate);
        },
      },
      {
        key: "next",
        value: function next() {
          this.flickityInstance.next();
        },
      },
      {
        key: "previous",
        value: function previous() {
          this.flickityInstance.previous();
        },
      },
      {
        key: "pausePlayer",
        value: function pausePlayer() {
          this.flickityInstance.pausePlayer();
        },
      },
      {
        key: "unpausePlayer",
        value: function unpausePlayer() {
          this.flickityInstance.unpausePlayer();
        },
      },
      {
        key: "resize",
        value: function resize() {
          this.flickityInstance.resize();
        },
      },
      {
        key: "getSelectedIndex",
        value: function getSelectedIndex() {
          return this.flickityInstance.selectedIndex;
        },
      },
      {
        key: "getSelectedCell",
        value: function getSelectedCell() {
          return this.flickityInstance.selectedCell.element;
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          if (this.initialConfig.breakpoints !== undefined) {
            this._onBreakpointChangedListener =
              this._onBreakpointChanged.bind(this);
            document.addEventListener(
              "breakpoint:changed",
              this._onBreakpointChangedListener,
            );
          }
        },
      },
      {
        key: "_build",
        value: function _build() {
          var _this = this;
          var config = this._processConfig();
          this.flickityInstance = new Flickity(this.element, config);
          this._validateDraggable();
          this.selectedIndex = this.flickityInstance.selectedIndex;
          this.flickityInstance.on(
            "resize",
            this._validateDraggable.bind(this),
          );
          if (this.options.onSelect) {
            this.flickityInstance.on("select", function () {
              if (
                _this.selectedIndex !== _this.flickityInstance.selectedIndex
              ) {
                _this.options.onSelect(
                  _this.flickityInstance.selectedIndex,
                  _this.flickityInstance.selectedCell.element,
                );
                _this.selectedIndex = _this.flickityInstance.selectedIndex;
              }
            });
          }
          if (this.options.onSettle) {
            this.flickityInstance.on("settle", function (index) {
              _this.options.onSettle(
                index,
                _this.flickityInstance.selectedCell.element,
              );
            });
          }
          if (this.options.onClick) {
            this.flickityInstance.on(
              "staticClick",
              function (event, pointer, cell, index) {
                _this.options.onClick(cell, index);
              },
            );
          }
        },
      },
      {
        key: "_validateDraggable",
        value: function _validateDraggable() {
          var isActive = this.flickityInstance.isActive || !1;
          if (!isActive || !this.flickityInstance.options.draggable) {
            return;
          }
          if (
            undefined === this.flickityInstance.selectedElements ||
            this.flickityInstance.selectedElements.length ===
              this.flickityInstance.cells.length
          ) {
            this.flickityInstance.unbindDrag();
          } else {
            this.flickityInstance.bindDrag();
          }
        },
      },
      {
        key: "_processConfig",
        value: function _processConfig() {
          var config = Object.assign({}, this.initialConfig);
          delete config.breakpoints;
          if (this.initialConfig.breakpoints === undefined) {
            return config;
          }
          var breakpoints = this.initialConfig.breakpoints;
          breakpoints.forEach(function (breakpoint) {
            if (Responsive.matchesBreakpoint(breakpoint["matches"])) {
              config = Object.assign(config, breakpoint["settings"]);
            }
          });
          return config;
        },
      },
      {
        key: "_onBreakpointChanged",
        value: function _onBreakpointChanged() {
          this.flickityInstance.destroy();
          this._build();
        },
      },
    ]);
    return Carousel;
  })();
  window.Carousel = Carousel;

  var Animation = (function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }
    _createClass(Animation, null, [
      {
        key: "slideUp",
        value: function slideUp(element) {
          element.style.height = "".concat(element.scrollHeight, "px");
          element.offsetHeight;
          element.style.height = 0;
        },
      },
      {
        key: "slideDown",
        value: function slideDown(element) {
          if (element.style.height === "auto") {
            return;
          }
          element.style.height = "".concat(
            element.firstElementChild.scrollHeight,
            "px",
          );
          var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === "height") {
              element.style.height = "auto";
              element.removeEventListener("transitionend", transitionEnded);
            }
          };
          element.addEventListener("transitionend", transitionEnded);
        },
      },
    ]);
    return Animation;
  })();
  var Dom = (function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }
    _createClass(Dom, null, [
      {
        key: "getSiblings",
        value: function getSiblings(element, filter) {
          var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : !1;
          var siblings = [];
          var currentElement = element;
          while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }
          if (includeSelf) {
            siblings.push(element);
          }
          currentElement = element;
          while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }
          return siblings;
        },
      },
      {
        key: "nodeListToArray",
        value: function nodeListToArray(nodeList, filter) {
          var items = [];
          for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
              items.push(nodeList[i]);
            }
          }
          return items;
        },
      },
      {
        key: "outerWidthWithMargin",
        value: function outerWidthWithMargin(element) {
          var width = element.offsetWidth,
            style = getComputedStyle(element);
          width += parseInt(style.marginLeft) + parseInt(style.marginRight);
          return width;
        },
      },
      {
        key: "outerHeightWithMargin",
        value: function outerHeightWithMargin(element) {
          var height = element.offsetHeight,
            style = getComputedStyle(element);
          height += parseInt(style.marginTop) + parseInt(style.marginBottom);
          return height;
        },
      },
    ]);
    return Dom;
  })();
  var Collapsible = (function () {
    function Collapsible() {
      _classCallCheck(this, Collapsible);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this._attachListeners();
    }
    _createClass(Collapsible, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on(
            "click",
            '[data-action="toggle-collapsible"]',
            this._toggleCollapsible.bind(this),
          );
        },
      },
      {
        key: "_toggleCollapsible",
        value: function _toggleCollapsible(event, target) {
          var _this = this;
          var parentCollapsible = target.closest(".Collapsible");
          if (
            parentCollapsible.classList.contains("Collapsible--autoExpand") &&
            Responsive.matchesBreakpoint("tablet-and-up")
          ) {
            return;
          }
          var isOpen = target.getAttribute("aria-expanded") === "true";
          if (isOpen) {
            this._close(parentCollapsible, target);
          } else {
            this._open(parentCollapsible, target);
          }
          Dom.getSiblings(parentCollapsible).forEach(
            function (collapsibleToClose) {
              return _this._close(collapsibleToClose);
            },
          );
          event.preventDefault();
        },
      },
      {
        key: "_open",
        value: function _open(collapsible) {
          var toggleButton = collapsible.querySelector(".Collapsible__Button"),
            collapsibleInner = collapsible.querySelector(".Collapsible__Inner");
          if (
            !collapsibleInner ||
            toggleButton.getAttribute("aria-expanded") === "true"
          ) {
            return;
          }
          toggleButton.setAttribute("aria-expanded", "true");
          collapsibleInner.style.overflow = "visible";
          Animation.slideDown(collapsibleInner);
          setTimeout(function () {
            collapsible.style.overflow = "visible";
          }, 350);
        },
      },
      {
        key: "_close",
        value: function _close(collapsible) {
          var toggleButton = collapsible.querySelector(".Collapsible__Button"),
            collapsibleInner = collapsible.querySelector(".Collapsible__Inner");
          if (
            !collapsibleInner ||
            toggleButton?.getAttribute("aria-expanded") === "false"
          ) {
            return;
          }
          toggleButton?.setAttribute("aria-expanded", "false");
          collapsibleInner.style.overflow = "hidden";
          collapsible.style.overflow = "hidden";
          Animation.slideUp(collapsibleInner);
        },
      },
    ]);
    return Collapsible;
  })();
  var Accessibility = (function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }
    _createClass(Accessibility, null, [
      {
        key: "trapFocus",
        value: function trapFocus(container, namespace, focusTarget) {
          this.listeners = this.listeners || {};
          this.lastFocused = this.lastFocused || {};
          // Remember what had focus so removeTrapFocus can hand it back.
          // Without this, closing search or the cart drawer dropped the user
          // at the top of the document instead of back on the trigger.
          this.lastFocused[namespace] =
            document.activeElement instanceof HTMLElement
              ? document.activeElement
              : null;
          // focusTarget was already being passed by _openSearch but the old
          // signature ignored it. [data-trap-focus] is the non-form-control
          // hook: `autofocus` on a tabindex="-1" heading risks the browser
          // focusing it at page load.
          var elementToFocus =
            focusTarget ||
            container.querySelector("[autofocus], [data-trap-focus]") ||
            container;
          container.setAttribute("tabindex", "-1");
          elementToFocus.focus();
          this.listeners[namespace] = function (event) {
            if (
              container !== event.target &&
              !container.contains(event.target)
            ) {
              container.focus();
            }
          };
          document.addEventListener("focusin", this.listeners[namespace]);
        },
      },
      {
        key: "removeTrapFocus",
        value: function removeTrapFocus(container, namespace) {
          if (container) {
            container.removeAttribute("tabindex");
          }
          if (this.listeners && this.listeners[namespace]) {
            document.removeEventListener("focusin", this.listeners[namespace]);
          }
          // Hand focus back to whatever opened this. Skipped when that element
          // has since been removed or hidden — getClientRects() rather than
          // offsetParent, which is null for position:fixed headers.
          var previous = this.lastFocused && this.lastFocused[namespace];
          if (previous) {
            this.lastFocused[namespace] = null;
            if (
              document.body.contains(previous) &&
              previous.getClientRects().length > 0
            ) {
              previous.focus();
            }
          }
        },
      },
      {
        key: "clearTrapFocus",
        value: function clearTrapFocus() {
          for (var key in this.listeners) {
            if (this.listeners.hasOwnProperty(key)) {
              document.removeEventListener("focusin", this.listeners[key]);
            }
          }
          this.listeners = {};
        },
      },
    ]);
    return Accessibility;
  })();
  var Drawer = (function () {
    function Drawer(element) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Drawer);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);
      this.onOpen = options.onOpen || function () {};
      this.onClose = options.onClose || function () {};
      this.isOpen = !1;
      this.direction = this.element.classList.contains("Drawer--fromLeft")
        ? "fromLeft"
        : "fromRight";
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(Drawer, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateBody.off(
            "click",
            '[data-action="open-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]',
            ),
          );
          this.delegateBody.off(
            "click",
            '[data-action="close-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]',
            ),
          );
          window.removeEventListener(
            "resize",
            this._calculateMaxHeightListener,
          );
        },
      },
      {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        },
      },
      {
        key: "_setTriggersExpanded",
        value: function _setTriggersExpanded(state) {
          // A drawer can have more than one trigger (the header icon and the
          // sidebar-menu variant both open sidebar-cart), so all of them have
          // to report the same state.
          var triggers = document.querySelectorAll(
            '[data-action="open-drawer"][data-drawer-id="' +
              this.element.id +
              '"][aria-expanded]',
          );
          for (var i = 0; i < triggers.length; i++) {
            triggers[i].setAttribute("aria-expanded", state);
          }
        },
      },
      {
        key: "open",
        value: function open(event) {
          if (this.isOpen) {
            return;
          }
          this.element.dispatchEvent(
            new CustomEvent("search:close", { bubbles: !0 }),
          );
          if (event) {
            event.preventDefault();
          }
          this.element.setAttribute("aria-hidden", "false");
          this._setTriggersExpanded("true");
          this._calculateMaxHeight();
          document.documentElement.classList.add("no-scroll");
          Accessibility.trapFocus(this.element, "drawer");
          document.querySelector("#shopify-section-header").style.zIndex = "";
          this.pageOverlayElement.classList.add("is-visible");
          this.pageOverlayElement.addEventListener(
            "click",
            this._closeListener,
          );
          this.isOpen = !0;
          this.onOpen();
          return !1;
        },
      },
      {
        key: "close",
        value: function close(event) {
          if (!this.isOpen) {
            return;
          }
          if (event) {
            event.preventDefault();
          }
          this.element.setAttribute("aria-hidden", "true");
          this._setTriggersExpanded("false");
          document.documentElement.classList.remove("no-scroll");
          Accessibility.removeTrapFocus(this.element, "drawer");
          this.pageOverlayElement.classList.remove("is-visible");
          this.pageOverlayElement.removeEventListener(
            "click",
            this._closeListener,
          );
          this.isOpen = !1;
          this.onClose();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._openListener = this.open.bind(this);
          this._closeListener = this.close.bind(this);
          this._calculateMaxHeightListener =
            this._calculateMaxHeight.bind(this);
          this.delegateBody.on(
            "click",
            '[data-action="open-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]',
            ),
            this._openListener,
          );
          this.delegateBody.on(
            "click",
            '[data-action="close-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]',
            ),
            this._closeListener,
          );
          this.element.addEventListener(
            "keyup",
            this._handleKeyboard.bind(this),
          );
          window.addEventListener("resize", this._calculateMaxHeightListener);
        },
      },
      {
        key: "_calculateMaxHeight",
        value: function _calculateMaxHeight() {
          this.element.style.maxHeight = window.innerHeight + "px";
        },
      },
      {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        },
      },
    ]);
    return Drawer;
  })();
  var LoadingBar = (function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);
      this.element = document.querySelector(".LoadingBar");
      document.addEventListener(
        "theme:loading:start",
        this._onLoadingStart.bind(this),
      );
      document.addEventListener(
        "theme:loading:end",
        this._onLoadingEnd.bind(this),
      );
      this.element.addEventListener(
        "transitionend",
        this._onTransitionEnd.bind(this),
      );
    }
    _createClass(LoadingBar, [
      {
        key: "_onLoadingStart",
        value: function _onLoadingStart() {
          this.element.classList.add("is-visible");
          this.element.style.width = "40%";
        },
      },
      {
        key: "_onLoadingEnd",
        value: function _onLoadingEnd() {
          this.element.style.width = "100%";
          this.element.classList.add("is-finished");
        },
      },
      {
        key: "_onTransitionEnd",
        value: function _onTransitionEnd(event) {
          if (
            event.propertyName === "width" &&
            this.element.classList.contains("is-finished")
          ) {
            this.element.classList.remove("is-visible");
            this.element.classList.remove("is-finished");
            this.element.style.width = "0";
          }
        },
      },
    ]);
    return LoadingBar;
  })();
  var Modal = (function () {
    function Modal() {
      _classCallCheck(this, Modal);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this.activeModal = null;
      this.wasLocked = !1;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
      this._checkOpenByHash();
    }
    _createClass(Modal, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._closeListener = this._closeModal.bind(this);
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this.domDelegate.on(
            "click",
            '[data-action="open-modal"]',
            this._openModalEvent.bind(this),
          );
          this.domDelegate.on(
            "click",
            '[data-action="close-modal"]',
            this._closeModal.bind(this),
          );
        },
      },
      {
        key: "_openModalEvent",
        value: function _openModalEvent(event, target) {
          var aria_controls = target.getAttribute("aria-controls");
          this._openModal(document.getElementById(aria_controls));
          if (aria_controls == "modal-sizing-chart") {
            ga("send", "event", {
              eventCategory: "Click",
              eventAction: "Size chart",
              eventLabel: target.getAttribute("data-product-title"),
            });
          }
          event.preventDefault();
          event.stopPropagation();
        },
      },
      {
        key: "_openModal",
        value: function _openModal(modal) {
          var _this = this;
          if (this.activeModal || !modal) {
            return;
          }
          this.activeModal = modal;
          this.domDelegate.on("keyup", this._handleKeyboardListener);
          if (document.documentElement.classList.contains("no-scroll")) {
            this.wasLocked = !0;
          }
          fastdom.mutate(function () {
            Accessibility.clearTrapFocus();
            _this._onTransitionEndedListener =
              _this._onTransitionEnded.bind(_this);
            _this.activeModal.addEventListener(
              "transitionend",
              _this._onTransitionEndedListener,
            );
            _this.activeModal.setAttribute("aria-hidden", "false");
            document.documentElement.classList.add("no-scroll");
            if (!_this.activeModal.classList.contains("Modal--fullScreen")) {
              _this.pageOverlayElement.classList.add("is-visible");
              _this.pageOverlayElement.addEventListener(
                "click",
                _this._closeListener,
              );
            }
          });
        },
      },
      {
        key: "_closeModal",
        value: function _closeModal() {
          var _this2 = this;
          if (!this.activeModal) {
            return;
          }
          this.activeModal.removeEventListener(
            "keyup",
            this._handleKeyboardListener,
          );
          this.domDelegate.off("keyup");
          fastdom.mutate(function () {
            if (_this2.activeModal.classList.contains("Modal--videoContent")) {
              _this2._resetVideoListener = _this2._resetVideo.bind(_this2);
              _this2.activeModal.addEventListener(
                "transitionend",
                _this2._resetVideoListener,
              );
            }
            Accessibility.removeTrapFocus(_this2.activeModal, "modal");
            if (!_this2.activeModal.classList.contains("Modal--fullScreen")) {
              _this2.pageOverlayElement.classList.remove("is-visible");
              _this2.pageOverlayElement.removeEventListener(
                "click",
                _this2._closeListener,
              );
            }
            _this2.activeModal.setAttribute("aria-hidden", "true");
            _this2.activeModal = null;
            if (!_this2.wasLocked) {
              document.documentElement.classList.remove("no-scroll");
            }
          });
        },
      },
      {
        key: "_onTransitionEnded",
        value: function _onTransitionEnded(event) {
          if (event.propertyName !== "visibility") {
            return;
          }
          Accessibility.trapFocus(this.activeModal, "modal");
          this.activeModal.removeEventListener(
            "transitionend",
            this._onTransitionEndedListener,
          );
        },
      },
      {
        key: "_resetVideo",
        value: function _resetVideo(event) {
          if (event.propertyName !== "visibility") {
            return;
          }
          var iframe = event.target.querySelector("iframe");
          iframe.parentNode.innerHTML =
            '<iframe class="Image--lazyLoad" data-src='.concat(
              iframe.getAttribute("data-src"),
              ' frameborder="0" allowfullscreen>',
            );
          event.target.removeEventListener(
            "transitionend",
            this._resetVideoListener,
          );
        },
      },
      {
        key: "_checkOpenByHash",
        value: function _checkOpenByHash() {
          var hash = window.location.hash,
            modal = document.getElementById(hash.replace("#", ""));
          if (modal && modal.classList.contains("Modal")) {
            this._openModal(modal);
          }
        },
      },
      {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (null !== this.activeModal && event.keyCode === 27) {
            this._closeModal();
          }
        },
      },
    ]);
    return Modal;
  })();
  var Popover = (function () {
    function Popover(element, options) {
      _classCallCheck(this, Popover);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator =
        options.activator ||
        document.querySelector(
          '[aria-controls="'.concat(element.getAttribute("id"), '"]'),
        );
      this.preferredPosition = options.preferredPosition || "bottom";
      this.preferredAlignment = options.preferredAlignment || undefined;
      this.threshold = options.threshold || 20;
      this.isOpen = !1;
      this.onValueChanged = options.onValueChanged || function () {};
      this.onOpen = options.onOpen || function () {};
      this.onClose = options.onClose || function () {};
      this.showOverlay =
        options.showOverlay === undefined ? !0 : options.showOverlay;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(Popover, [
      {
        key: "destroy",
        value: function destroy() {
          this.element.removeEventListener(
            "keyup",
            this._handleKeyboardListener,
          );
          this.delegateElement.off("click");
          this.activator.removeEventListener("click", this._toggleListener);
        },
      },
      {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        },
      },
      {
        key: "open",
        value: function open() {
          var _this = this;
          if (
            this.isOpen ||
            this.activator.getAttribute("aria-controls") !== this.element.id
          ) {
            return;
          }
          this.element.setAttribute("aria-hidden", "false");
          this.activator.setAttribute("aria-expanded", "true");
          disableBodyScroll(!0, "[data-scrollable]");
          document.documentElement.classList.add("no-scroll");
          if (Responsive.matchesBreakpoint("lap-and-up")) {
            document.body.addEventListener("click", this._clickOutsideListener);
            this._position();
            this.element.setAttribute("tabindex", "-1");
            this.element.addEventListener(
              "transitionend",
              function () {
                _this.element.focus();
              },
              { once: !0 },
            );
          } else {
            this.element.removeAttribute("style");
            if (this.showOverlay) {
              this.pageOverlayElement.classList.add("is-visible");
              this.pageOverlayElement.addEventListener(
                "click",
                this._closeListener,
              );
            }
          }
          this.onOpen(this);
          this.isOpen = !0;
        },
      },
      {
        key: "close",
        value: function close() {
          if (!this.isOpen) {
            return;
          }
          this.element.setAttribute("aria-hidden", "true");
          this.activator.setAttribute("aria-expanded", "false");
          disableBodyScroll(!1, "[data-scrollable]");
          document.documentElement.classList.remove("no-scroll");
          if (Responsive.matchesBreakpoint("lap-and-up")) {
            document.body.removeEventListener(
              "click",
              this._clickOutsideListener,
            );
          } else if (this.showOverlay) {
            this.pageOverlayElement.classList.remove("is-visible");
            this.pageOverlayElement.removeEventListener(
              "click",
              this._closeListener,
            );
          }
          this.element.removeAttribute("tabindex");
          this.activator.focus();
          this.onClose(this);
          this.isOpen = !1;
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this._clickOutsideListener = this._clickOutside.bind(this);
          this._closeListener = this.close.bind(this);
          this._toggleListener = this.toggle.bind(this);
          this.element.addEventListener("keyup", this._handleKeyboardListener);
          this.activator.addEventListener("click", this._toggleListener);
          this.delegateElement.on(
            "click",
            '[data-action="close-popover"]',
            this.close.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="select-value"]',
            this._valueChanged.bind(this),
          );
          if (this.element.hasAttribute("id")) {
            this.delegateElement.on(
              "focusout",
              "#".concat(this.element.getAttribute("id")),
              this._onFocusOut.bind(this),
            );
          }
        },
      },
      {
        key: "_valueChanged",
        value: function _valueChanged(event) {
          Dom.getSiblings(event.target, ".is-selected").forEach(
            function (item) {
              return item.classList.remove("is-selected");
            },
          );
          event.target.classList.add("is-selected");
          this.onValueChanged(
            event.target.getAttribute("data-value"),
            event.target,
            this.activator,
          );
          this.close();
        },
      },
      {
        key: "_onFocusOut",
        value: function _onFocusOut(event) {
          if (!this.element.contains(event.relatedTarget)) {
            this.close();
          }
        },
      },
      {
        key: "_clickOutside",
        value: function _clickOutside(event) {
          if (
            !event.target.closest(".Popover") &&
            !event.target.closest(".Modal") &&
            event.target !== this.activator &&
            !this.activator.contains(event.target)
          ) {
            this.close();
          }
        },
      },
      {
        key: "_position",
        value: function _position() {
          var _this2 = this;
          var topPosition = 0,
            rightPosition = 0,
            position = "",
            alignment = "",
            threshold = this.threshold;
          fastdom.measure(function () {
            var windowHeight = window.innerHeight,
              activatorBoundingRect = _this2.activator.getBoundingClientRect(),
              halfHeight = windowHeight / 2;
            if (_this2.preferredPosition === "bottom") {
              alignment = "right";
              if (
                _this2.element.clientHeight <=
                  windowHeight - (activatorBoundingRect.bottom + threshold) ||
                windowHeight - activatorBoundingRect.bottom >= halfHeight
              ) {
                position = "bottom";
              } else {
                position = "top";
              }
            } else if (_this2.preferredPosition === "top") {
              alignment = "right";
              if (
                _this2.element.clientHeight <=
                  activatorBoundingRect.top - threshold ||
                activatorBoundingRect.top >= halfHeight
              ) {
                position = "top";
              } else {
                position = "bottom";
              }
            } else {
              position = "left";
              var halfElementHeight = _this2.element.clientHeight / 2;
              if (
                activatorBoundingRect.top >= halfElementHeight &&
                windowHeight - activatorBoundingRect.bottom >= halfElementHeight
              ) {
                alignment = "center";
              } else if (
                windowHeight - activatorBoundingRect.bottom >=
                halfElementHeight
              ) {
                alignment = "bottom";
              } else {
                alignment = "top";
              }
            }
            if (_this2.preferredAlignment) {
              alignment = _this2.preferredAlignment;
            }
            if (position === "top") {
              topPosition =
                activatorBoundingRect.top -
                _this2.element.clientHeight -
                threshold;
              if (alignment === "center") {
                rightPosition =
                  window.innerWidth -
                  activatorBoundingRect.right -
                  _this2.element.clientWidth / 2 +
                  3;
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right;
              }
            } else if (position === "bottom") {
              topPosition = activatorBoundingRect.bottom + threshold;
              if (alignment === "center") {
                rightPosition =
                  window.innerWidth -
                  activatorBoundingRect.right -
                  _this2.element.clientWidth / 2 +
                  3;
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right;
              }
            } else {
              rightPosition =
                window.innerWidth - activatorBoundingRect.left + threshold;
              if (alignment === "center") {
                topPosition =
                  activatorBoundingRect.top -
                  _this2.element.clientHeight / 2 +
                  _this2.activator.clientHeight / 2;
              } else if (alignment === "top") {
                topPosition =
                  activatorBoundingRect.bottom - _this2.element.clientHeight;
              } else {
                topPosition = activatorBoundingRect.top;
              }
            }
          });
          fastdom.mutate(function () {
            [
              "Popover--positionBottom",
              "Popover--positionTop",
              "Popover--positionCenter",
              "Popover--alignTop",
              "Popover--alignCenter",
              "Popover--alignBottom",
            ].map(function (item) {
              return _this2.element.classList.remove(item);
            });
            _this2.element.classList.add(
              "Popover--position".concat(
                position.charAt(0).toUpperCase() + position.slice(1),
              ),
            );
            _this2.element.classList.add(
              "Popover--align".concat(
                alignment.charAt(0).toUpperCase() + alignment.slice(1),
              ),
            );
            _this2.element.setAttribute(
              "style",
              "top: "
                .concat(parseInt(topPosition), "px; right: ")
                .concat(parseInt(rightPosition), "px;"),
            );
          });
        },
      },
      {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        },
      },
    ]);
    return Popover;
  })();
  var PageTransition = (function () {
    function PageTransition() {
      _classCallCheck(this, PageTransition);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this.pageTransition = document.querySelector(".PageTransition");
      this._attachListeners();
    }
    _createClass(
      PageTransition,
      [
        {
          key: "_attachListeners",
          value: function _attachListeners() {
            this.domDelegate.on(
              "click",
              'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
              this._onPageUnload.bind(this),
            );
          },
        },
        {
          key: "_onPageUnload",
          value: function _onPageUnload(event, target) {
            var _this = this;
            if (
              event.defaultPrevented ||
              event.ctrlKey ||
              event.metaKey ||
              !window.theme.showPageTransition ||
              !this.pageTransition
            ) {
              return;
            }
            event.preventDefault();
            if (window.theme.showPageTransition && this.pageTransition) {
              var doTransition = function doTransition(event) {
                if (event.propertyName === "opacity") {
                  _this.pageTransition.removeEventListener(
                    "transitionend",
                    doTransition,
                  );
                  window.location.href = target.href;
                }
              };
              this.pageTransition.addEventListener(
                "transitionend",
                doTransition,
              );
              this.pageTransition.style.visibility = "visible";
              this.pageTransition.style.opacity = "1";
            }
          },
        },
      ],
      [
        {
          key: "getInstance",
          value: function getInstance() {
            if (!this.instance) {
              this.instance = new PageTransition();
            }
            return this.instance;
          },
        },
      ],
    );
    return PageTransition;
  })();
  var ProductItemColorSwatch = (function () {
    function ProductItemColorSwatch(element) {
      _classCallCheck(this, ProductItemColorSwatch);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on(
        "change",
        ".ColorSwatch__Radio",
        this._colorChanged.bind(this),
      );
    }
    _createClass(ProductItemColorSwatch, [
      {
        key: "_colorChanged",
        value: function _colorChanged(event, target) {
          var productItem = target.closest(".ProductItem"),
            variantUrl = target.getAttribute("data-variant-url");
          productItem
            .querySelector(".ProductItem__ImageWrapper")
            .setAttribute("href", variantUrl);
          productItem
            .querySelector(".ProductItem__Title > a")
            .setAttribute("href", variantUrl);
          var originalImageElement = productItem.querySelector(
            ".ProductItem__Image:not(.ProductItem__Image--alternate)",
          );
          if (
            target.hasAttribute("data-image-url") &&
            target.getAttribute("data-image-id") !==
              originalImageElement.getAttribute("data-image-id")
          ) {
            var newImageElement = document.createElement("img");
            newImageElement.className =
              "ProductItem__Image Image--fadeIn Image--lazyLoad";
            newImageElement.setAttribute(
              "data-image-id",
              target.getAttribute("data-image-id"),
            );
            newImageElement.setAttribute(
              "data-src",
              target.getAttribute("data-image-url"),
            );
            newImageElement.setAttribute(
              "data-widths",
              target.getAttribute("data-image-widths"),
            );
            newImageElement.setAttribute("data-sizes", "auto");
            if (window.theme.productImageSize === "natural") {
              originalImageElement.parentNode.style.paddingBottom = "".concat(
                100.0 / target.getAttribute("data-image-aspect-ratio"),
                "%",
              );
            }
            originalImageElement.parentNode.style.setProperty(
              "--aspect-ratio",
              target.getAttribute("data-image-aspect-ratio"),
            );
            originalImageElement.parentNode.replaceChild(
              newImageElement,
              originalImageElement,
            );
          }
        },
      },
    ]);
    return ProductItemColorSwatch;
  })();
  var Image = (function () {
    function Image() {
      _classCallCheck(this, Image);
    }
    _createClass(Image, null, [
      {
        key: "getSizedImageUrl",
        value: function getSizedImageUrl(src, size) {
          if (size === null) {
            return src;
          }
          if (size === "master") {
            return src.replace(/http(s)?:/, "");
          }
          var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
          );
          if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
          } else {
            return null;
          }
        },
      },
      {
        key: "getSupportedSizes",
        value: function getSupportedSizes(image, desiredSizes) {
          var supportedSizes = [],
            imageWidth = image.width;
          desiredSizes.forEach(function (width) {
            if (imageWidth >= width) {
              supportedSizes.push(width);
            }
          });
          return supportedSizes;
        },
      },
    ]);
    return Image;
  })();
  var ProductImageZoom = (function () {
    function ProductImageZoom(element, slideshow) {
      _classCallCheck(this, ProductImageZoom);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.body);
      this.slideshow = slideshow;
      this._attachListeners();
    }
    _createClass(ProductImageZoom, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("click");
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="open-product-zoom"]',
            this._initPhotoSwipe.bind(this),
          );
          this.delegateElement.on(
            "click",
            ".Product__SlideItem--image",
            this._initPhotoSwipeFromImageClick.bind(this),
          );
        },
      },
      {
        key: "_initPhotoSwipe",
        value: function _initPhotoSwipe() {
          var images = [];
          this.slideshow.flickityInstance.cells.forEach(function (item) {
            if (item.element.classList.contains("Product__SlideItem--image")) {
              const img = item.element.querySelector("img[data-original-src]");
              if (img) {
                images.push(img);
              }
              // images.push(item.element.querySelector("img"));
            }
          });
          this._createPhotoSwipeInstance(
            this._createPhotoSwipeItemsFromImages(images),
            parseInt(
              this.slideshow.flickityInstance.selectedElement.getAttribute(
                "data-image-media-position",
              ),
            ),
          );
        },
      },
      {
        key: "_initPhotoSwipeFromImageClick",
        value: function _initPhotoSwipeFromImageClick(event, target) {
          if (Responsive.matchesBreakpoint("pocket")) {
            return;
          }
          var images = Dom.nodeListToArray(
            this.element.querySelectorAll(".Product__SlideItem--image img"),
          ).filter((img) => img.hasAttribute("data-original-src"));
          this._createPhotoSwipeInstance(
            this._createPhotoSwipeItemsFromImages(images),
            parseInt(target.getAttribute("data-image-media-position")),
          );
        },
      },
      {
        key: "_createPhotoSwipeItemsFromImages",
        value: function _createPhotoSwipeItemsFromImages(images) {
          return images.map(function (image) {
            var maxWidth = parseInt(image.getAttribute("data-max-width")),
              maxHeight = parseInt(image.getAttribute("data-max-height")),
              maxDimension = Responsive.matchesBreakpoint("phone")
                ? 1200
                : 1800,
              reduceFactor = 1.0;
            if (maxWidth >= maxHeight) {
              reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
            } else {
              reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
            }
            var requestedWidth = Math.floor(maxWidth / reduceFactor);
            var requestedHeight = Math.floor(maxHeight / reduceFactor);
            return {
              msrc: image.currentSrc || image.src,
              w: requestedWidth,
              h: requestedHeight,
              initialZoomLevel: 0.65,
              src: Image.getSizedImageUrl(
                image.getAttribute("data-original-src"),
                requestedWidth + "x" + requestedHeight,
              ),
            };
          });
        },
      },
      {
        key: "_createPhotoSwipeInstance",
        value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
          var _this = this;
          var photoswipeContainer = document.querySelector(".pswp");
          this.photoSwipeInstance = new PhotoSwipe(
            photoswipeContainer,
            !1,
            items,
            {
              index: selectedImageIndex,
              showHideOpacity: !0,
              showAnimationDuration: 500,
              loop: !1,
              history: !1,
              closeOnVerticalDrag: !1,
              allowPanToNext: !1,
              pinchToClose: !1,
              errorMsg:
                '<p class="pswp__error-msg">' +
                window.languages.productImageLoadingError +
                "</p>",
              scaleMode: "zoom",
              getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) {
                  return 1.6;
                } else {
                  return item.initialZoomLevel < 0.7 ? 1 : 1.33;
                }
              },
              getThumbBoundsFn: function getThumbBoundsFn(index) {
                var thumbnail = _this.element.querySelector(
                    '.Product__Slideshow .Carousel__Cell[data-image-media-position="'.concat(
                      parseInt(index),
                      '"] img',
                    ),
                  ),
                  pageYScroll =
                    window.pageYOffset || document.documentElement.scrollTop,
                  rect = thumbnail.getBoundingClientRect();
                return {
                  x: rect.left,
                  y: rect.top + pageYScroll,
                  w: rect.width,
                };
              },
            },
          );
          this.photoSwipeInstance.listen(
            "beforeChange",
            this._onSlideChanged.bind(this),
          );
          this.photoSwipeInstance.listen(
            "destroy",
            this._destroyPhotoSwipe.bind(this),
          );
          this.photoSwipeInstance.listen(
            "doubleTap",
            this._onDoubleTap.bind(this),
          );
          this.photoSwipeInstance.listen(
            "initialZoomIn",
            this._onInitialZoomIn.bind(this),
          );
          this.photoSwipeInstance.listen(
            "initialZoomOut",
            this._onInitialZoomOut.bind(this),
          );
          this.delegateRoot.on(
            "pswpTap",
            ".pswp__scroll-wrap",
            this._onSingleTap.bind(this),
          );
          this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--close",
            this.photoSwipeInstance.close,
          );
          this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--prev",
            this.photoSwipeInstance.prev,
          );
          this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--next",
            this.photoSwipeInstance.next,
          );
          this.photoSwipeInstance.init();
        },
      },
      {
        key: "_onSlideChanged",
        value: function _onSlideChanged() {
          if (this.photoSwipeInstance.getCurrentIndex() === 0) {
            this.photoSwipeInstance.scrollWrap
              .querySelector(".pswp__button--prev")
              .setAttribute("disabled", "disabled");
          } else {
            this.photoSwipeInstance.scrollWrap
              .querySelector(".pswp__button--prev")
              .removeAttribute("disabled");
          }
          if (
            this.photoSwipeInstance.getCurrentIndex() + 1 ===
            this.photoSwipeInstance.options.getNumItemsFn()
          ) {
            this.photoSwipeInstance.scrollWrap
              .querySelector(".pswp__button--next")
              .setAttribute("disabled", "disabled");
          } else {
            this.photoSwipeInstance.scrollWrap
              .querySelector(".pswp__button--next")
              .removeAttribute("disabled");
          }
        },
      },
      {
        key: "_onSingleTap",
        value: function _onSingleTap(event) {
          if (!event.detail || event.detail.pointerType === "mouse") {
            if (event.target.classList.contains("pswp__img")) {
              this.photoSwipeInstance.toggleDesktopZoom(
                event.detail.releasePoint,
              );
            }
          } else {
            if (event.target.classList.contains("pswp__button")) {
              return;
            }
            event.target
              .closest(".pswp")
              .querySelector(".pswp__ui")
              .classList.toggle("pswp__ui--hidden");
          }
        },
      },
      {
        key: "_onDoubleTap",
        value: function _onDoubleTap(point) {
          var initialZoomLevel =
            this.photoSwipeInstance.currItem.initialZoomLevel;
          if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
            this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
          } else {
            this.photoSwipeInstance.zoomTo(
              initialZoomLevel < 0.7 ? 1 : 1.33,
              point,
              333,
            );
          }
        },
      },
      {
        key: "_onInitialZoomIn",
        value: function _onInitialZoomIn() {
          document
            .querySelector(".pswp__ui")
            .classList.remove("pswp__ui--hidden");
        },
      },
      {
        key: "_onInitialZoomOut",
        value: function _onInitialZoomOut() {
          document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
        },
      },
      {
        key: "_destroyPhotoSwipe",
        value: function _destroyPhotoSwipe() {
          this.delegateRoot.off("pswpTap");
          this.photoSwipeInstance = null;
        },
      },
    ]);
    return ProductImageZoom;
  })();
  var ProductModel = (function () {
    function ProductModel(element, stackProductImages) {
      _classCallCheck(this, ProductModel);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.documentElement);
      this.stackProductImages = stackProductImages;
      this._attachListeners();
      var stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href =
        "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
      document.head.appendChild(stylesheet);
      window.Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this._setupModelViewerUI.bind(this),
        },
        { name: "shopify-xr", version: "1.0" },
      ]);
    }
    _createClass(ProductModel, [
      { key: "destroy", value: function destroy() {} },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;
          this.element
            .querySelector("model-viewer")
            .addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function () {
                _this.element.dispatchEvent(
                  new CustomEvent("model:played", { bubbles: !0 }),
                );
              },
            );
          this.element
            .querySelector("model-viewer")
            .addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function () {
                _this.element.dispatchEvent(
                  new CustomEvent("model:paused", { bubbles: !0 }),
                );
              },
            );
        },
      },
      {
        key: "hasBeenSelected",
        value: function hasBeenSelected() {
          if (Responsive.matchesBreakpoint("supports-hover")) {
            this.modelUi.play();
          }
        },
      },
      {
        key: "hasBeenDeselected",
        value: function hasBeenDeselected() {
          this.modelUi.pause();
        },
      },
      {
        key: "_setupModelViewerUI",
        value: function _setupModelViewerUI() {
          this.modelElement = this.element.querySelector("model-viewer");
          this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
        },
      },
    ]);
    return ProductModel;
  })();
  var ProductReviews = (function () {
    function ProductReviews(container) {
      _classCallCheck(this, ProductReviews);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on(
        "click",
        ".spr-summary-actions-newreview",
        this._onNewReviewClicked.bind(this),
      );
      window.SPRCallbacks = {};
      window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
      window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
    }
    _createClass(ProductReviews, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
        },
      },
      {
        key: "_updatePagination",
        value: function _updatePagination(event, target) {
          SPR.$(target).data(
            "page",
            parseInt(target.getAttribute("data-page")) + 1,
          );
        },
      },
      {
        key: "_onFormSuccess",
        value: function _onFormSuccess() {
          var formSuccess = this.element.querySelector(
            ".spr-form-message-success",
          );
          window.scrollTo(0, formSuccess.offsetTop - 45);
        },
      },
      {
        key: "_onReviewsLoad",
        value: function _onReviewsLoad() {
          var sprSummaryActions = this.element.querySelector(
              ".spr-summary-actions",
            ),
            previousSprPaginationNext = sprSummaryActions.querySelector(
              ".spr-pagination-next",
            ),
            sprPaginationNext = this.element.querySelector(
              ".spr-pagination .spr-pagination-next",
            );
          if (previousSprPaginationNext) {
            previousSprPaginationNext.remove();
          }
          if (sprPaginationNext) {
            sprSummaryActions.insertBefore(
              sprPaginationNext,
              sprSummaryActions.firstChild,
            );
          }
        },
      },
      {
        key: "_onNewReviewClicked",
        value: function _onNewReviewClicked(event, target) {
          target.style.display = "none";
          if (target.previousElementSibling) {
            target.previousElementSibling.style.display = "none";
          }
        },
      },
    ]);
    return ProductReviews;
  })();
  var Form = (function () {
    function Form() {
      _classCallCheck(this, Form);
    }
    _createClass(Form, null, [
      {
        key: "serialize",
        value: function serialize(form) {
          function stringKey(key, value) {
            var beginBracket = key.lastIndexOf("[");
            if (beginBracket === -1) {
              var _hash = {};
              _hash[key] = value;
              return _hash;
            }
            var newKey = key.substr(0, beginBracket);
            var newValue = {};
            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
            return stringKey(newKey, newValue);
          }
          var hash = {};
          for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];
            if (formElement.name === "" || formElement.disabled) {
              continue;
            }
            if (
              formElement.name &&
              !formElement.disabled &&
              (formElement.checked ||
                /select|textarea/i.test(formElement.nodeName) ||
                /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                  formElement.type,
                ))
            ) {
              var stringKeys = stringKey(formElement.name, formElement.value);
              hash = Form.extend(hash, stringKeys);
            }
          }
          return hash;
        },
      },
      {
        key: "extend",
        value: function extend() {
          var extended = {};
          var i = 0;
          var merge = function merge(obj) {
            for (var prop in obj) {
              if (obj.hasOwnProperty(prop)) {
                if (
                  Object.prototype.toString.call(obj[prop]) ===
                  "[object Object]"
                ) {
                  extended[prop] = Form.extend(extended[prop], obj[prop]);
                } else {
                  extended[prop] = obj[prop];
                }
              }
            }
          };
          for (; i < arguments.length; i++) {
            merge(arguments[i]);
          }
          return extended;
        },
      },
    ]);
    return Form;
  })();
  var Currency = (function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }
    _createClass(Currency, null, [
      {
        key: "formatMoney",
        value: function formatMoney(cents, format) {
          if (typeof cents === "string") {
            cents = cents.replace(".", "");
          }
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || "${{amount}}";
          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
              return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split("."),
              dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands,
              ),
              centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
          }
          var value = "";
          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;
            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;
            case "amount_with_space_separator":
              value = formatWithDelimiters(cents, 2, " ", ".");
              break;
            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ",", ".");
              break;
            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;
            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;
          }
          if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString
              .replace(placeholderRegex, value)
              .replace(",00", "");
          } else {
            return formatString
              .replace(placeholderRegex, value)
              .replace(".00", "");
          }
        },
      },
    ]);
    return Currency;
  })();
  var VariantSelector = (function () {
    function VariantSelector(element, parentProductVariants) {
      var options =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, VariantSelector);
      this.element = element;
      this.parentProductVariants = parentProductVariants;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator =
        options.activator ||
        document.querySelector(
          '[aria-controls="'.concat(element.getAttribute("id"), '"]'),
        );
      this.onValueChangedCallback = options.onValueChanged || function () {};
      this.isOpen = !1;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this.variantChoiceList = Dom.nodeListToArray(
        this.element.querySelectorAll(".VariantSelector__Choice"),
      );
      this.variantCarousel = new Carousel(
        this.element.querySelector(".VariantSelector__Carousel"),
        {
          onSelect: this._variantChanged.bind(this),
          onClick: this._variantSelected.bind(this),
        },
      );
      this._attachListeners();
    }
    _createClass(VariantSelector, [
      {
        key: "destroy",
        value: function destroy() {
          this.element.removeEventListener(
            "keyup",
            this._handleKeyboardListener,
          );
          this.delegateElement.off("click");
          this.activator.removeEventListener("click", this._toggleListener);
          this.variantCarousel.destroy();
        },
      },
      {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        },
      },
      {
        key: "open",
        value: function open() {
          if (this.isOpen) {
            return;
          }
          this.element.setAttribute("aria-hidden", "false");
          this.activator.setAttribute("aria-expanded", "true");
          Accessibility.trapFocus(this.element, "variant-selector");
          document.documentElement.classList.add("no-scroll");
          this.element.setAttribute("style", "");
          this.pageOverlayElement.classList.add("is-visible");
          this.pageOverlayElement.addEventListener(
            "click",
            this._closeListener,
          );
          this.isOpen = !0;
        },
      },
      {
        key: "close",
        value: function close() {
          if (!this.isOpen) {
            return;
          }
          this.element.setAttribute("aria-hidden", "true");
          this.activator.setAttribute("aria-expanded", "false");
          Accessibility.removeTrapFocus(this.element, "variant-selector");
          document.documentElement.classList.remove("no-scroll");
          this.pageOverlayElement.classList.remove("is-visible");
          this.pageOverlayElement.removeEventListener(
            "click",
            this._closeListener,
          );
          this.isOpen = !1;
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this._closeListener = this.close.bind(this);
          this._toggleListener = this.toggle.bind(this);
          this.element.addEventListener("keyup", this._handleKeyboardListener);
          this.activator.addEventListener("click", this._toggleListener);
          this.delegateElement.on(
            "click",
            '[data-action="select-variant"]',
            this._onVariantSelect.bind(this),
          );
          this.parentProductVariants.delegateElement.on(
            "variant:changed",
            this._onVariantChanged.bind(this),
          );
        },
      },
      {
        key: "_variantChanged",
        value: function _variantChanged(selectedIndex) {
          var activeChoice = this.variantChoiceList[selectedIndex];
          activeChoice.classList.add("is-selected");
          Dom.getSiblings(activeChoice, ".is-selected").forEach(
            function (item) {
              return item.classList.remove("is-selected");
            },
          );
        },
      },
      {
        key: "_variantSelected",
        value: function _variantSelected(cellElement, cellIndex) {
          if (this.variantCarousel.getSelectedIndex() === cellIndex) {
            this.onValueChangedCallback(
              cellElement.getAttribute("data-option-value"),
              cellElement,
              this.activator,
            );
            this.close();
          } else {
            this.variantCarousel.selectCell(cellIndex);
          }
        },
      },
      {
        key: "_onVariantChanged",
        value: function _onVariantChanged(event) {
          var _this = this;
          var selectedVariant = event.detail.variant,
            imageWrapperElements = this.element.querySelectorAll(
              ".VariantSelector__ImageWrapper",
            ),
            found = !1;
          Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
            var colorPosition =
                parseInt(
                  image.parentElement.getAttribute("data-option-position"),
                ) - 1,
              combinationExcludedColor = "";
            selectedVariant.options.forEach(function (optionValue, index) {
              if (index !== colorPosition) {
                combinationExcludedColor += optionValue;
              }
            });
            if (
              image.getAttribute("data-variant-title") ===
              combinationExcludedColor
            ) {
              image.setAttribute("aria-hidden", "false");
              found = !0;
            } else {
              image.setAttribute("aria-hidden", "true");
            }
          });
          if (!found) {
            imageWrapperElements.children[0].setAttribute(
              "aria-hidden",
              "false",
            );
          }
          var foundColorIndex = 0;
          Dom.nodeListToArray(
            this.element.querySelectorAll(".VariantSelector__ChoicePrice"),
          ).forEach(function (priceElement, index) {
            var colorPosition =
              parseInt(priceElement.getAttribute("data-color-position")) - 1;
            _this.parentProductVariants.productData.variants.forEach(
              function (variant) {
                var matchOptionsExcludedColor = !0;
                variant.options.forEach(function (option, index) {
                  if (index !== colorPosition) {
                    if (
                      variant.options[index] !== selectedVariant.options[index]
                    ) {
                      matchOptionsExcludedColor = !1;
                    }
                  }
                });
                if (
                  matchOptionsExcludedColor &&
                  variant.options[colorPosition] ===
                    selectedVariant.options[colorPosition]
                ) {
                  if (foundColorIndex++ === index) {
                    priceElement.innerHTML =
                      '<span class="Heading Text--subdued">'.concat(
                        Currency.formatMoney(
                          variant.price,
                          window.theme.moneyFormat,
                        ),
                        "</span>",
                      );
                  }
                }
              },
            );
          });
        },
      },
      {
        key: "_onVariantSelect",
        value: function _onVariantSelect() {
          var selectedCell =
            this.variantCarousel.flickityInstance.selectedCell.element;
          this.onValueChangedCallback(
            selectedCell.getAttribute("data-option-value"),
            selectedCell,
            this.activator,
          );
          this.close();
        },
      },
      {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        },
      },
    ]);
    return VariantSelector;
  })();
  var StoreAvailability = (function () {
    function StoreAvailability(element, productTitle) {
      _classCallCheck(this, StoreAvailability);
      this.element = element;
      this.productTitle = productTitle;
    }
    _createClass(StoreAvailability, [
      {
        key: "updateWithVariant",
        value: function updateWithVariant(variant) {
          if (!this.element) {
            return;
          }
          if (!variant) {
            this.element.textContent = "";
            return;
          }
          this._renderAvailabilitySection(variant.id);
        },
      },
      {
        key: "_renderAvailabilitySection",
        value: function _renderAvailabilitySection(id) {
          var _this = this;
          this.element.innerHTML = "";
          var availabilityModal = document.getElementById(
            "StoreAvailabilityModal-".concat(id),
          );
          if (availabilityModal) {
            availabilityModal.remove();
          }
          return fetch(
            ""
              .concat(window.routes.rootUrlWithoutSlash, "/variants/")
              .concat(id, "?section_id=store-availability"),
          ).then(function (response) {
            return response.text().then(function (content) {
              _this.element.innerHTML = content;
              _this.element.innerHTML =
                _this.element.firstElementChild.innerHTML;
              var productTitle = _this.element.querySelector(
                ".store-availabilities-modal__product-title",
              );
              if (productTitle) {
                productTitle.textContent = _this.productTitle;
              }
              var availabilityModal = document.getElementById(
                "StoreAvailabilityModal-".concat(id),
              );
              document.body.appendChild(availabilityModal);
              new Drawer(availabilityModal);
            });
          });
        },
      },
    ]);
    return StoreAvailability;
  })();
  var ProductVariants = (function () {
    function ProductVariants(container, options) {
      var _this = this;
      _classCallCheck(this, ProductVariants);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      var jsonData = JSON.parse(
        this.element.querySelector("[data-product-json]").innerHTML,
      );
      this.productData = jsonData.product;
      this.variantsInventories = jsonData.inventories || {};
      this.masterSelector = this.element.querySelector(
        "#product-select-".concat(this.productData.id),
      );
      this.packSelector = this.element.querySelector("select#pack-select");
      this.selectedSize = sessionStorage.getItem("product-selected-size");

      this.productData.variants.forEach(function (variant) {
        if (variant.id === jsonData.selected_variant_id) {
          _this.currentVariant = variant;
          _this.option1 = variant.option1;
          _this.option2 = variant.option2;
          _this.option3 = variant.option3;
        }
      });
      this.storeAvailability = new StoreAvailability(
        this.element.querySelector(".ProductMeta__StoreAvailabilityContainer"),
        this.productData.title,
      );
      this.storeAvailability.updateWithVariant(this.currentVariant);
      this._attachListeners();
      this._createSelectors();
      if (this.selectedSize) {
        var selectedEl = this.element.querySelector(
          `.ProductForm__Option input[value="${this.selectedSize}"]`,
        );
        if (!selectedEl) {
          return;
        }
        if (selectedEl.disabled) {
          var selectedEls = this.element.querySelectorAll(
            `.ProductForm__Option input.SizeSwatch__Radio:not(:disabled)`,
          );
          if (selectedEls.length > 0) {
            selectedEl = selectedEls[0];
            sessionStorage.setItem("product-selected-size", selectedEl.value);
          }
        }
        selectedEl.dispatchEvent(new Event("change", { bubbles: !0 }));
        selectedEl.dispatchEvent(new Event("click", { bubbles: !0 }));
        selectedEl.setAttribute("checked", "checked");
        this.selectedSize = null;
      }
    }
    _createClass(ProductVariants, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("click");
          this.formPopovers.forEach(function (popover) {
            return popover.destroy();
          });
          this.formVariantSelectors.forEach(function (selector) {
            return selector.destroy();
          });
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="add-to-cart"]',
            this._addToCart.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="decrease-quantity"]',
            this._decreaseQuantity.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="increase-quantity"]',
            this._increaseQuantity.bind(this),
          );
          this.delegateElement.on(
            "change",
            '[name="quantity"]',
            this._validateQuantity.bind(this),
          );
          this.delegateElement.on(
            "change",
            '.ProductForm__Option [type="radio"]',
            this._onOptionChanged.bind(this),
          );
        },
      },
      {
        key: "_createSelectors",
        value: function _createSelectors() {
          var _this2 = this;
          this.formPopovers = [];
          this.formVariantSelectors = [];
          Dom.nodeListToArray(
            this.element.querySelectorAll(".OptionSelector"),
          ).forEach(function (item) {
            var popover = new Popover(item, {
              preferredPosition: "left",
              onValueChanged: _this2._onOptionChanged.bind(_this2),
            });
            _this2.formPopovers.push(popover);
          });
          Dom.nodeListToArray(
            this.element.querySelectorAll(".VariantSelector"),
          ).forEach(function (item) {
            var variantSelector = new VariantSelector(item, _this2, {
              onValueChanged: _this2._onOptionChanged.bind(_this2),
            });
            _this2.formVariantSelectors.push(variantSelector);
          });
        },
      },
      {
        key: "_onVariantChanged",
        value: function _onVariantChanged(previousVariant, newVariant) {
          this._updateProductPrices(newVariant, previousVariant);
          this._updateInventory(newVariant, previousVariant);
          this._updateSku(newVariant, previousVariant);
          this._updateUnitPrice(newVariant, previousVariant);
          this._updateAddToCartButton(newVariant, previousVariant);
          this.storeAvailability.updateWithVariant(newVariant);
          this.element.dispatchEvent(
            new CustomEvent("variant:changed", {
              bubbles: !0,
              detail: { variant: newVariant, previousVariant: previousVariant },
            }),
          );
        },
      },
      {
        key: "_updateProductPrices",
        value: function _updateProductPrices(newVariant, previousVariant) {
          var productMetaPrices = this.element.querySelector(
            ".ProductMeta__PriceList",
          );
          if (!productMetaPrices) {
            return;
          }
          const product_collections =
            productMetaPrices.getAttribute("data-collections");
          const product_pack = productMetaPrices.getAttribute("data-pack");
          // Product-level compare_at from Liquid (data-compare attribute).
          // Many size variants carry compare_at_price = 0 even when the product has a
          // compare price. Fall back to the product-level value so the subtract markdown
          // can use the correct (compare − factor) × 0.9 hideStrikethrough formula.
          const product_compare_at = parseInt(
            productMetaPrices.getAttribute("data-compare") || "0",
            10,
          );
          if (!newVariant) {
            productMetaPrices.style.display = "none";
          } else {
            if (
              previousVariant &&
              previousVariant.price === newVariant.price &&
              previousVariant.compare_at_price === newVariant.compare_at_price
            ) {
              return;
            }
            const effective_compare_at =
              newVariant.compare_at_price > 0
                ? newVariant.compare_at_price
                : product_compare_at;
            // data-pack-size: needed by subtract markdown to scale per-pair amount.
            // data-compare-price on the outer div: needed for data-discounted-price calc.
            // data-compare-price on the inner span: read by $el.data("compare-price") in
            //   MarkdownPricePro subtract logic to determine hideStrikethrough formula.
            let innerHTML = `<div class="pro-main-price" data-product-coll="${product_collections}" data-pack-size="${product_pack}" data-price="${newVariant.price}" data-compare-price="${effective_compare_at}" ${effective_compare_at > newVariant.price ? 'data-discounted-price="' + newVariant.price + '"' : ""}>`;
            if (effective_compare_at > newVariant.price) {
              innerHTML +=
                '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4"' +
                ' data-compare-price="$' +
                (effective_compare_at / 100).toFixed(2) +
                '" data-money-convertible>'.concat(
                  "$",
                  (newVariant.price / 100).toFixed(2),
                  "</span>",
                );
              innerHTML +=
                '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>List: '.concat(
                  "$",
                  (effective_compare_at / 100).toFixed(2),
                  "</span>",
                );
            } else {
              innerHTML +=
                '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(
                  "$",
                  (newVariant.price / 100).toFixed(2),
                  "</span>",
                );
              innerHTML += `<span class="CustomUnitPricing" data-pack="${product_pack}">
                <span class="current-price Price">$${(
                  newVariant["price"] /
                  product_pack /
                  100
                ).toFixed(2)}</span>
                <span class="fade-pricing">per pair (Total <span class="full-price">$${(
                  newVariant["price"] / 100
                ).toFixed(2)}</span>)</span>
              </span>`;
            }
            innerHTML += "</div>";
            productMetaPrices.innerHTML = innerHTML;
            productMetaPrices.style.display = "";
          }
        },
      },
      {
        key: "_updateInventory",
        value: function _updateInventory(newVariant) {
          if (!this.options.showInventoryQuantity) {
            return;
          }
          var productFormInventory = this.element.querySelector(
              ".ProductForm__Inventory",
            ),
            variantInventory = newVariant
              ? this.variantsInventories[newVariant.id]
              : null;
          if (
            !newVariant ||
            null === variantInventory.inventory_management ||
            variantInventory.inventory_quantity <= 0 ||
            (this.options.inventoryQuantityThreshold > 0 &&
              variantInventory.inventory_quantity >
                this.options.inventoryQuantityThreshold)
          ) {
            productFormInventory.style.display = "none";
          } else {
            productFormInventory.innerHTML = variantInventory.inventory_message;
            productFormInventory.style.display = "";
          }
        },
      },
      {
        key: "_updateSku",
        value: function _updateSku(newVariant) {
          if (!this.options.showSku || !newVariant) {
            return;
          }
          var productSkuNumber = this.element.querySelector(
            ".ProductMeta__SkuNumber",
          );
          if (productSkuNumber && newVariant.sku) {
            productSkuNumber.innerText = newVariant.sku;
          }
        },
      },
      {
        key: "_updateUnitPrice",
        value: function _updateUnitPrice(newVariant) {
          if (!newVariant) {
            return;
          }
          var unitPriceMeasurement = this.element.querySelector(
            ".ProductMeta__UnitPriceMeasurement",
          );
          if (!unitPriceMeasurement) {
            return;
          }
          if (!newVariant.hasOwnProperty("unit_price")) {
            unitPriceMeasurement.style.display = "none";
            return;
          }
          unitPriceMeasurement.style.display = "block";
          unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__Price",
          ).innerHTML = Currency.formatMoney(
            newVariant.unit_price,
            window.theme.moneyFormat,
          );
          unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__ReferenceUnit",
          ).textContent = newVariant.unit_price_measurement.reference_unit;
          var unitPriceReferenceValue = unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__ReferenceValue",
          );
          unitPriceReferenceValue.textContent =
            newVariant.unit_price_measurement.reference_value;
          unitPriceReferenceValue.style.display =
            newVariant.unit_price_measurement.reference_value === 1
              ? "none"
              : "inline";
        },
      },
      {
        key: "_updateAddToCartButton",
        value: function _updateAddToCartButton(newVariant) {
          var addToCartButton = this.element.querySelector(
              ".ProductForm__AddToCart",
            ),
            shopifyPaymentButton = this.element.querySelector(
              ".shopify-payment-button",
            );
          if (addToCartButton) {
            addToCartButton.classList.remove("Button--secondary");
            addToCartButton.classList.remove("Button--primary");
            if (!newVariant) {
              addToCartButton.setAttribute("disabled", "disabled");
              addToCartButton.removeAttribute("data-action");
              addToCartButton.classList.add("Button--secondary");
              addToCartButton.classList.remove("bg-green-light");
              addToCartButton.innerHTML =
                window.languages.productFormUnavailable;
            } else {
              // Check if the variant is available for preorder
              // If the variant is available for preorder, we need to check if the preorder threshold has been met
              let isPreorderVariant = false;
              const variantInventoryElement = document.getElementById(
                "PreorderQuantities-" + this.productData.id,
              );
              if (variantInventoryElement) {
                const variantInventory = JSON.parse(
                  variantInventoryElement.innerHTML || "{}",
                );
                const variantDetails = variantInventory[newVariant.id];
                const shipsOnDate = variantDetails?.ships_on_date;
                newVariant.variantDetails = variantDetails;
                
                if (variantDetails && variantDetails.pre_order) {
                  isPreorderVariant = true;
                  newVariant.available = true;
                }
                if(isPreorderVariant && variantDetails && variantDetails.mod_inventory_quantity > variantDetails.preorder_threshold){
                  isPreorderVariant = false;
                  newVariant.available = false;
                }
                
                const delayedShippingMsg = this.element.querySelector('.pdp-delayed-shipping');
                if (delayedShippingMsg) {
                  delayedShippingMsg.style.display = isPreorderVariant && shipsOnDate ? 'inline-flex' : 'none';
                }
                
                const propInput = document.getElementById('delayed-shipping-prop-' + this.productData.id);
                if (propInput) propInput.disabled = !isPreorderVariant || !shipsOnDate;

                if(isPreorderVariant && shipsOnDate){                  
                  const [year, month, day] = shipsOnDate.split('-').map(Number);
                  const date = new Date(year, month - 1, day);
                  if (propInput) {
                    const formatted = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
                    propInput.value = "Ships by " + formatted;
                  }
                  if (delayedShippingMsg) {
                    const formatted = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric' });
                    delayedShippingMsg.querySelector('.pdp-delayed-shipping-text').textContent = "This Color Ships On " + formatted;
                  }
                }

              }

              if (newVariant.available) {
                addToCartButton.removeAttribute("disabled");
                addToCartButton.classList.add("bg-green-light");
                addToCartButton.classList.add(
                  addToCartButton.getAttribute("data-use-primary-button") ===
                    "true"
                    ? "Button--primary"
                    : "Button--secondary",
                );
                addToCartButton.setAttribute("data-action", "add-to-cart");
                
                let preorderSuffixHtml = '<span class="ProductForm__PreorderSuffix" style="display:none;"></span>';
                if(isPreorderVariant && newVariant?.variantDetails?.ships_on_date){
                  const [year, month, day] = newVariant.variantDetails.ships_on_date.split('-').map(Number);
                  const date = new Date(year, month - 1, day); // constructed in local time, no UTC round-trip
                  const formatted = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric' });
                  preorderSuffixHtml = '<span class="ProductForm__PreorderSuffix">: Ships by '.concat(formatted,"</span>");
                }
                if (
                  undefined === this.options.showPriceInButton ||
                  this.options.showPriceInButton
                ) {
                  addToCartButton.innerHTML = "\n            <span>"
                    .concat(
                      window.languages.productFormAddToCart,
                      preorderSuffixHtml,
                      '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>',
                    )
                    .concat(
                      Currency.formatMoney(
                        newVariant.price,
                        window.theme.moneyFormat,
                      ),
                      "</span>\n          ",
                    );
                } else {
                  addToCartButton.innerHTML = "<span>".concat(
                    window.languages.productFormAddToCart,
                    preorderSuffixHtml,
                    "</span>",
                  );
                }
              } else {
                addToCartButton.setAttribute("disabled", "disabled");
                addToCartButton.classList.add("Button--secondary");
                addToCartButton.classList.remove("bg-green-light");
                addToCartButton.removeAttribute("data-action");
                addToCartButton.innerHTML = window.languages.productFormSoldOut;
              }
            }
          }
          if (this.options.showPaymentButton && shopifyPaymentButton) {
            if (!newVariant || !newVariant.available) {
              shopifyPaymentButton.style.display = "none";
            } else {
              shopifyPaymentButton.style.display = "block";
            }
          }
        },
      },
      {
        key: "_onOptionChanged",
        value: function _onOptionChanged(newValue, target, activator) {
          let selectedSize = newValue;
          const acceptedWidecalfSizes = window.themeVariables.acceptedWidecalfSizes;
          const sizeMap = window.themeVariables.sizeMap;

          if (activator) {
            this["option" + target.getAttribute("data-option-position")] = newValue;
            activator.querySelector(".ProductForm__SelectedValue").innerHTML = sizeMap[newValue] || newValue;
          } else {
            this["option" + target.getAttribute("data-option-position")] = target.value;
            var selectedValue = target
              .closest(".ProductForm__Option")
              .querySelector(".ProductForm__SelectedValue");

            this.selectedSize = target.value;
            sessionStorage.setItem("product-selected-size", this.selectedSize);
            if (selectedValue) {
              selectedValue.innerHTML = sizeMap[target.value] || target.value;
            }
            selectedSize = target.value;
          }

          const isWidecalfSize = acceptedWidecalfSizes.includes(selectedSize);
          const widecalfDescriptionEl = this.element.querySelector(
            ".widecalf-description",
          );
          const compressionSectionEl = document.querySelector(
            ".Compression-Section",
          );
          if (widecalfDescriptionEl) {
            widecalfDescriptionEl.classList.toggle("hide-all", !isWidecalfSize);
          }

          if (compressionSectionEl) {
            const compressionImages =
              compressionSectionEl.querySelectorAll("img");
            compressionImages.forEach((image) => {
              const isWidecalfImage = image.classList.contains(
                "widecalf-compression-image",
              );
              image.classList.toggle(
                "hide-all",
                isWidecalfSize ? !isWidecalfImage : isWidecalfImage,
              );
            });
          }

          var previousVariant = this.currentVariant;
          var jsonData = JSON.parse(
            this.element.querySelector("[data-product-json]").innerHTML,
          );
          this.productData = jsonData.product;
          this.currentVariant = this._getCurrentVariantFromOptions();
          this._onVariantChanged(previousVariant, this.currentVariant);
          if (this.currentVariant) {
            if (this.options.enableHistoryState) {
              this._updateHistoryState(this.currentVariant);
            }
            if (this.masterSelector.querySelector("[selected]")) {
              this.masterSelector
                .querySelector("[selected]")
                .removeAttribute("selected");
            }
            if (this.packSelector) {
              if (this.packSelector.querySelector("[selected]")) {
                this.packSelector
                  .querySelector("[selected]")
                  .removeAttribute("selected");
              }
              this.packSelector
                .querySelector('[data-title="'.concat(this.selectedSize, '"]'))
                .setAttribute("selected", "selected");
            } else {
              this.masterSelector
                .querySelector('[value="'.concat(this.currentVariant.id, '"]'))
                .setAttribute("selected", "selected");
              this.masterSelector.dispatchEvent(
                new Event("change", { bubbles: !0 }),
              );
            }
          }
        },
      },
      {
        key: "_getCurrentVariantFromOptions",
        value: function _getCurrentVariantFromOptions() {
          var _this3 = this;
          var found = !1;
          this.productData.variants.forEach(function (variant) {
            if (
              variant.option1 === _this3.option1 &&
              variant.option2 === _this3.option2 &&
              variant.option3 === _this3.option3
            ) {
              found = variant;
            }
          });
          return found || null;
        },
      },
      {
        key: "_updateHistoryState",
        value: function _updateHistoryState(variant) {
          if (!history.replaceState) {
            return;
          }
          var currentUrl = new URL(window.location);
          var searchParams = new URLSearchParams(currentUrl.search);
          searchParams.set("variant", variant.id);
          var newUrl =
            currentUrl.origin +
            currentUrl.pathname +
            "?" +
            searchParams.toString();
          window.history.replaceState({ path: newUrl }, "", newUrl);
        },
      },
      {
        key: "_addToCart",
        value: function _addToCart(event) {
          var _this4 = this;
          if (!this.options.useAjaxCart) {
            return;
          }

          event.preventDefault();

          function isValidEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
          }

          if (window.themeVariables.template == "product.gift-card") {
            const recipientCheckbox = document.querySelector(
              'input[name="properties[__shopify_send_gift_card_to_recipient]"]',
            );
            const recipientEmailInput = document.querySelector(
              'input[name="properties[Recipient email]"]',
            );
            if (recipientEmailInput) {
              recipientEmailInput.parentElement.classList.remove("bg-error");
            }

            if (
              recipientCheckbox &&
              recipientCheckbox.checked &&
              recipientEmailInput
            ) {
              if (
                recipientEmailInput.value.trim() == "" ||
                !isValidEmail(recipientEmailInput.value.trim())
              ) {
                recipientEmailInput.parentElement.classList.add("bg-error");
                return;
              }
            }
          }

          var addToCartButton = this.element.querySelector(
            ".ProductForm__AddToCart",
          );
          addToCartButton.setAttribute("disabled", "disabled");
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          var formElement = this.element.querySelector(
            'form[action*="/cart/add"]',
          );
          var _serializedForm = Form.serialize(formElement);
          var _priceAbProps =
            typeof getPriceAbLineItemProperties === "function"
              ? getPriceAbLineItemProperties()
              : {
                  _price_ab: document.body.classList.contains("price-ab-regular")
                    ? "b"
                    : "a",
                  _customer_type:
                    document.body.classList.contains("show-retention-banner") ||
                    /(?:^|; )WW_PR_kStatus=/.test(document.cookie)
                      ? "RET"
                      : "ACQ",
                };
          _serializedForm.properties = Object.assign(
            _serializedForm.properties || {},
            _priceAbProps
          );
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(_serializedForm),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            var quantityElement =
              formElement.querySelector('[name="quantity"]');
            if (response.ok) {
              addToCartButton.removeAttribute("disabled");
              response.json().then(function (product) {
                _this4.element.dispatchEvent(
                  new CustomEvent("product:added", {
                    bubbles: !0,
                    detail: {
                      product,
                      variant: _this4.currentVariant,
                      quantity: quantityElement
                        ? parseInt(quantityElement.value)
                        : 1,
                    },
                  }),
                );
              });
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement("span");
                errorMessageElement.className =
                  "ProductForm__Error Alert Alert--error";
                errorMessageElement.innerHTML = content.description;
                addToCartButton.removeAttribute("disabled");
                addToCartButton.insertAdjacentElement(
                  "afterend",
                  errorMessageElement,
                );
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
          event.preventDefault();
        },
      },
      {
        key: "_decreaseQuantity",
        value: function _decreaseQuantity(event, target) {
          target.nextElementSibling.value = Math.max(
            parseInt(target.nextElementSibling.value) - 1,
            1,
          );
        },
      },
      {
        key: "_increaseQuantity",
        value: function _increaseQuantity(event, target) {
          target.previousElementSibling.value =
            parseInt(target.previousElementSibling.value) + 1;
        },
      },
      {
        key: "_validateQuantity",
        value: function _validateQuantity(event, target) {
          target.value = Math.max(parseInt(target.value) || 1, 1);
        },
      },
    ]);
    return ProductVariants;
  })();
  var ProductDots = (function () {
    function ProductDots(container, options) {
      _classCallCheck(this, ProductDots);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      this.selectedSize = sessionStorage.getItem("product-selected-size");
      // P3: stale-update guard — incremented on every dot click; each async
      // update captures the value at start and bails if it has changed by the
      // time the DOM write runs.  Prevents out-of-order renders on rapid clicks.
      this._updateSeq = 0;
      // P5: per-instance RGB cache so Strategy 4 never re-decodes the same image
      this._rgbCache = new Map();
      // P12: AbortController so all in-flight fetches are cancelled on destroy
      this._abortCtrl = new AbortController();
      this._loadRelatedProducts();
      this._attachListeners();
      onYotpoReady(() => {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      });
    }
    _createClass(ProductDots, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("change");
          if (this._onVariantChangedForDots) {
            this.element.removeEventListener(
              "variant:changed",
              this._onVariantChangedForDots,
            );
          }

          if (this._sizeAbObserver) {
            this._sizeAbObserver.disconnect();
            this._sizeAbObserver = null;
          }
          // P12: cancel all in-flight fetches started by this instance
          this._abortCtrl.abort();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "change",
            '.color-dot-col [type="radio"]',
            this._onClickDot.bind(this),
          );

          // Existing size-aware A/B feature (refreshDotsForSize).
          // Always listen for variant:changed; gate the refresh on the body
          // class at event time. Convert often adds legacy-size-option-behaviour
          // after ProductDots constructs — attaching only when the class is
          // already present leaves the feature permanently unwired.
          this._onVariantChangedForDots = (e) => {
            if (
              !document.body.classList.contains("legacy-size-option-behaviour")
            ) {
              return;
            }
            const selectedSize =
              e.detail?.variant?.option1 ||
              sessionStorage.getItem("product-selected-size");
            if (selectedSize) {
              this.refreshDotsForSize(selectedSize);
            }
          };
          this.element.addEventListener(
            "variant:changed",
            this._onVariantChangedForDots,
          );

          // When Convert adds the A/B class late, refresh once for the current size.
          this._sizeAbActive = document.body.classList.contains(
            "legacy-size-option-behaviour",
          );
          this._sizeAbObserver = new MutationObserver(() => {
            const hasClass = document.body.classList.contains(
              "legacy-size-option-behaviour",
            );
            if (hasClass === this._sizeAbActive) return;
            this._sizeAbActive = hasClass;
            if (!hasClass) return;
            const selectedSize =
              sessionStorage.getItem("product-selected-size") ||
              this.element.querySelector(
                '.SizeSwatch__Radio.MainProduct[type="radio"]:checked',
              )?.value;
            if (selectedSize) {
              this.refreshDotsForSize(selectedSize);
            }
          });
          this._sizeAbObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"],
          });
        },
      },
      {
        key: "_isColorAvailableForSize",
        value: function _isColorAvailableForSize(product, selectedSize) {
          // A dot with no data-variants (legacy single-dot fallback) is treated as
          // available rather than silently disabled.
          if (!product?.details?.variants?.length) return true;
          const isAvailable = (v) =>
            !!product.variants_preorder_data?.[v.id]?.available;
          if (!selectedSize) {
            return product.details.variants.some(isAvailable);
          }
          const sizeVariants = product.details.variants.filter(
            (v) => v.option1 === selectedSize,
          );
          if (!sizeVariants.length) return false;
          return sizeVariants.some(isAvailable);
        },
      },
      {
        key: "_applyColorDotAvailability",
        value: function _applyColorDotAvailability(
          dotInput,
          dotLabel,
          product,
          selectedSize,
        ) {
          if (!dotInput || !dotLabel || !product) return;
          const abEnabled = document.body.classList.contains(
            "legacy-size-option-behaviour",
          );
          if (abEnabled) {
            // Size-unavailable is informational only — keep the dot selectable.
            const isAvailable = this._isColorAvailableForSize(
              product,
              selectedSize,
            );
            dotInput.disabled = false;
            dotLabel.classList.remove("disabled");
            dotLabel.classList.toggle("unavailable-for-size", !isAvailable);
          } else {
            // No variant data (legacy single-dot fallback) means "unknown", not
            // "sold out" — don't disable a dot we know nothing about.
            const isAvailable = product.details.variants.length
              ? product.details.variants.some((v) => v.available)
              : true;
            dotInput.disabled = !isAvailable;
            dotLabel.classList.remove("unavailable-for-size");
            dotLabel.classList.toggle("disabled", !isAvailable);
          }
        },
      },
      {
        key: "refreshDotsForSize",
        value: function refreshDotsForSize(selectedSize) {
          const groupedProducts = window.groupedProducts || [];
          if (!groupedProducts.length) return;
          const colorDotWrap = this.element.querySelector(".color-dot-wrap");
          if (!colorDotWrap) return;
          colorDotWrap.querySelectorAll(".color-dot-col").forEach((dotCol) => {
            const dotInput = dotCol.querySelector("input");
            const dotLabel = dotCol.querySelector("label");
            if (!dotInput || !dotLabel) return;
            const dotProductId = Number(dotInput.dataset.productId);
            const matchedProduct = groupedProducts.find(
              (p) => p.details.id == dotProductId,
            );
            if (!matchedProduct) return;
            // Include the checked dot — after clicking a size-unavailable color,
            // size may fall back and that selected color must clear gray/strikethrough.
            this._applyColorDotAvailability(
              dotInput,
              dotLabel,
              matchedProduct,
              selectedSize,
            );
          });
        },
      },
      {
        key: "getCurrentProductData",
        value: function getCurrentProductData() {
          const currentProduct = document.querySelector("[data-product-json]");
          return currentProduct ? JSON.parse(currentProduct.innerHTML) : null;
        },
      },
      {
        key: "updateSelectedColorDot",
        value: async function updateSelectedColorDot(container, productId) {
          var self = this;
          var groupedProducts = window.groupedProducts || [];

          container.querySelectorAll(".color-dot-col").forEach((colorDot) => {
            const dotInput = colorDot.querySelector("input");
            const dotLabel = colorDot.querySelector("label");
            const dotProductId = Number(dotInput.dataset.productId);
            const matchedProduct = groupedProducts.find(
              (p) => p.details.id == dotProductId,
            );

            if (matchedProduct) {
              const _abEnabled = document.body.classList.contains("legacy-size-option-behaviour");
              const _selectedSize = _abEnabled
                ? (sessionStorage.getItem("product-selected-size") || null)
                : null;
              this._applyColorDotAvailability(
                dotInput,
                dotLabel,
                matchedProduct,
                _selectedSize,
              );
            }
            dotInput.checked = dotProductId == productId;

            // select the color dot of ankle aerolite upsell product based on the selected products color
            if (dotProductId == productId) {
              self.selectAnkleColorDot(matchedProduct);
            }
          });

          document.addEventListener("shopify:section:reloaded", (e) => {
            if (e.detail.section == "product") {
              self.selectAnkleColorDot();
            }
          });
        },
      },
      {
        key: "selectAnkleColorDot",
        value: function selectAnkleColorDot(product) {
          let colors = [];
          if (product) {
            colors = product.metafields.custom?.color || [];
          } else {
            const selectedColorDot = document.querySelector(
              '.ProductForm .color-dot-col input[type="radio"]:checked',
            );

            if (!selectedColorDot) return;
            colors = selectedColorDot.dataset.productColors
              .split(",")
              .map((c) => c.trim().toLowerCase());
          }

          if (!colors.length) return;

          const matchingRadios = Array.from(
            document.querySelectorAll(
              '.upsell-item-wrapper input[type="radio"][data-product-colors]',
            ),
          ).find((radio) => {
            const data = radio.dataset.productColors
              .split(",")
              .map((c) => c.trim().toLowerCase());

            return colors.some((color) => data.includes(color.toLowerCase()));
          });

          if (matchingRadios) {
            matchingRadios.dispatchEvent(
              new InputEvent("change", { bubbles: true }),
            );
            matchingRadios.checked = true;
          }
        },
      },
      {
        /**
         * Reads the server-rendered color dots (snippets/product-color-dots.liquid)
         * into the `window.groupedProducts` shape the rest of this class expects.
         * Every dot for the product's color_family is already in the DOM on first
         * paint, so there is no fetch and no IndexedDB read here.
         */
        /**
         * The main PDP swatches. A product page carries several .color-dot-wrap
         * elements — the cross-sell and upsell modules render their own — so an
         * unscoped query only found the right one by DOM-order luck.
         * .ProductForm__Option--ColorDots is rendered solely by product-form.liquid.
         */
        key: "_getColorDotWrap",
        value: function _getColorDotWrap() {
          // A product swap replaces [data-section="product-data-section"]'s
          // innerHTML, which leaves this.element detached but still holding a
          // full copy of the old markup — including a .color-dot-wrap. Scoping
          // to it then quietly operates on DOM the shopper cannot see, so only
          // trust it while it is still in the document.
          const root =
            this.element && this.element.isConnected ? this.element : document;
          return (
            root.querySelector(".ProductForm__Option--ColorDots .color-dot-wrap") ||
            document.querySelector(".ProductForm__Option--ColorDots .color-dot-wrap") ||
            document.querySelector(".color-dot-wrap")
          );
        },
      },
      {
        key: "_initDotsFromDOM",
        value: function _initDotsFromDOM() {
          const colorDotWrap = this._getColorDotWrap();
          if (!colorDotWrap) return [];

          // Variants arrive as one JSON blob keyed by product id (see
          // product-color-dots.liquid). The per-dot data-variants attribute is
          // the older shape — still read as a fallback for cached markup.
          let variantMap = {};
          const blob = colorDotWrap.querySelector(".js-color-dot-variants");
          if (blob) {
            try {
              variantMap = JSON.parse(blob.textContent) || {};
            } catch (_e) {
              variantMap = {};
            }
          }

          const products = [];
          colorDotWrap.querySelectorAll(".color-dot-col input").forEach((input) => {
            const id = Number(input.dataset.productId);
            if (!id) return;
            let variants = Array.isArray(variantMap[id]) ? variantMap[id] : [];
            if (!variants.length && input.dataset.variants) {
              try {
                variants = JSON.parse(input.dataset.variants);
              } catch (_e) {
                variants = [];
              }
            }
            const variantsPreorderData = {};
            variants.forEach((v) => {
              variantsPreorderData[v.id] = {
                available: !!v.available,
                pre_order: !!v.pre_order,
              };
            });
            products.push({
              details: {
                id: id,
                handle: input.dataset.productHandle || "",
                title: input.dataset.productTitle || "",
                url: input.dataset.productUrl || "",
                variants: variants.map((v) => ({
                  id: v.id,
                  option1: v.option1,
                  available: !!v.available,
                })),
              },
              variants_preorder_data: variantsPreorderData,
              metafields: {
                custom: {
                  color: (input.dataset.productColors || "")
                    .split(",")
                    .map((c) => c.trim())
                    .filter(Boolean),
                },
              },
              fabric: input.dataset.fabric || "",
              supportLevel: input.dataset.supportLevel || "",
            });
          });

          // Liquid caps some loops, and a truncated pool renders as a quietly
          // incomplete swatch row. Compare against the size the server reported.
          const poolSize = Number(blob?.dataset.poolSize || 0);
          if (poolSize && products.length < poolSize) {
            console.warn(
              `[PDP] Colour dots truncated: rendered ${products.length} of ${poolSize} in this colour family.`,
            );
          }
          return products;
        },
      },
      {
        key: "_loadRelatedProducts",
        value: function _loadRelatedProducts() {
          // Re-bind on every construction, before the early return. A section
          // swap builds a new instance, and leaving these pointing at the
          // destroyed one made the next fabric / support-level switch act on
          // detached markup.
          window.swapColorDotsToFabric = this.swapColorDotsToFabric.bind(this);
          window.swapColorDotsToSupportLevel =
            this.swapColorDotsToSupportLevel.bind(this);

          if (document.body.classList.contains("product-dots-loaded")) return;

          const productData = this.getCurrentProductData();
          const colorDotWrap = this._getColorDotWrap();

          window.groupedProducts = this._initDotsFromDOM();
          window.currentProductData = productData;

          const axisSection = document.querySelector(
            ".fabric-technology-section, .support-level-section",
          );
          window.currentColorFamilyId = axisSection?.dataset.colorFamilyId || "";
          window.currentProductGroupTag = window.currentColorFamilyId || null;
          if (!window.relatedProductsData) window.relatedProductsData = {};

          if (colorDotWrap && productData) {
            this.updateSelectedColorDot(colorDotWrap, productData.product.id);
          }

          // Everything needed for a fabric / support-level switch is already in
          // the DOM, so the swap functions are exposed synchronously.
          document.body.classList.add("product-dots-loaded");
          window.swapColorDotsToFabric = this.swapColorDotsToFabric.bind(this);
          window.swapColorDotsToSupportLevel =
            this.swapColorDotsToSupportLevel.bind(this);
        },
      },
      {
        /**
         * Show/hide already-rendered dots for one axis ("fabric" or
         * "supportLevel"), pinning the other axis to the current selection, then
         * re-run the closest-colour selection over what is left visible.
         * No fetch, no re-render — the dots never leave the DOM.
         */
        key: "_swapDotsByAxis",
        value: async function _swapDotsByAxis(
          axis,
          targetValue,
          currentProductId,
          currentColorDotTag,
        ) {
          const colorDotWrap = this._getColorDotWrap();
          if (!colorDotWrap) return;

          const cols = Array.from(colorDotWrap.querySelectorAll(".color-dot-col"));
          if (!cols.length) return;

          const axisKey = axis === "fabric" ? "fabric" : "supportLevel";
          const otherKey = axis === "fabric" ? "supportLevel" : "fabric";

          // Capture the outgoing selection before re-filtering — the closest-colour
          // algorithm matches the new visible set against it.
          const checkedInput = colorDotWrap.querySelector("input:checked");
          const checkedLabel = checkedInput
            ? colorDotWrap.querySelector(`label[for="${checkedInput.id}"]`)
            : null;
          const currentDotInfo = {
            colorTag: currentColorDotTag,
            productColors: checkedInput
              ? (checkedInput.dataset.productColors || "").split(",").filter(Boolean)
              : [],
            productTitle: checkedInput ? checkedInput.dataset.productTitle || "" : "",
            imageUrl:
              checkedLabel && checkedLabel.style.backgroundImage
                ? checkedLabel.style.backgroundImage
                    .replace(/url\(["']?/, "")
                    .replace(/["']?\)/, "")
                : null,
          };

          // Pin the other axis to whatever is selected right now.
          const otherValue = checkedInput ? checkedInput.dataset[otherKey] || "" : "";

          // Remember this axis-value's selection so switching back restores it
          // (e.g. AP-Yellow -> Signature-Sesame -> back to AP-Yellow).
          if (!window.lastAxisColorSelection) window.lastAxisColorSelection = {};
          const previousValue = checkedInput ? checkedInput.dataset[axisKey] || "" : "";
          if (previousValue) {
            window.lastAxisColorSelection[axis + ":" + previousValue] = currentDotInfo;
          }

          const applyFilter = (matchOtherAxis) => {
            let shown = 0;
            cols.forEach((col) => {
              const input = col.querySelector("input");
              if (!input) return;
              let show = (input.dataset[axisKey] || "") === targetValue;
              if (show && matchOtherAxis) {
                const otherVal = input.dataset[otherKey] || "";
                // A blank on either side means "not scoped by that axis".
                show = !otherValue || !otherVal || otherVal === otherValue;
              }
              col.style.display = show ? "" : "none";
              if (show) shown++;
            });
            return shown;
          };

          let visibleCount = applyFilter(true);
          // Nothing satisfies both axes — relax the secondary one rather than
          // leaving the shopper looking at an empty row.
          if (!visibleCount) visibleCount = applyFilter(false);
          if (!visibleCount) {
            cols.forEach((col) => {
              col.style.display = "";
            });
            return;
          }

          const dotInfoForSelection =
            window.lastAxisColorSelection?.[axis + ":" + targetValue] || currentDotInfo;
          await this._selectClosestColorDot(colorDotWrap, dotInfoForSelection);
        },
      },
      {
        /** Accepts a fabric handle, an "ap"/"rg" code, or a legacy _ap_/_rg_ group tag. */
        key: "_normalizeFabricValue",
        value: function _normalizeFabricValue(value) {
          const v = String(value || "");
          if (v === "aerolite-plus" || v === "signature") return v;
          if (v === "ap" || v.includes("_ap_")) return "aerolite-plus";
          return "signature";
        },
      },
      {
        key: "swapColorDotsToFabric",
        value: async function swapColorDotsToFabric(
          target,
          currentProductId,
          currentColorDotTag,
        ) {
          const fabricHandle = this._normalizeFabricValue(target);
          await this._swapDotsByAxis(
            "fabric",
            fabricHandle,
            currentProductId,
            currentColorDotTag,
          );
          const colorDotsWrapper = document.querySelector(
            ".ProductForm__Option--ColorDots",
          );
          if (colorDotsWrapper) {
            colorDotsWrapper.dataset.fabric =
              fabricHandle === "aerolite-plus" ? "ap" : "rg";
          }
        },
      },
      {
        /**
         * A support-level change is a product change, so it runs through the
         * same path a colour-dot click uses: _selectClosestColorDot picks the
         * sibling, which swaps [data-section="product-data-section"] — the
         * gallery, price, title, accordions and pack selector all live inside
         * it. Firm and Extra Firm are separate templates, so when the sibling
         * is on another template _updateProductPageContent also swaps the
         * below-the-fold sections (see _applyTemplateChange). No page load.
         */
        key: "swapColorDotsToSupportLevel",
        value: async function swapColorDotsToSupportLevel(
          targetHandle,
          currentProductId,
          currentColorDotTag,
        ) {
          const handle = String(targetHandle || "");
          if (!handle) return;

          const section = document.querySelector(".support-level-section");
          if (section) section.dataset.currentSupportLevel = handle;

          // The old price stays on screen while the sibling is fetched and
          // would otherwise read as current. The section swap replaces these
          // nodes outright, so the state clears itself; the timeout only covers
          // a swap that never lands.
          const scope =
            (this.element && this.element.isConnected
              ? this.element.closest('[data-section="product-data-section"]')
              : null) ||
            document.querySelector('[data-section="product-data-section"]') ||
            document;
          const pendingEls = [
            scope.querySelector(".ProductMeta__PriceList"),
            scope.querySelector(".ProductMeta__Title"),
          ].filter(Boolean);
          pendingEls.forEach((el) => {
            el.setAttribute("aria-busy", "true");
            el.classList.add("is-swapping");
          });
          setTimeout(() => {
            pendingEls.forEach((el) => {
              el.removeAttribute("aria-busy");
              el.classList.remove("is-swapping");
            });
          }, 8000);

          await this._swapDotsByAxis(
            "supportLevel",
            handle,
            currentProductId,
            currentColorDotTag,
          );
        },
      },
      {
        key: "_onDotChanged",
        value: function _onDotChanged(previousDot, newDot) {
          this._updatePageContent(newDot, previousDot);
        },
      },
      {
        /**
         * Select the best-matching color dot in `colorDotWrap` relative to
         * the previous selection described by `currentDotInfo`.
         *
         * Priority:
         *  1. Exact color-name match (from color-dot-* tag) against data-product-colors
         *  2. Partial / fuzzy color-name match
         *  3. Product title keyword match
         *  4. Canvas image-color proximity (average RGB, perceptual distance)
         *  5. First available dot
         */
        key: "_selectClosestColorDot",
        value: async function _selectClosestColorDot(colorDotWrap, currentDotInfo) {
          // Only dots currently visible for the selected fabric / support level
          // are candidates — _swapDotsByAxis hides the rest with display:none.
          const inputs = Array.from(colorDotWrap.querySelectorAll(".color-dot-col"))
            .filter((col) => col.style.display !== "none")
            .map((col) => col.querySelector("input"))
            .filter(Boolean);
          if (!inputs.length) return;

          // Size-sticky fabric swap: the customer's chosen size must be preserved
          // across a fabric switch. Restrict colour candidates to products that
          // actually offer that size — so when the current colour isn't made in
          // that size, we change the COLOUR (to the first one available in the
          // size) instead of bumping the size. If no colour in this fabric offers
          // the size at all, fall back to the full list so a product still loads.
          let candidateInputs = inputs;
          const stickySize = sessionStorage.getItem("product-selected-size");
          if (stickySize && Array.isArray(window.groupedProducts) && window.groupedProducts.length) {
            const availableInSize = inputs.filter((inp) => {
              const product = window.groupedProducts.find(
                (p) => p.details.id == Number(inp.dataset.productId),
              );
              if (!product) return true; // unknown product — don't exclude
              return this._isColorAvailableForSize(product, stickySize);
            });
            if (availableInSize.length) candidateInputs = availableInSize;
          }

          const checkAndLabel = (input) => {
            inputs.forEach((i) => { i.checked = false; });
            input.checked = true;
            // Mark the dispatch as programmatic so _onClickDot does not clear
            // lastAxisColorSelection (which was just set by _swapDotsByAxis).
            this._swapping = true;
            input.dispatchEvent(new InputEvent("change", { bubbles: true }));
            this._swapping = false;
            // Write into the value span, not the whole label — the label also
            // carries the "Color:" prefix, and overwriting it dropped the prefix
            // on every fabric / support-level swap. Falls back to the label for
            // markup that predates the inner span.
            const nameEl =
              document.querySelector(".js-color-name-value") ||
              document.querySelector(".js-color-name");
            if (nameEl && input.dataset.productTitle) {
              const parts = input.dataset.productTitle.split(/ [-–] /);
              nameEl.textContent =
                parts.length > 1 ? parts[parts.length - 1] : input.dataset.productTitle;
            }
          };

          if (!currentDotInfo?.productTitle && !currentDotInfo?.productColors?.length) {
            checkAndLabel(candidateInputs[0]);
            return;
          }

          // Strategy 1: first-word-of-title match.
          // Both fabrics put the canonical set/color name as the first whitespace-
          // separated token of the title:
          //   AP:  "Atrium Aerolite+- 3 Pack"  →  "atrium"
          //   Sig: "Atrium - 3 Pack"           →  "atrium"
          // This is the only reliable pairing signal across fabrics for 3-packs,
          // because data-product-colors describes bundle tones (inconsistent) rather
          // than the set identity.
          const firstWord = (title) =>
            (title || "").trim().toLowerCase().split(/\s+/)[0] || "";
          const myFirstWord = firstWord(currentDotInfo.productTitle);
          if (myFirstWord) {
            const match = candidateInputs.find(
              (inp) => firstWord(inp.dataset.productTitle) === myFirstWord,
            );
            if (match) { checkAndLabel(match); return; }
          }

          // Strategy 2: exact match against data-product-colors.
          // Demoted from Strategy 1 because for 3-packs the metafield holds bundle
          // tones, not pair identity — e.g. AP/Atrium=["black","gray","blue"] vs
          // Sig/Atrium=[]. Still useful for 1-packs where each product is one colour.
          const needle = (
            (currentDotInfo.productColors && currentDotInfo.productColors[0]) ||
            ""
          ).toLowerCase();
          if (needle) {
            const exact = candidateInputs.find((inp) =>
              (inp.dataset.productColors || "")
                .split(",")
                .some((c) => c.trim() === needle),
            );
            if (exact) { checkAndLabel(exact); return; }
          }

          // Strategy 3: partial / fuzzy color-name match against data-product-colors.
          // Empty entries are dropped first: a product with no colour metafield
          // splits to [""], and needle.includes("") is always true, so it would
          // "match" every colour and short-circuit Strategy 4 onto the first dot.
          if (needle) {
            const fuzzy = candidateInputs.find((inp) => {
              const colors = (inp.dataset.productColors || "")
                .split(",")
                .map((c) => c.trim())
                .filter(Boolean);
              return colors.some((c) => c.includes(needle) || needle.includes(c));
            });
            if (fuzzy) { checkAndLabel(fuzzy); return; }
          }


          // Strategy 4: canvas image-color proximity
          if (currentDotInfo.imageUrl) {
            try {
              const currentRgb = await this._getAverageImageColor(currentDotInfo.imageUrl);
              // console.log("Current RGB:", currentRgb);
              if (currentRgb) {
                const scored = await Promise.all(
                  candidateInputs.map(async (inp) => {
                    const lbl = colorDotWrap.querySelector(`label[for="${inp.id}"]`);
                    if (!lbl?.style.backgroundImage) return { input: inp, dist: Infinity };
                    const url = lbl.style.backgroundImage
                      .replace(/url\(["']?/, "")
                      .replace(/["']?\)/, "");
                    const rgb = await this._getAverageImageColor(url);
                    return { input: inp, dist: rgb ? this._colorDistance(currentRgb, rgb) : Infinity };
                  }),
                );
                scored.sort((a, b) => a.dist - b.dist);
                if (scored[0].dist < Infinity) { checkAndLabel(scored[0].input); return; }
              }
            } catch (e) {
              console.warn("[PDP] Image color proximity failed:", e);
            }
          }

          
          // Fallback: first colour available in the customer's size (or first
          // colour overall when no size is set / the size is sold out everywhere).
          checkAndLabel(candidateInputs[0]);
        },
      },
      {
        key: "_getAverageImageColor",
        value: async function _getAverageImageColor(url) {
          if (!url) return null;
          // Normalise protocol-relative URLs (//cdn...) → https://cdn...
          const src = url.startsWith("//") ? "https:" + url : url;
          // P5: Return from instance cache — avoids re-decoding the same PNG on
          // every fabric switch or Strategy 4 comparison run.
          if (this._rgbCache.has(src)) return this._rgbCache.get(src);
          try {
            // fetch() shares the HTTP cache with CSS background-image loads —
            // no network round-trip for already-rendered color dot images.
            const blob = await fetch(src).then((r) => r.blob());
            // Decode without resizing — we draw to a 16×16 canvas ourselves so
            // we can skip transparent pixels (the dot circle sits on a transparent
            // background; resizing to 1×1 would dilute alpha below the 128 threshold
            // and return null for every dot).
            const bmp = await createImageBitmap(blob);
            const size = 16;
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(bmp, 0, 0, size, size);
            bmp.close();
            const data = ctx.getImageData(0, 0, size, size).data;
            let r = 0, g = 0, b = 0, count = 0;
            for (let i = 0; i < data.length; i += 4) {
              if (data[i + 3] > 128) {
                r += data[i]; g += data[i + 1]; b += data[i + 2]; count++;
              }
            }
            const result = count > 0 ? { r: r / count, g: g / count, b: b / count } : null;
            this._rgbCache.set(src, result);
            return result;
          } catch (_e) {
            return null;
          }
        },
      },
      {
        /** Perceptual weighted Euclidean distance in RGB (R×2, G×4, B×3). */
        key: "_colorDistance",
        value: function _colorDistance(a, b) {
          const dr = a.r - b.r, dg = a.g - b.g, db = a.b - b.b;
          return Math.sqrt(2 * dr * dr + 4 * dg * dg + 3 * db * db);
        },
      },
      {
        key: "_updatePageContent",
        value: function _updatePageContent(newDot, previousDot) {
          if (previousDot && previousDot.id === newDot.id) {
            return;
          }
          if (
            this.element.dataset.sectionType &&
            this.element.dataset.sectionType === "featured-product"
          ) {
            this._updateFeaturedProductPageContent();
          } else {
            this._updateProductPageContent(newDot, previousDot);
          }
        },
      },
      {
        key: "_updateProductPageContent",
        value: async function _updateProductPageContent(newDot, previousDot) {
          const productId = Number(newDot.id);
          const selector = this.element.closest(
            '[data-section="product-data-section"]',
          );

          // Early return if selector not found
          if (!selector) {
            console.warn("Product section selector not found");
            return;
          }

          // P3: Stale-update guard — capture the sequence number at the start of
          // this call. After every await we check if a newer call has started; if
          // so we bail silently to avoid overwriting fresher content.
          const seq = ++this._updateSeq;

          try {
            // P4: Resolve all data synchronously from in-memory globals first.
            // On a warm cache (every click after the first page load) this skips
            // all async barriers and goes straight to DOM work.
            let relatedProduct =
              window.relatedProductsData?.[productId] || null;
            let currentProductGroupTag =
              window.currentProductGroupTag || null;
            let groupedProducts = window.groupedProducts || null;

            // Only hit async paths if any value was missing from memory
            if (!relatedProduct) {
              relatedProduct = this._getRelatedProductData(productId);
            }
            if (!currentProductGroupTag) {
              currentProductGroupTag = this._getProductGroupTag();
            }
            if (!groupedProducts) {
              groupedProducts = this._getGroupedProducts();
              if (this._updateSeq !== seq) return;
            }

            // Decided up front: _applyTemplateChange moves PDP_TEMPLATE_SUFFIX
            // on, so this can't be recomputed once the DOM has been swapped.
            const crossTemplate = this._isCrossTemplate(newDot.templateSuffix);

            // Get product markup (from cache or fetch)
            const {
              productSectionMarkup,
              reviewSectionMarkup,
              pageSections,
              markupExisted,
            } = await this._getProductMarkup(
              relatedProduct,
              newDot.handle,
              productId,
              selector,
              newDot.templateSuffix,
              crossTemplate,
            );
            if (this._updateSeq !== seq) return;

            // A product on another template needs that template's sections too.
            // Without them the swap would leave the old template's below-fold
            // sections on screen, so bail to the full page load (the catch
            // below) before touching the DOM rather than half-apply it.
            if (crossTemplate && productSectionMarkup && !pageSections) {
              throw new Error(
                "Page sections for the target template were not found",
              );
            }

            // Update DOM if we have valid markup
            let staleSectionId = null;
            if (productSectionMarkup) {
              // Read before the swap: the section id names the template the
              // markup came from, and the running instance is registered under it.
              const previousSectionId =
                selector.querySelector('[data-section-type="product"]')
                  ?.dataset.sectionId || null;

              await this._updateDOMContent(
                selector,
                productSectionMarkup,
                reviewSectionMarkup,
                groupedProducts,
                productId,
              );
              if (this._updateSeq !== seq) return;

              if (crossTemplate) {
                this._applyTemplateChange(
                  selector,
                  pageSections,
                  newDot.templateSuffix,
                );
                // The instance still running is registered under the old
                // template's id; the reload below only knows the new one.
                staleSectionId = previousSectionId;
              }
              // Re-attach fabric technology listeners — _updateDOMContent replaces
              // selector.innerHTML which destroys the old DOM nodes and their listeners
              if (typeof window.initFabricTechnology === 'function') {
                window.initFabricTechnology();
              }
              if (typeof window.initSupportLevelTechnology === 'function') {
                window.initSupportLevelTechnology();
              }
              // The fetched page carries its own server-rendered dots, so the
              // in-memory dot index has to be rebuilt from them.
              window.groupedProducts = this._initDotsFromDOM();
            }

            // Cache and store in background (non-blocking)
            if (!markupExisted) {
              this._cacheProductData(
                productId,
                productSectionMarkup,
                reviewSectionMarkup,
                pageSections,
              );
            }

            // Dispatch events. After a template change the recommendations
            // section arrived as part of the swapped-in sections and has
            // already been started by its section:load, so asking for a
            // reload as well would fetch the recommendations twice.
            this._dispatchUpdateEvents(newDot, previousDot, {
              reloadRecommendations: !crossTemplate,
              staleSectionId,
            });
          } catch (error) {
            if (this._updateSeq !== seq) return; // stale — ignore error too
            console.error("Error updating product page content:", error);
            // Fallback: reload page if critical error occurs
            window.location.href = `/products/${newDot.handle}`;
          }
        },
      },
      {
        key: "_getRelatedProductData",
        value: function _getRelatedProductData(productId) {
          // In-memory only. The IndexedDB warm cache is gone — _getProductMarkup
          // fetches the product page on demand when nothing is cached yet.
          if (window.relatedProductsData?.[productId]?.productHTML) {
            return window.relatedProductsData[productId];
          }
          return {};
        },
      },
      {
        key: "_getProductGroupTag",
        value: function _getProductGroupTag() {
          return window.currentProductGroupTag || null;
        },
      },
      {
        key: "_getGroupedProducts",
        value: function _getGroupedProducts() {
          if (window.groupedProducts) return window.groupedProducts;
          window.groupedProducts = this._initDotsFromDOM();
          return window.groupedProducts;
        },
      },
      {
        key: "_getProductMarkup",
        value: async function _getProductMarkup(
          relatedProduct,
          handle,
          productId,
          selector,
          targetTemplateSuffix,
          needPageSections,
        ) {
          let productSectionMarkup = relatedProduct?.productHTML;
          let reviewSectionMarkup = relatedProduct?.reviewHTML;
          let pageSections = relatedProduct?.pageSections || null;
          let markupExisted = true;

          // A cached product that was fetched through the sections shortcut has
          // no page sections stored. When they are needed (template change) it
          // has to be fetched again as a full page.
          if (productSectionMarkup && needPageSections && !pageSections) {
            productSectionMarkup = null;
          }

          // If markup doesn't exist, fetch from server
          if (!productSectionMarkup) {
            markupExisted = false;

            // Show loading state on images
            const images = selector.querySelectorAll(".Product__SlideItem img");
            images.forEach((img) => {
              img.classList.remove("Image--lazyLoad", "Image--lazyLoaded");
              img.classList.add("Image--lazyLoading");
            });

            try {
              const parseHtml = (text) =>
                new DOMParser().parseFromString(text, "text/html");
              const pick = (doc) => ({
                product:
                  doc.querySelector(
                    `section[data-section-type="product"][data-product-id="${productId}"]`,
                  )?.outerHTML || null,
                review: doc.querySelector("#yotpo-main-widget")?.outerHTML || null,
                pageSections: this._extractPageSections(doc, productId),
              });

              let found = null;

              // Ask for just the two sections we read instead of the whole page
              // (~795KB vs ~315KB). Both come back in one request as JSON keyed
              // by section id.
              //
              // Only safe when the target product uses the template this page
              // was rendered from. The section id names THIS template, and
              // Shopify does not refuse it for a product on another template:
              // it renders the target product inside this template's section,
              // with this template's gallery blocks, description and accordion
              // settings. The product id still matches, so the check below
              // cannot catch it. Unknown target template -> full page, which
              // always renders the product with its own template.
              const pageTemplate = window.PDP_TEMPLATE_SUFFIX;
              const sameTemplate =
                !needPageSections &&
                typeof pageTemplate === "string" &&
                typeof targetTemplateSuffix === "string" &&
                targetTemplateSuffix === pageTemplate;
              const productSectionId = sameTemplate
                ? selector.querySelector(
                    '[data-section-type="product"][data-section-id]',
                  )?.dataset.sectionId
                : null;
              const reviewSectionId =
                document
                  .querySelector("#yotpo-main-widget")
                  ?.closest('[id^="shopify-section-"]')
                  ?.id.replace("shopify-section-", "") || "product-reviews";

              if (productSectionId) {
                const ids = [productSectionId, reviewSectionId].join(",");
                const res = await fetch(
                  `/products/${handle}?sections=${encodeURIComponent(ids)}`,
                );
                if (res.ok) {
                  let payload = null;
                  try {
                    payload = await res.json();
                  } catch (_e) {
                    payload = null;
                  }
                  if (payload) {
                    const productHtml = payload[productSectionId];
                    const reviewHtml = payload[reviewSectionId];
                    const candidate = productHtml ? pick(parseHtml(productHtml)) : null;
                    // A section id that doesn't exist on the target's template
                    // comes back as null, and a mismatched product renders a
                    // section without this product id — treat both as a miss.
                    if (candidate?.product) {
                      found = {
                        product: candidate.product,
                        review: reviewHtml
                          ? parseHtml(reviewHtml).querySelector("#yotpo-main-widget")
                              ?.outerHTML || null
                          : null,
                      };
                    }
                  }
                }
              }

              if (!found) {
                const response = await fetch(`/products/${handle}`);
                const text = await response.text();
                found = pick(parseHtml(text));
              }

              productSectionMarkup = found.product;
              reviewSectionMarkup = found.review;
              pageSections = found.pageSections || null;
            } catch (error) {
              console.error("Failed to fetch product markup:", error);
              throw error;
            }
          }

          return {
            productSectionMarkup,
            reviewSectionMarkup,
            pageSections,
            markupExisted,
          };
        },
      },
      {
        key: "_updateDOMContent",
        value: async function _updateDOMContent(
          selector,
          productSectionMarkup,
          reviewSectionMarkup,
          groupedProducts,
          productId,
        ) {
          // Create temporary containers for manipulation
          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = productSectionMarkup;

          // Sticky size from the previous product — may not exist on the new color.
          const requestedSize =
            sessionStorage.getItem("product-selected-size") ||
            $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();

          // Resolve size first so color-dot availability matches what the shopper
          // will actually see (fallback size when the sticky size is OOS).
          const finalSelectedSize = this._updateSizeSelection(
            tempContainer,
            requestedSize,
          );
          if (finalSelectedSize) {
            sessionStorage.setItem("product-selected-size", finalSelectedSize);
          }

          // Update color dots if markup exists — use the resolved size, not the
          // pre-fallback sticky size (otherwise unavailable-for-size sticks after
          // clicking a size-unavailable color that then falls back to another size).
          this._updateColorDots(
            tempContainer,
            groupedProducts,
            finalSelectedSize || requestedSize,
            productId,
          );

          // PERFORMANCE FIX 3: Batch DOM update (single reflow)
          selector.innerHTML = tempContainer.innerHTML;

          // Update reviews section if needed. The widget normally sits in the
          // layout-level product-reviews section, outside this block, so look
          // for it page-wide; the in-block lookup stays for templates that
          // render it inside the product section.
          if (reviewSectionMarkup) {
            const yotpoMainWidget =
              selector.querySelector(".yotpo-main-widget") ||
              document.querySelector("#yotpo-main-widget");
            if (yotpoMainWidget) {
              yotpoMainWidget.outerHTML = reviewSectionMarkup;
            }
          }

          // P11: Re-init Yotpo after the DOM has been fully replaced so rating
          // widgets re-attach to the new nodes, and the reviews widget (new,
          // empty, with the new product id) renders that product's reviews.
          refreshYotpoWidgets();
        },
      },
      {
        /**
         * Applies availability + checked state to the color dots the fetched
         * product page already server-rendered. There is no cached markup blob to
         * inject any more — the fetched page's own `.color-dot-wrap` is
         * authoritative, including which dots its fabric/support level hides.
         */
        key: "_updateColorDots",
        value: function _updateColorDots(
          tempContainer,
          groupedProducts,
          selectedSize,
          productId,
        ) {
          const colorDotWrap = tempContainer.querySelector(".color-dot-wrap");
          if (!colorDotWrap) return;

          colorDotWrap.querySelectorAll(".color-dot-col").forEach((colorDot) => {
            const dotInput = colorDot.querySelector("input");
            const dotLabel = colorDot.querySelector("label");
            if (!dotInput || !dotLabel) return;
            const dotProductId = Number(dotInput.dataset.productId);

            const matchedProduct = (groupedProducts || []).find(
              (p) => p.details.id == dotProductId,
            );
            if (matchedProduct) {
              this._applyColorDotAvailability(
                dotInput,
                dotLabel,
                matchedProduct,
                selectedSize,
              );
            }

            if (dotProductId == productId) {
              dotInput.setAttribute("checked", "checked");
            } else {
              dotInput.removeAttribute("checked");
            }
          });
        },
      },
      {
        key: "_updateSizeSelection",
        value: function _updateSizeSelection(tempContainer, selectedSize) {
          const sizeMap = window.themeVariables.sizeMap;
          const sizeInputs = tempContainer.querySelectorAll(
            ".ProductForm__Option .SizeSwatchList input",
          );

          let selected = false;
          let finalSelectedSize = selectedSize;

          // First pass: try to select the requested size
          sizeInputs.forEach((inputButton) => {
            inputButton.removeAttribute("checked");

            if (
              !selected &&
              selectedSize === inputButton.value &&
              !inputButton.disabled
            ) {
              inputButton.setAttribute("checked", "checked");
              selected = true;
            }
          });

          // If requested size wasn't available, select first available
          if (!selected) {
            for (const inputButton of sizeInputs) {
              if (!inputButton.disabled) {
                inputButton.setAttribute("checked", "checked");
                finalSelectedSize = inputButton.value;
                break;
              }
            }
          }

          // Update size label
          const sizeLabel = sizeMap[finalSelectedSize] || finalSelectedSize;
          const sizeLabelElement = tempContainer.querySelector(
            '.ProductForm__Option--labelled[data-option-name="size"] .ProductForm__Label .ProductForm__SelectedValue',
          );

          if (sizeLabelElement) {
            sizeLabelElement.innerHTML = sizeLabel;
          }

          return finalSelectedSize;
        },
      },
      {
        key: "_cacheProductData",
        value: function _cacheProductData(
          productId,
          productSectionMarkup,
          reviewSectionMarkup,
          pageSections,
        ) {
          // Cache in memory immediately (synchronous)
          if (!window.relatedProductsData) {
            window.relatedProductsData = {};
          }
          window.relatedProductsData[productId] = {
            id: productId,
            productHTML: productSectionMarkup,
            reviewHTML: reviewSectionMarkup,
            // Only present when the markup came from a full page fetch
            pageSections: pageSections || null,
          };

          // Memory-only: this warm cache is not persisted any more. Losing it on
          // navigation just means the next colour-dot click re-fetches that
          // product page, which is the same cost as a cold first visit.
        },
      },
      {
        key: "_dispatchUpdateEvents",
        value: function _dispatchUpdateEvents(newDot, previousDot, options = {}) {
          const { reloadRecommendations = true, staleSectionId = null } =
            options;

          // After a template change the running product section is registered
          // under the previous template's id, which the reload below can't see.
          if (staleSectionId) {
            document.dispatchEvent(
              new CustomEvent("shopify:section:unload", {
                detail: { sectionId: staleSectionId },
              }),
            );
          }

          // Dispatch color-dot:changed event
          document.dispatchEvent(
            new CustomEvent("color-dot:changed", {
              bubbles: true,
              cancelable: true,
              detail: { newDot, previousDot },
            }),
          );

          // Dispatch section reload event
          document.dispatchEvent(
            new CustomEvent("shopify:section:reload", {
              detail: {
                sections: reloadRecommendations
                  ? [
                      "product",
                      "product-recommendations",
                      "recently-viewed-products",
                    ]
                  : ["product"],
              },
            }),
          );
        },
      },
      {
        key: "_updateFeaturedProductPageContent",
        value: function _updateFeaturedProductPageContent() {
          var currentEl = this.element.querySelector(
            `#product-dot-${this.currentDot.id}`,
          );
          var data = currentEl.dataset;
          var jsonDataEl = this.element.querySelector("[data-product-json]");
          var jsonProductUrlEl = this.element.querySelector(
            'a[data-product-section="yotpo-reviews"]',
          );
          var imageEl = this.element.querySelector(".AspectRatio img");
          var titleEl = this.element.querySelector(
            ".ProductMeta__Title.Heading a",
          );
          var selectEl = this.element.querySelector('select[title="Variant"]');
          var current = JSON.parse(data.productJson);
          var jsonData = JSON.parse(jsonDataEl.innerHTML);

          jsonData.product = current;
          jsonDataEl.innerHTML = JSON.stringify(jsonData);
          titleEl.setAttribute("href", data.productUrl);
          titleEl.innerHTML = current.title.includes(" - ")
            ? current.title.split(" - ")[0]
            : current.title;
          current.variants.forEach(function (variant) {
            var option = selectEl.querySelector(
              `option[data-title="${variant.title}"]`,
            );
            option.value = variant.id;
            option.dataset.sku = variant.sku;
            option.dataset.title = variant.title;
            option.innerHTML = `${variant.title} - $${variant.price / 100}`;
          });
          const featuredImage = current.featured_image;
          const widths = imageEl.dataset.widths
            .replace(/\[|\]/g, "")
            .split(",");
          const filesPrefix =
            featuredImage.indexOf("/products/") !== -1 ? "products" : "files";
          const name = featuredImage.match(`/${filesPrefix}/.*?\.`)[0];
          const srcset = widths
            .map(function (width) {
              const modifiedName = name.replace(".", "");
              return (
                featuredImage.replace(
                  `/${filesPrefix}/.*?\.`,
                  `${modifiedName}_${width}x.`,
                ) + ` ${width}w`
              );
            })
            .join(", ");
          imageEl.setAttribute("srcset", srcset);
          imageEl.dataset.srcset = srcset;
          imageEl.alt = `${current.title} image`;
        },
      },
      {
        key: "_updateRecommendedProducts",
        value: function _updateRecommendedProducts(newDot) {
          if (!newDot) {
            return;
          }
          var unitPriceMeasurement = this.element.querySelector(
            ".ProductMeta__UnitPriceMeasurement",
          );
          if (!unitPriceMeasurement) {
            return;
          }
          if (!newDot.hasOwnProperty("unit_price")) {
            unitPriceMeasurement.style.display = "none";
            return;
          }
          unitPriceMeasurement.style.display = "block";
          unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__Price",
          ).innerHTML = Currency.formatMoney(
            newDot.unit_price,
            window.theme.moneyFormat,
          );
          unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__ReferenceUnit",
          ).textContent = newDot.unit_price_measurement.reference_unit;
          var unitPriceReferenceValue = unitPriceMeasurement.querySelector(
            ".UnitPriceMeasurement__ReferenceValue",
          );
          unitPriceReferenceValue.textContent =
            newDot.unit_price_measurement.reference_value;
          unitPriceReferenceValue.style.display =
            newDot.unit_price_measurement.reference_value === 1
              ? "none"
              : "inline";
        },
      },
      {
        key: "_updatePreviouslyViewed",
        value: function _updatePreviouslyViewed(newDot) {
          var addToCartButton = this.element.querySelector(
              ".ProductForm__AddToCart",
            ),
            shopifyPaymentButton = this.element.querySelector(
              ".shopify-payment-button",
            );
          if (addToCartButton) {
            addToCartButton.classList.remove("Button--secondary");
            addToCartButton.classList.remove("Button--primary");
            if (!newDot) {
              addToCartButton.setAttribute("disabled", "disabled");
              addToCartButton.removeAttribute("data-action");
              addToCartButton.classList.add("Button--secondary");
              addToCartButton.innerHTML =
                window.languages.productFormUnavailable;
            } else {
              if (newDot.available) {
                addToCartButton.removeAttribute("disabled");
                addToCartButton.classList.add(
                  addToCartButton.getAttribute("data-use-primary-button") ===
                    "true"
                    ? "Button--primary"
                    : "Button--secondary",
                );
                addToCartButton.setAttribute("data-action", "add-to-cart");
                if (
                  undefined === this.options.showPriceInButton ||
                  this.options.showPriceInButton
                ) {
                  addToCartButton.innerHTML = "\n            <span>"
                    .concat(
                      window.languages.productFormAddToCart,
                      '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>',
                    )
                    .concat(
                      Currency.formatMoney(
                        newDot.price,
                        window.theme.moneyFormat,
                      ),
                      "</span>\n          ",
                    );
                } else {
                  addToCartButton.innerHTML = "<span>".concat(
                    window.languages.productFormAddToCart,
                    "</span>",
                  );
                }
              } else {
                addToCartButton.setAttribute("disabled", "disabled");
                addToCartButton.classList.add("Button--secondary");
                addToCartButton.removeAttribute("data-action");
                addToCartButton.innerHTML = window.languages.productFormSoldOut;
              }
            }
          }
          if (this.options.showPaymentButton && shopifyPaymentButton) {
            if (!newDot || !newDot.available) {
              shopifyPaymentButton.style.display = "none";
            } else {
              shopifyPaymentButton.style.display = "block";
            }
          }
        },
      },
      {
        key: "_onClickDot",
        value: function _onClickDot(newValue, target) {
          var data = target.dataset;
          var previousDot = this.currentDot;
          this.currentDot = {
            id: data.productId,
            handle: data.productHandle,
            url: data.productUrl,
            // undefined when the dot predates data-template-suffix
            templateSuffix: data.templateSuffix,
          };
          // User manually picked a color dot — clear the saved per-axis selections
          // so the next fabric / support-level switch re-runs the colour-matching
          // strategies fresh instead of restoring a stale saved dot. Skip when the
          // change was dispatched programmatically by _selectClosestColorDot
          // (this._swapping === true), which would otherwise immediately erase the
          // selection _swapDotsByAxis just saved.
          if (!this._swapping) {
            window.lastAxisColorSelection = {};
          }

          if (
            this.element.dataset.sectionType &&
            this.element.dataset.sectionType === "featured-product"
          ) {
            var productPacks = data.productPacks
              ? JSON.parse(data.productPacks)
              : {};

            var packsInventoryJson = data.packsInventoryJson
              ? JSON.parse(data.packsInventoryJson)
              : {};
            var productPackEls = $('.pack-variant-options [type="radio"]');

            productPackEls.each(function () {
              const packName = $(this).val();
              if (!productPacks[packName]) {
                $(this).parent().hide();
              } else {
                $(this).attr(
                  "data-product",
                  JSON.stringify(productPacks[packName]),
                );
                if (packsInventoryJson[packName]) {
                  $(this).attr(
                    "data-inventory-json",
                    JSON.stringify(packsInventoryJson[packName]),
                  );
                }
                $(this).parent().show();
              }
            });
            sessionStorage.setItem(
              "productPacks",
              JSON.stringify(productPacks),
            );
            sessionStorage.setItem(
              "packsInventoryJson",
              JSON.stringify(packsInventoryJson),
            );
            this.selectedPack = sessionStorage.getItem("selectedPack");
            if (this.selectedPack) {
              var selectedPackEl = this.element.querySelector(
                `.pack-variant-options input[value="${this.selectedPack}"]`,
              );
              if (!selectedPackEl) {
                return sessionStorage.removeItem("selectedPack");
              }
              selectedPackEl.dispatchEvent(
                new Event("change", { bubbles: !0 }),
              );
              selectedPackEl.dispatchEvent(new Event("click", { bubbles: !0 }));
              selectedPackEl.setAttribute("checked", "checked");
              this.selectedPackEl = null;
            }
            if (Object.keys(productPacks).length <= 1) {
              $(".pack-variant-options").hide();
            } else {
              $(".pack-variant-options").show();
            }
          }

          this._onDotChanged(previousDot, this.currentDot);
          if (this.currentDot) {
            if (this.options.enableHistoryState) {
              this._updateHistoryState(this.currentDot);
            }
          }
        },
      },
      {
        /**
         * True when swapping to a product on `targetSuffix` means changing
         * template: a Firm / Extra Firm support level or the Aerolite+ fabric
         * have their own gallery blocks, description, accordions and
         * below-the-fold sections. '' and a missing suffix both mean the default
         * product.json. Either side unknown (the featured product section, a dot
         * without data-template-suffix, a page without PDP_TEMPLATE_SUFFIX)
         * means false, i.e. the existing same-template swap.
         */
        key: "_isCrossTemplate",
        value: function _isCrossTemplate(targetSuffix) {
          if (this.element.dataset.sectionType === "featured-product") {
            return false;
          }
          const pageTemplate = window.PDP_TEMPLATE_SUFFIX;
          if (typeof pageTemplate !== "string") return false;
          if (typeof targetSuffix !== "string") return false;
          return targetSuffix !== pageTemplate;
        },
      },
      {
        /**
         * Pull the template's own sections out of a full product page: every
         * section inside <main> other than the one holding the product. Returns
         * the new main wrapper id plus the markup of the others, in order, with
         * their ids intact — each section's scoped <style> rules target its own
         * "#shopify-section-<id>", so the wrapper has to arrive with it.
         */
        key: "_extractPageSections",
        value: function _extractPageSections(doc, productId) {
          const productEl = doc.querySelector(
            `section[data-section-type="product"][data-product-id="${productId}"]`,
          );
          const mainWrapper = productEl?.closest(".shopify-section");
          const main = mainWrapper?.parentElement;
          if (!mainWrapper || !mainWrapper.id || !main) return null;

          const sections = Array.from(main.children)
            .filter(
              (el) => el !== mainWrapper && el.classList.contains("shopify-section"),
            )
            .map((el) => el.outerHTML);

          return { mainWrapperId: mainWrapper.id, sections };
        },
      },
      {
        /**
         * Finish a template change after the product markup is in place:
         * rename the wrapper to the new template's section id (the product's
         * scoped <style> rules were written against it), replace the old
         * template's below-the-fold sections with the new one's, and move
         * PDP_TEMPLATE_SUFFIX on so the next swap compares against what is
         * actually on screen.
         */
        key: "_applyTemplateChange",
        value: function _applyTemplateChange(selector, pageSections, targetSuffix) {
          const mainWrapper = selector.closest(".shopify-section");
          const main = mainWrapper?.parentElement;
          if (!mainWrapper || !main) {
            throw new Error("Product section wrapper not found");
          }

          mainWrapper.id = pageSections.mainWrapperId;

          // Old below-the-fold sections: stop their instances, then remove
          Array.from(main.children)
            .filter(
              (el) =>
                el !== mainWrapper && el.classList.contains("shopify-section"),
            )
            .forEach((el) => {
              el.querySelectorAll("[data-section-id]").forEach((node) => {
                document.dispatchEvent(
                  new CustomEvent("shopify:section:unload", {
                    detail: { sectionId: node.dataset.sectionId },
                  }),
                );
              });
              el.remove();
            });

          // New ones, in order, straight after the product
          const tpl = document.createElement("template");
          tpl.innerHTML = pageSections.sections.join("");
          const inserted = Array.from(tpl.content.children);
          let anchor = mainWrapper;
          inserted.forEach((el) => {
            anchor.after(el);
            anchor = el;
          });

          // Start them the way the theme editor does
          inserted.forEach((el) => {
            el.dispatchEvent(
              new CustomEvent("shopify:section:load", {
                bubbles: true,
                detail: { sectionId: el.id.replace("shopify-section-", "") },
              }),
            );
          });

          // Autoplay videos in the new sections are lazy: their observers
          // were set up once, on page load
          if (typeof window.initLazyAutoplayVideos === "function") {
            window.initLazyAutoplayVideos();
          }
          if (typeof window.initVideoPlayPause === "function") {
            window.initVideoPlayPause();
          }

          window.PDP_TEMPLATE_SUFFIX = targetSuffix;
        },
      },
      {
        key: "_updateHistoryState",
        value: function _updateHistoryState(product) {
          if (!history.replaceState) {
            return;
          }
          var newUrl = product.url;
          window.history.replaceState({ path: newUrl }, "", newUrl);
        },
      },
    ]);
    return ProductDots;
  })();

  var ProductSizes = (function () {
    function ProductSizes(container, options) {
      _classCallCheck(this, ProductSizes);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      this.selectedSize =
        sessionStorage.getItem("product-selected-size") ||
        $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();
      this._attachListeners();
    }
    _createClass(ProductSizes, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("change");
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "change",
            '.SizeSwatch__Radio.MainProduct[type="radio"][name="option-0"]',
            this._onSizeChange.bind(this),
          );
        },
      },
      {
        key: "_onSizeChange",
        value: function _onSizeChange(newValue, target) {
          if (target.closest(".Product__Wrapper--Byob")) {
            return;
          }

          this.selectedSize = target.value;
          sessionStorage.setItem("product-selected-size", this.selectedSize);

          // Color dots must not change when size is selected — only completely
          // OOS products (no available variant of any size) are ever shown as
          // disabled, and that state is set at render time.  Toggling dots per
          // size selection causes unwanted visual flicker and conflicts with the
          // CASCADE FIX principle (color dots reflect product-level OOS only).
          MarkdownPricePro.run({ overwriteOthers: true });
        },
      },
    ]);
    return ProductSizes;
  })();

  var ProductPacks = (function () {
    function ProductPacks(container, options) {
      _classCallCheck(this, ProductPacks);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      this.selectedSize =
        sessionStorage.getItem("product-selected-size") ||
        $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();
      this.selectedPack = sessionStorage.getItem("selectedPack");
      this._attachListeners();
      if (this.selectedPack) {
        var selectedPackEl = this.element.querySelector(
          `.pack-variant-options input[value="${this.selectedPack}"]:not([style*="display: none;"])`,
        );
        if (!selectedPackEl) return sessionStorage.removeItem("selectedPack");
        selectedPackEl.dispatchEvent(new Event("change", { bubbles: !0 }));
        selectedPackEl.dispatchEvent(new Event("click", { bubbles: !0 }));
        selectedPackEl.setAttribute("checked", "checked");
        this.selectedPackEl = null;
      }
    }
    _createClass(ProductPacks, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("change");
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "change",
            '.pack-variant-options [type="radio"]',
            this._onClickPack.bind(this),
          );
        },
      },
      {
        key: "_loadProductPacks",
        value: function _loadProductPacks() {
          let productPacks = {};
          const productPackEls = $('.pack-variant-options [type="radio"]');
          productPackEls.each(function () {
            const inventory_json = $(this).data("inventory-json");
            let data = $(this).data("product");
            data.inventory_json = inventory_json;
            const key = $(this).val();
            productPacks[key] = data;
          });
          sessionStorage.setItem("productPacks", JSON.stringify(productPacks));
        },
      },
      {
        key: "_getPackCount",
        value: function _getPackCount() {
          let productPack = 1;
          switch (this.selectedPack) {
            case "3_pack":
              productPack = 3;
              break;
            case "5_pack":
              productPack = 5;
              break;
          }

          return productPack;
        },
      },
      {
        key: "_onPackChanged",
        value: function _onPackChanged(previousPack, newPack) {
          var storedSize = sessionStorage.getItem("product-selected-size");
          var currentSizes = [];
          document
            .querySelectorAll('.SizeSwatch__Radio.MainProduct[type="radio"]')
            .forEach(function ($input) {
              currentSizes.push($input.value);
            });

          if (!currentSizes.includes(storedSize))
            sessionStorage.removeItem("product-selected-size");
          var selectedSize =
            sessionStorage.getItem("product-selected-size") ||
            $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();

          var selectedVariant =
            newPack.variants.find(function (variant) {
              return variant.title === selectedSize;
            }) || newPack.variants[0];

          const productPack = this._getPackCount();

          selectedVariant.product_pack = productPack;
          var previousVariant = previousPack
            ? previousPack.variants.find(function (variant) {
                return variant.title === selectedSize;
              })
            : null;

          if (previousVariant) previousVariant.product_pack = productPack;

          try {
            document.dispatchEvent(
              new CustomEvent("pdp:updated", {
                detail: { product: newPack, trigger: "pack_changed" },
              }),
            );
          } catch (error) {}

          this._updatePageContent(newPack, previousPack);
          this._updateProductPrices(selectedVariant, previousVariant);
        },
      },
      {
        key: "_updatePageContent",
        value: function _updatePageContent(newPack, previousPack) {
          // if (previousPack && previousPack.id === newPack.id) return;
          var productData = this.currentPack;

          const packSelect = $("select#pack-select");
          const productSelect = $('[id^="product-select-"]');

          // $(".pack-variant-options .ProductForm__SelectedValue").html(
          //   this.selectedPack.replace("_", " "),
          // );
          const $productMetaTitle = $(
            "form.ProductForm .ProductMeta .ProductMeta__Title.Heading",
          );
          // Only the pack suffix is replaced: the title itself is also made of
          // spans (a screen-reader copy and an aria-hidden visual copy).
          $productMetaTitle.find(".ProductMeta__TitlePack").remove();

          if (this.selectedPack !== "1_pack") {
            $productMetaTitle.append(
              `<span class="ProductMeta__TitlePack"> - ${this.selectedPack.replace("_", " ")}</span>`,
            );
          }

          const packCount = this._getPackCount();
          const productForm = document.querySelector(".ProductForm");
          let quantityInput = productForm.querySelector('[name="quantity"]');
          if (!quantityInput) {
            quantityInput = document.createElement("input");
            quantityInput.type = "hidden";
            quantityInput.name = "quantity";
            productForm.appendChild(quantityInput);
          }
          quantityInput.value = packCount;

          const productFormInputs = productForm.querySelector(
            "input[name='properties[_bundle_id]']",
          );
          if (productFormInputs) productFormInputs.remove();

          if (packCount > 1) {
            const uniqueId = Math.random().toString(36).substr(2, 9);
            productForm.insertAdjacentHTML(
              "beforeend",
              `<input type="hidden" name="properties[_bundle_id]" value="${uniqueId}">`,
            );
          }

          try {
            const selectedSize = $(this.element).find(
              ".SizeSwatch__Radio.MainProduct:checked",
            );
            if (selectedSize.prop("disabled")) {
              selectedSize.removeAttr("checked");
              const firstAvailableSize = $(this.element)
                .find(".SizeSwatch__Radio.MainProduct:not([disabled])")
                .first();
              firstAvailableSize.next("label").click();
              firstAvailableSize.attr("checked", !0).trigger("change");
              sessionStorage.setItem(
                "product-selected-size",
                firstAvailableSize.val(),
              );
              const firstAvailableVariant =
                firstAvailableSize.attr("data-variant-id");
              const selectReset = (elem) => {
                elem.find("option[selected]").removeAttr("selected");
                elem
                  .find(`option[value="${firstAvailableVariant}"]`)
                  .attr("selected", "selected");
                elem.val(firstAvailableVariant).trigger("change");
              };
              selectReset(productSelect);
              selectReset(packSelect);
            }
          } catch (error) {
            console.log(error);
          }

          const packDiscounts = {
            "5_pack": "Includes 10% pack savings",
          };
          const discountMessage = packDiscounts[this.selectedPack];
          
          $(".pack-discount-label").remove();
          if (discountMessage) {
            $(".ProductForm .ProductPriceReview").after(
              `<p class="pack-discount-label">${discountMessage}</p>`,
            );
          }
        },
      },
      {
        key: "_updateProductPrices",
        value: function _updateProductPrices(newVariant, previousVariant) {
          if (!newVariant) return;

          var productMetaPrices = this.element.querySelector(
            ".ProductMeta__PriceList",
          );
          if (!productMetaPrices) return;


          const discounts = {
            "5_pack": {
              percent_saving: {
                value: 10,
                type: "percentage",
              },
              default: {
                value: 10,
                type: "percentage",
              },
            },
          };

          let product_collections =
            productMetaPrices.getAttribute("data-collections");
          const product_pack = newVariant.product_pack || 1;

          var variantOriginalPrice = newVariant.price * product_pack;
          newVariant.price = newVariant.price * product_pack;
          newVariant.compare_at_price = newVariant.compare_at_price
            ? newVariant.compare_at_price * product_pack
            : 0;

          // Last Chance products get their own tiered markdown (25%/30% by
          // pack size, see MarkdownPricePro) instead of the standard 10%
          // 5-pack savings — the two shouldn't stack.
          const lastChanceCollections = [
            "last-chance-collection",
            "last-chance-sale",
            "july-4th-sale",
          ];
          const productCollectionList = (product_collections || "").split(",");
          const isLastChanceProduct = lastChanceCollections.some((coll) =>
            productCollectionList.includes(coll),
          );

          const discount = isLastChanceProduct
            ? {}
            : discounts[this.selectedPack] || {};
          const percentSavingTags = [
            "ankle-socks",
            "orbit-ankle-aerolite-plus",
            "aerolite-plus-collection",
            "midcalf",
          ];
          const discountValue =
            discount[
              percentSavingTags.some((tag) =>
                this.currentPack.tags.includes(tag),
              )
                ? "percent_saving"
                : "default"
            ] || {};
          const discountType = discountValue.type || "fixed";
          const discountAmount = discountValue.value || 0;

          if (discountType === "percentage") {
            newVariant.price = Math.floor(
              newVariant.price * (1 - discountAmount / 100),
            );
            newVariant.compare_at_price = Math.floor(variantOriginalPrice);
          } else if (discountType === "fixed") {
            newVariant.price = Math.floor(newVariant.price - discountAmount);
            newVariant.compare_at_price = Math.floor(variantOriginalPrice);
          }

          var selectedPackEl = this.element.querySelector(
            `.pack-variant-options input[value="${this.selectedPack}"]:not([style*="display: none;"])`,
          );
          if (selectedPackEl)
            product_collections = selectedPackEl.dataset.productCollections;
          let innerHTML = `<div class="pro-main-price" data-product-coll="${product_collections}" data-pack-size="${product_pack}" data-price="${newVariant.price}" data-compare-price="${newVariant.compare_at_price}" ${newVariant.compare_at_price > newVariant.price ? 'data-discounted-price="' + newVariant.price + '"' : ""}>`;
          if (newVariant.compare_at_price > newVariant.price) {
            innerHTML +=
              '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-compare-price = "$' +
              (newVariant["compare_at_price"] / 100).toFixed(2) +
              '" data-money-convertible>'.concat(
                "$",
                (newVariant.price / 100).toFixed(2),
                "</span>",
              );
            innerHTML +=
              '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>List: '.concat(
                "$",
                (newVariant.compare_at_price / 100).toFixed(2),
                "</span>",
              );
          } else {
            innerHTML +=
              '<span class="ProductMeta__Price Price Text--subdued u-h4 DefaultPrice" data-money-convertible>'.concat(
                "$",
                (newVariant.price / 100).toFixed(2),
                "</span>",
              );
            innerHTML += `<span class="CustomUnitPricing" data-pack="${this.selectedPack}"><span class="current-price Price">$${(newVariant["price"] / product_pack / 100).toFixed(2)}</span><span class="fade-pricing">per pair ${product_pack > 1 ? `(Total<span class="full-price">$${(newVariant.price / 100).toFixed(2)}</span>)` : ""}</span></span>`;
          }

          innerHTML += "</div>";
          productMetaPrices.innerHTML = "";
          productMetaPrices.insertAdjacentHTML("beforeend", innerHTML);
          productMetaPrices.querySelector(
            ".pro-main-price",
          ).dataset.productColl = product_collections;
          productMetaPrices.parentElement.dataset.collections =
            product_collections;

          document.dispatchEvent(
            new CustomEvent("pdp:price:updated", {
              detail: {
                selectedPack: this.selectedPack,
                newVariant,
              },
            }),
          );
        },
      },
      {
        key: "_onClickPack",
        value: function _onClickPack(newValue, target) {
          const productForm = target.closest(".ProductForm");
          const productMasterJson = JSON.parse(
            productForm.querySelector("[data-product-json]").innerHTML,
          );
          const productJson = productMasterJson.product;
          // const packsInventoryJson = productMasterJson.inventories;
          // const cartFreeShippingThreshold = THEME_SETTINGS.cart_free_shipping_threshold/100;
          // const percentSavingTags = ["ankle-socks", "aerolite-plus-collection", "midcalf"];

          var previousPack = this.currentPack;
          this.selectedPack = target.value;
          this.currentPack = productJson;
          // if (packsInventoryJson && !this.currentPack.inventory_json) this.currentPack.inventory_json = packsInventoryJson || {};
          // var selectedSize = sessionStorage.getItem("product-selected-size") || $('.SizeSwatch__Radio.MainProduct[type="radio"]:checked').val();

          // const productTags = this.currentPack.tags;
          // var selectedVariant = this.currentPack.variants.find(function (variant) {
          //   return variant.title === selectedSize;
          // }) || {};

          // var shippingText = {
          //   "1_pack": "Free Shipping over <span data-free-shipping-amount>$"+cartFreeShippingThreshold+"</span>.",
          //   "3_pack": productTags.includes("ankle-socks") ? "Free Shipping over <span data-free-shipping-amount>$"+cartFreeShippingThreshold+"</span>." : "These socks ship free."
          // };

          // const is_eligible_for_percent_saving = productTags.some(tag => percentSavingTags.includes(tag));

          sessionStorage.setItem("selectedPack", this.selectedPack);

          this._onPackChanged(previousPack, this.currentPack);

          // $('.pack-variant-options [type="radio"]').removeAttr("checked");
          // $(`.pack-variant-options [type="radio"][value="${this.selectedPack}"]`).prop("checked", "checked");

          // if (is_eligible_for_percent_saving) {
          //   shippingText["5_pack"] = `Includes 10% pack savings ${ !productTags.includes("ankle-socks") ? ' and free shipping' : ''}.`;
          // }else{
          //   shippingText["5_pack"] = "Includes 10% pack savings and free shipping.";
          // }

          // let regularShippingText = shippingText[this.selectedPack];
          // if (productTags.includes('delayed-shipping')) {
          //   if (this.selectedPack == "3_pack"){
          //     regularShippingText = shippingText["1_pack"] + "<br>";
          //   }else {
          //     regularShippingText = regularShippingText + "<br>";
          //   }
          //   regularShippingText = regularShippingText + '<span class="delayed-shipping" style="display:none;">' + THEME_SETTINGS.preorder_copy + "</span>";
          // }

          // $(".shipping-eligibility-block p").html(regularShippingText);
          // const inventory_quantity = this.currentPack?.inventory_json[selectedVariant.id]?.inventory_quantity ?? 0;
          // if (inventory_quantity <= 0) $("span.delayed-shipping").show();

          document.dispatchEvent(
            new CustomEvent("pack:changed", {
              detail: {
                selectedPack: this.selectedPack,
              },
            }),
          );
        },
      },
    ]);
    return ProductPacks;
  })();

  var ProductVideo = (function () {
    function ProductVideo(element, stackProductImages, enableVideoLooping) {
      _classCallCheck(this, ProductVideo);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.stackProductImages = stackProductImages;
      this.enableVideoLooping = enableVideoLooping;
      this.player = null;
      switch (this.element.getAttribute("data-media-type")) {
        case "video":
          var stylesheet = document.createElement("link");
          stylesheet.rel = "stylesheet";
          stylesheet.href =
            "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css";
          document.head.appendChild(stylesheet);
          window.Shopify.loadFeatures([
            {
              name: "video-ui",
              version: "1.0",
              onLoad: this._setupHtml5Video.bind(this),
            },
          ]);
          break;
        case "external_video":
          this._setupExternalVideo();
          break;
      }
    }
    _createClass(ProductVideo, [
      {
        key: "destroy",
        value: function destroy() {
          if (this.player) {
            this.player.destroy();
          }
        },
      },
      {
        key: "hasBeenSelected",
        value: function hasBeenSelected() {
          if (Responsive.matchesBreakpoint("supports-hover")) {
            this.play();
          }
        },
      },
      {
        key: "hasBeenDeselected",
        value: function hasBeenDeselected() {
          this.pause();
        },
      },
      {
        key: "play",
        value: function play() {
          switch (this.element.getAttribute("data-media-type")) {
            case "video":
              this.player.play();
              break;
            case "external_video":
              this.player.playVideo();
              break;
          }
        },
      },
      {
        key: "pause",
        value: function pause() {
          switch (this.element.getAttribute("data-media-type")) {
            case "video":
              this.player.pause();
              break;
            case "external_video":
              this.player.pauseVideo();
              break;
          }
        },
      },
      {
        key: "_setupHtml5Video",
        value: function _setupHtml5Video() {
          var _this = this;
          this.player = new Shopify.Plyr(this.element.querySelector("video"), {
            controls: [
              "play",
              "progress",
              "mute",
              "volume",
              "play-large",
              "fullscreen",
            ],
            loop: { active: this.enableVideoLooping },
            hideControlsOnPause: !0,
            clickToPlay: !0,
            iconUrl:
              "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
            tooltips: { controls: !1, seek: !0 },
          });
          this.player.on("play", function () {
            _this.element.dispatchEvent(
              new CustomEvent("video:played", { bubbles: !0 }),
            );
          });
          this.player.on("pause", function () {
            _this.element.dispatchEvent(
              new CustomEvent("video:paused", { bubbles: !0 }),
            );
          });
        },
      },
      {
        key: "_setupExternalVideo",
        value: function _setupExternalVideo() {
          if (this.element.getAttribute("data-video-host") === "youtube") {
            this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
          }
        },
      },
      {
        key: "_setupYouTubePlayer",
        value: function _setupYouTubePlayer() {
          var _this2 = this;
          var playerLoadingInterval = setInterval(function () {
            if (window.YT !== undefined && window.YT.Player !== undefined) {
              _this2.player = new YT.Player(
                _this2.element.querySelector("iframe"),
                {
                  videoId: _this2.element.getAttribute("data-video-id"),
                  events: {
                    onStateChange: function onStateChange(event) {
                      if (event.data === window.YT.PlayerState.PLAYING) {
                        _this2.element.dispatchEvent(
                          new CustomEvent("video:played", { bubbles: !0 }),
                        );
                      } else if (event.data === YT.PlayerState.PAUSED) {
                        _this2.element.dispatchEvent(
                          new CustomEvent("video:paused", { bubbles: !0 }),
                        );
                      }
                      if (
                        event.data === window.YT.PlayerState.ENDED &&
                        _this2.enableVideoLooping
                      ) {
                        event.target.seekTo(0);
                      }
                    },
                  },
                },
              );
              clearInterval(playerLoadingInterval);
            }
          }, 50);
        },
      },
      {
        key: "_loadYouTubeScript",
        value: function _loadYouTubeScript() {
          return new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = !0;
            script.src = "//www.youtube.com/iframe_api";
          });
        },
      },
    ]);
    return ProductVideo;
  })();

  var ScrollSpy = (function () {
    function ScrollSpy(container, elementsToSpy, observerOptions) {
      var _this = this;
      _classCallCheck(this, ScrollSpy);
      this.container = container;
      this.targets = [];
      this.targetIndices = {};
      this.indicesInViewPort = [];
      this.observer = new IntersectionObserver(
        this._onIntersectionChange.bind(this),
        observerOptions,
      );
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy);
        _this.targetIndices[elementToSpy.id] = index;
        _this.observer.observe(elementToSpy);
      });
    }
    _createClass(ScrollSpy, [
      {
        key: "destroy",
        value: function destroy() {
          this.observer.disconnect();
        },
      },
      {
        key: "_onIntersectionChange",
        value: function _onIntersectionChange(changes) {
          var oldTargetIndex = this.indicesInViewPort[0] || 0;
          for (var i = changes.length - 1; i >= 0; i--) {
            this._updateIndicesInViewPort(changes[i], oldTargetIndex);
          }
          this.indicesInViewPort = this.indicesInViewPort.filter(
            function (value, index, self) {
              return self.indexOf(value) === index;
            },
          );
          if (
            this.indicesInViewPort.length === 0 ||
            oldTargetIndex === this.indicesInViewPort[0]
          ) {
            return;
          }
          var event = new CustomEvent("scrollspy:target:changed", {
            detail: {
              newTarget: this.targets[this.indicesInViewPort[0]],
              oldTarget: this.targets[oldTargetIndex],
            },
          });
          this.container.dispatchEvent(event);
        },
      },
      {
        key: "_updateIndicesInViewPort",
        value: function _updateIndicesInViewPort(change, oldTargetIndex) {
          var index = this.targetIndices[change.target.id];
          if (change.intersectionRatio === 0) {
            var indexInViewPort = this.indicesInViewPort.indexOf(index);
            if (indexInViewPort !== -1) {
              this.indicesInViewPort.splice(indexInViewPort, 1);
            }
          } else {
            if (index < oldTargetIndex) {
              this.indicesInViewPort.unshift(index);
            } else if (
              index > this.indicesInViewPort[this.indicesInViewPort.length - 1]
            ) {
              this.indicesInViewPort.push(index);
            } else {
              this.indicesInViewPort.push(index);
              this.indicesInViewPort.sort();
            }
          }
        },
      },
    ]);
    return ScrollSpy;
  })();

  var SearchBar = (function () {
    function SearchBar() {
      _classCallCheck(this, SearchBar);
      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchElement = document.getElementById("Search");
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement =
        this.searchElement.querySelector(".Search__Results");
      this.queryMap = {};
      this.isOpen = !1;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(SearchBar, [
      {
        key: "destroy",
        value: function destroy() {
          this.searchInputElement.removeEventListener(
            "keydown",
            this._preventSubmissionListener,
          );
          this.searchInputElement.removeEventListener(
            "input",
            this._onInputListener,
          );
          this.documentDelegate.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._preventSubmissionListener = this._preventSubmission.bind(this);
          this._onInputListener = this._debounce(this._onInput.bind(this), 250);
          this.searchInputElement.addEventListener(
            "keydown",
            this._preventSubmissionListener,
          );
          this.searchInputElement.addEventListener(
            "input",
            this._onInputListener,
          );
          this.documentDelegate.on(
            "click",
            '[data-action="toggle-search"]',
            this._toggleSearch.bind(this),
          );
          this.documentDelegate.on(
            "click",
            '[data-action="open-search"]',
            this._openSearch.bind(this),
          );
          this.documentDelegate.on(
            "click",
            '[data-action="close-search"]',
            this._closeSearch.bind(this),
          );
          this.documentDelegate.on(
            "search:close",
            this._closeSearch.bind(this),
          );
        },
      },
      {
        key: "_toggleSearch",
        value: function _toggleSearch(event) {
          if (this.isOpen) {
            this._closeSearch(event);
          } else {
            this._openSearch(event);
          }
          event.preventDefault();
        },
      },
      {
        key: "_setSearchTriggersExpanded",
        value: function _setSearchTriggersExpanded(state) {
          // There is more than one trigger (primary header icon plus the
          // sidebar-menu variant), so every one has to report the same state.
          var triggers = document.querySelectorAll(
            '[data-action="toggle-search"]',
          );
          for (var i = 0; i < triggers.length; i++) {
            triggers[i].setAttribute("aria-expanded", state);
          }
        },
      },
      {
        key: "_openSearch",
        value: function _openSearch() {
          var _this = this;
          this.searchElement.setAttribute("aria-hidden", "false");
          this._setSearchTriggersExpanded("true");
          document.documentElement.classList.add("no-scroll");
          Accessibility.trapFocus(
            this.searchElement,
            "search",
            this.searchElement.querySelector('[name="q"]'),
          );
          var onFocusListener = function onFocusListener() {
            _this.searchInputElement.focus();
            _this.searchElement.removeEventListener(
              "transitionend",
              onFocusListener,
            );
          };
          this.searchElement.addEventListener("transitionend", onFocusListener);
          this.isOpen = !0;
          this.pageOverlayElement.classList.add("is-visible");
          document.querySelector("#shopify-section-header").style.zIndex = 10;
        },
      },
      {
        key: "_closeSearch",
        value: function _closeSearch() {
          var _this2 = this;
          this.searchElement.setAttribute("aria-hidden", "true");
          this._setSearchTriggersExpanded("false");
          document.documentElement.classList.remove("no-scroll");
          Accessibility.removeTrapFocus(this.searchElement, "search");
          this.isOpen = !1;
          var onTransitionEnd = function onTransitionEnd(event) {
            if (event.propertyName === "visibility") {
              document.querySelector("#shopify-section-header").style.zIndex =
                "";
              _this2.pageOverlayElement.removeEventListener(
                "transitionend",
                onTransitionEnd,
              );
            }
          };
          this.pageOverlayElement.addEventListener(
            "transitionend",
            onTransitionEnd,
          );
          this.pageOverlayElement.classList.remove("is-visible");
        },
      },
      {
        key: "_preventSubmission",
        value: function _preventSubmission(event) {
          if (event.keyCode === 13 && window.theme.searchMode !== "product") {
            event.preventDefault();
          }
        },
      },
      {
        key: "_onInput",
        value: function _onInput(event) {
          var _this3 = this;
          if (event.keyCode === 13) {
            return;
          }
          this.lastInputValue = event.target.value;
          if (this.lastInputValue === "") {
            this._resetSearch();
            return;
          }
          var queryOptions = { method: "GET", credentials: "same-origin" };
          var queries = [
            fetch(
              ""
                .concat(
                  window.routes.searchUrl,
                  "?section_id=predictive-search&q=",
                )
                .concat(
                  encodeURIComponent(this.lastInputValue),
                  "*&type=product",
                ),
              queryOptions,
            ),
          ];
          if (window.theme.searchMode !== "product") {
            queries.push(
              fetch(
                ""
                  .concat(
                    window.routes.searchUrl,
                    "?section_id=predictive-search&q=",
                  )
                  .concat(encodeURIComponent(this.lastInputValue), "*&type=")
                  .concat(window.theme.searchMode.replace("product,", "")),
                queryOptions,
              ),
            );
          }
          this.queryMap[this.lastInputValue] = !0;
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          Promise.all(queries).then(function (responses) {
            if (_this3.lastInputValue !== event.target.value) {
              return;
            }
            delete _this3.queryMap[event.target.value];
            Promise.all(
              responses.map(function (response) {
                return response.text();
              }),
            ).then(function (contents) {
              if (window.theme.searchMode === "product") {
                _this3.searchResultsElement.innerHTML = contents[0];
              } else {
                _this3.searchResultsElement.innerHTML =
                  '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
                    .concat(
                      contents[0],
                      '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">',
                    )
                    .concat(contents[1], "</div>\n            </div>");
              }
              _this3.searchResultsElement.setAttribute("aria-hidden", "false");
            });
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            onYotpoReady(() => {
              var api = new Yotpo.API(yotpo);
              api.refreshWidgets();
            });
          });
        },
      },
      {
        key: "_resetSearch",
        value: function _resetSearch() {
          if (window.theme.searchMode === "product") {
            this.searchResultsElement.innerHTML = "";
          } else {
            this.searchResultsElement.innerHTML =
              '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>';
          }
          this.searchResultsElement.setAttribute("aria-hidden", "true");
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        },
      },
      {
        key: "_debounce",
        value: function _debounce(fn, delay) {
          var _this4 = this;
          var timer = null;
          return function () {
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key];
            }
            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(_this4, args);
            }, delay);
          };
        },
      },
    ]);
    return SearchBar;
  })();

  var CountrySelector = (function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);
      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;
      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();
        this._initSelectors();
      }
    }
    _createClass(CountrySelector, [
      {
        key: "destroy",
        value: function destroy() {
          if (this.countrySelect) {
            this.countrySelect.removeEventListener(
              "change",
              this._onCountryChangedListener,
            );
          }
        },
      },
      {
        key: "_initSelectors",
        value: function _initSelectors() {
          var defaultCountry = this.countrySelect.getAttribute("data-default");
          if (defaultCountry) {
            for (var i = 0; i !== this.countrySelect.options.length; ++i) {
              if (this.countrySelect.options[i].text === defaultCountry) {
                this.countrySelect.selectedIndex = i;
                break;
              }
            }
          } else {
            this.countrySelect.selectedIndex = 0;
          }
          var event = new Event("change", { bubbles: !0 });
          this.countrySelect.dispatchEvent(event);
          var defaultProvince =
            this.provinceSelect.getAttribute("data-default");
          if (defaultProvince) {
            for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
              if (this.provinceSelect.options[_i].text === defaultProvince) {
                this.provinceSelect.selectedIndex = _i;
                break;
              }
            }
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onCountryChangedListener = this._onCountryChanged.bind(this);
          this.countrySelect.addEventListener(
            "change",
            this._onCountryChangedListener,
          );
        },
      },
      {
        key: "_onCountryChanged",
        value: function _onCountryChanged() {
          var _this = this;
          var selectedOption =
              this.countrySelect.options[this.countrySelect.selectedIndex],
            provinces = JSON.parse(
              selectedOption.getAttribute("data-provinces") || "[]",
            );
          this.provinceSelect.innerHTML = "";
          if (provinces.length === 0) {
            this.provinceSelect.parentNode.style.display = "none";
            return;
          }
          provinces.forEach(function (data) {
            _this.provinceSelect.options.add(new Option(data[1], data[0]));
          });
          this.provinceSelect.parentNode.style.display = "block";
        },
      },
    ]);
    return CountrySelector;
  })();
  var ShippingEstimator = (function () {
    function ShippingEstimator(element) {
      _classCallCheck(this, ShippingEstimator);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.countrySelector = new CountrySelector(
        this.element.querySelector('[name="country"]'),
        this.element.querySelector('[name="province"]'),
      );
      this._attachListeners();
    }
    _createClass(ShippingEstimator, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");
          this.countrySelector.destroy();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            ".ShippingEstimator__Submit",
            this._fetchRates.bind(this),
          );
        },
      },
      {
        key: "_fetchRates",
        value: function _fetchRates() {
          var _this = this;
          var country = this.element.querySelector('[name="country"]').value,
            province = this.element.querySelector('[name="province"]').value,
            zip = this.element.querySelector('[name="zip"]').value;
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          fetch(
            ""
              .concat(
                window.routes.cartUrl,
                "/shipping_rates.json?shipping_address[zip]=",
              )
              .concat(zip, "&shipping_address[country]=")
              .concat(country, "&shipping_address[province]=")
              .concat(province),
            { credentials: "same-origin", method: "GET" },
          ).then(function (response) {
            response.json().then(function (result) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              var resultsContainer = _this.element.querySelector(
                  ".ShippingEstimator__Results",
                ),
                errorContainer = _this.element.querySelector(
                  ".ShippingEstimator__Error",
                );
              if (response.ok) {
                var shippingRates = result.shipping_rates;
                if (shippingRates.length === 0) {
                  resultsContainer.innerHTML = "<p>".concat(
                    window.languages.shippingEstimatorNoResults,
                    "</p>",
                  );
                } else {
                  var html = "";
                  if (shippingRates.length === 1) {
                    html += "<p>".concat(
                      window.languages.shippingEstimatorOneResult,
                      "</p><ul>",
                    );
                  } else {
                    html += "<p>".concat(
                      window.languages.shippingEstimatorMoreResults.replace(
                        "{{count}}",
                        shippingRates.length,
                      ),
                      "</p><ul>",
                    );
                  }
                  shippingRates.forEach(function (item) {
                    html += "<li>"
                      .concat(item.name, ": ")
                      .concat(
                        Currency.formatMoney(
                          item.price,
                          window.theme.moneyFormat,
                        ),
                        "</li>",
                      );
                  });
                  html += "</ul>";
                  resultsContainer.firstElementChild.innerHTML = html;
                }
                TweenLite.fromTo(
                  resultsContainer.firstElementChild,
                  0.6,
                  { autoAlpha: 0, y: -15 },
                  { autoAlpha: 1, y: 0, delay: 0.35 },
                );
                errorContainer.style.display = "none";
                resultsContainer.style.display = "block";
                Animation.slideDown(resultsContainer);
              } else {
                var errorHtml = "";
                Object.keys(result).forEach(function (key) {
                  errorHtml += '<li class="Alert__ErrorItem">'
                    .concat(key, " ")
                    .concat(result[key], "</li>");
                });
                errorContainer.innerHTML =
                  '<ul class="Alert__ErrorList">'.concat(errorHtml, "</ul>");
                resultsContainer.style.display = "none";
                errorContainer.style.display = "block";
              }
            });
          });
        },
      },
    ]);
    return ShippingEstimator;
  })();
  var AddressesSection = function AddressesSection() {
    var _this = this;
    _classCallCheck(this, AddressesSection);
    this.countrySelectors = [];
    Dom.nodeListToArray(document.querySelectorAll(".Modal--address")).forEach(
      function (modal) {
        _this.countrySelectors.push(
          new CountrySelector(
            modal.querySelector('[name="address[country]"]'),
            modal.querySelector('[name="address[province]"]'),
          ),
        );
      },
    );
  };
  var ArticleList = (function () {
    function ArticleList(container) {
      var _this = this;
      _classCallCheck(this, ArticleList);
      this.element = container;
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0,
        });
        this.intersectionObserver = new IntersectionObserver(
          this._reveal.bind(this),
        );
        Dom.nodeListToArray(
          this.element.querySelectorAll(".ArticleItem"),
        ).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }
    _createClass(ArticleList, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
        },
      },
      {
        key: "_reveal",
        value: function _reveal(results) {
          var _this2 = this;
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target);
              _this2.intersectionObserver.unobserve(result.target);
            }
          });
          if (toReveal.length === 0) {
            return;
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0 },
            0.2,
          );
        },
      },
    ]);
    return ArticleList;
  })();
  var ArticleSection = (function () {
    function ArticleSection(container) {
      var _this = this;
      _classCallCheck(this, ArticleSection);
      this.element = container;
      this.toolbarElement = this.element.querySelector(".ArticleToolbar");
      this.articleNavElement = this.element.querySelector(".ArticleNav");
      var articleImageElement = this.element.querySelector(".Article__Image");
      if (
        articleImageElement &&
        window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
      ) {
        this.parallaxInstance = new Rellax(".Article__Image", {
          speed: -7,
          center: !1,
          round: !0,
        });
      }
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0,
        });
        this.intersectionObserver = new IntersectionObserver(
          this._reveal.bind(this),
        );
        Dom.nodeListToArray(
          this.element.querySelectorAll(".ArticleItem"),
        ).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
      this._attachListeners();
    }
    _createClass(ArticleSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy();
          }
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
          window.removeEventListener("scroll", this._onScrollListener);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onScrollListener = this._checkToolbarVisibility.bind(this);
          window.addEventListener("scroll", this._onScrollListener);
        },
      },
      {
        key: "_checkToolbarVisibility",
        value: function _checkToolbarVisibility() {
          var _this2 = this;
          var lastYPosition = 0,
            headerHeight = 0,
            navBottom = 0,
            isFixedHeader = 0,
            header = document.querySelector(".Header");
          fastdom.measure(function () {
            lastYPosition = window.pageYOffset;
            headerHeight = header.offsetHeight;
            isFixedHeader = parseInt(
              window
                .getComputedStyle(document.body)
                .getPropertyValue("--use-sticky-header") || 0,
            );
            if (_this2.articleNavElement) {
              navBottom =
                _this2.articleNavElement.offsetTop +
                _this2.articleNavElement.clientHeight -
                headerHeight;
            }
          });
          fastdom.mutate(function () {
            _this2.toolbarElement.style.top = isFixedHeader
              ? headerHeight + "px"
              : null;
            if (_this2.articleNavElement) {
              if (
                lastYPosition > 150 &&
                _this2.articleNavElement &&
                lastYPosition < navBottom
              ) {
                _this2.toolbarElement.classList.add("is-visible");
              } else {
                _this2.toolbarElement.classList.remove("is-visible");
              }
            } else {
              if (lastYPosition > 150) {
                _this2.toolbarElement.classList.add("is-visible");
              } else {
                _this2.toolbarElement.classList.remove("is-visible");
              }
            }
          });
        },
      },
      {
        key: "_reveal",
        value: function _reveal(results) {
          var _this3 = this;
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target);
              _this3.intersectionObserver.unobserve(result.target);
            }
          });
          if (toReveal.length === 0) {
            return;
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0 },
            0.2,
          );
        },
      },
    ]);
    return ArticleSection;
  })();
  var CartSection = (function () {
    function CartSection(container, options = {}) {
      _classCallCheck(this, CartSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.documentDelegate = new domDelegate.Delegate(
        document.documentElement,
      );
      const defaultOptions = {
        attachListeners: true,
        ...options,
      };
      this.options = {
        ...defaultOptions,
        ...JSON.parse(this.element.getAttribute("data-section-settings")),
      };
      this.itemCount = this.options.itemCount;
      this.isCartNoteOpen = !1;
      if (this.options.drawer) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this),
        });
      }
      if (this.options.hasShippingEstimator) {
        this.shippingEstimator = new ShippingEstimator(
          this.element.querySelector(".ShippingEstimator"),
        );
      }

      if (this.options.attachListeners) {
        this._attachListeners();
      }
    }
    _createClass(CartSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.options.hasShippingEstimator) {
            this.shippingEstimator.destroy();
          }
          this.delegateElement.off();
          document.removeEventListener(
            "product:added",
            this._onProductAddedListener,
          );
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onProductAddedListener = this._onProductAdded.bind(this);
          this.delegateElement.on(
            "change",
            "#cart-note",
            this._updateCartNote.bind(this),
          );
          if (this.options.type !== "page") {
            this.delegateElement
              .off(
                "click",
                '[data-action="update-item-quantity"], [data-action="remove-item"]',
              )
              .on(
                "click",
                '[data-action="update-item-quantity"], [data-action="remove-item"]',
                this._updateItemQuantity.bind(this),
              );

            this.delegateElement
              .off("change", ".QuantitySelector__CurrentQuantity")
              .on(
                "change",
                ".QuantitySelector__CurrentQuantity",
                this._updateItemQuantity.bind(this),
              );
          } else {
            this.delegateElement.on(
              "change",
              ".QuantitySelector__CurrentQuantity",
              this._reloadPageWithQuantity.bind(this),
            );
          }
          if (this.options.drawer) {
            this.delegateElement.on(
              "click",
              '[data-action="toggle-cart-note"]',
              this._toggleCartNote.bind(this),
            );
          }
          document.addEventListener(
            "product:added",
            this._onProductAddedListener,
          );
          this.documentDelegate.on(
            "cart:refresh",
            this._rerenderCart.bind(this, !1),
          );
        },
      },
      {
        key: "_updateCartNote",
        value: function _updateCartNote(event, target) {
          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({ note: target.value }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
        },
      },
      {
        key: "_toggleCartNote",
        value: function _toggleCartNote() {
          var _this = this;
          var noteContainer = this.element.querySelector(
              ".Cart__OffscreenNoteContainer",
            ),
            cartNote = this.element.querySelector("#cart-note");
          this.element.classList.toggle("has-note-open");
          this.element.querySelector(".Cart__NoteButton").innerHTML =
            cartNote.value !== ""
              ? window.languages.cartEditNote
              : window.languages.cartAddNote;
          noteContainer.setAttribute(
            "aria-hidden",
            noteContainer.getAttribute("aria-hidden") === "true"
              ? "false"
              : "true",
          );
          this.isCartNoteOpen =
            noteContainer.getAttribute("aria-hidden") === "false";
          if (this.element.classList.contains("has-note-open")) {
            var transitionEndListener = function transitionEndListener() {
              _this.element.querySelector("#cart-note").focus();
              noteContainer.removeEventListener(
                "transitionend",
                transitionEndListener,
              );
            };
            noteContainer.addEventListener(
              "transitionend",
              transitionEndListener,
            );
          }
        },
      },
      {
        key: "_updateItemQuantity",
        value: function _updateItemQuantity(event, target) {
          var _this2 = this;
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          var quantity = null,
            elementToAnimate = null;
          if (target.tagName === "INPUT") {
            quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
          } else {
            quantity = parseInt(target.getAttribute("data-quantity"));
          }
          if (quantity === 0) {
            elementToAnimate = target.closest(".CartItemWrapper");
          }
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: target.getAttribute("data-line"),
              quantity: quantity,
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this2.itemCount = content.item_count;
              _this2._rerenderCart(elementToAnimate);
              _this2.element.dispatchEvent(
                new CustomEvent("quantity:updated", {
                  bubbles: !0,
                  detail: { cart: cart },
                }),
              );
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
            });
          });
          event.preventDefault();
        },
      },
      {
        key: "_reloadPageWithQuantity",
        value: function _reloadPageWithQuantity(event, target) {
          window.location.href = ""
            .concat(window.routes.cartChangeUrl, "?quantity=")
            .concat(parseInt(target.value), "&line=")
            .concat(target.getAttribute("data-line"));
        },
      },
      {
        key: "_onProductAdded",
        value: function _onProductAdded(event) {
          var _this3 = this;
          this.itemCount += event.detail.quantity;
          this._rerenderCart(null, event.detail).then(function () {
            const sectionSettings = JSON.parse(
              event.target?.dataset?.sectionSettings || "{}",
            );

            if (event.detail?.product?.handle == "priority-processing") {
              sectionSettings.hideSideCart = true;
            }

            if (!sectionSettings?.hideSideCart) {
              _this3.sidebarDrawer && _this3.sidebarDrawer.open();
            }
          });
        },
      },
      {
        key: "_onDrawerClosed",
        value: function _onDrawerClosed() {
          if (this.isCartNoteOpen) {
            this._toggleCartNote();
          }
        },
      },
      {
        key: "_rerenderCart",
        value: function _rerenderCart(elementToAnimate, eventDetails = null) {
          var _this4 = this;
          return fetch(
            ""
              .concat(window.routes.cartUrl, "?section_id=")
              .concat(
                this.options.drawer && window.theme.pageType !== "cart"
                  ? "mini-cart"
                  : "main-cart",
                "&timestamp=",
              )
              .concat(Date.now()),
            { credentials: "same-origin", method: "GET" },
          ).then(function (content) {
            if (_this4.options.drawer && elementToAnimate) {
              var timelineLite = new TimelineLite({
                onComplete: function onComplete() {
                  content.text().then(function (html) {
                    _this4._replaceContent(html, eventDetails);
                  });
                },
              });
              timelineLite.to(
                elementToAnimate,
                0.5,
                { height: 0, opacity: 0, ease: Cubic.easeOut },
                0,
              );
              if (_this4.itemCount === 0) {
                timelineLite.to(
                  _this4.element.querySelector(".Drawer__Footer"),
                  0.5,
                  { y: "100%", transition: "none", ease: Cubic.easeInOut },
                  0,
                );
              }
            } else {
              content.text().then(function (html) {
                _this4._replaceContent(html, eventDetails);
              });
            }
          });
        },
      },
      {
        key: "_replaceContent",
        value: function _replaceContent(html, eventDetails) {
          var _this5 = this;
          var tempElement = document.createElement("div");
          tempElement.innerHTML = html;
          var cartNodeParent = this.element.querySelector(".Cart").parentNode;
          if (this.options.drawer && window.theme.pageType !== "cart") {
            var currentScrollPosition =
              this.element.querySelector(".Drawer__Main").scrollTop;
            cartNodeParent.replaceChild(
              tempElement.querySelector(".Cart"),
              this.element.querySelector(".Cart"),
            );
            this.element.querySelector(".Drawer__Main").scrollTop =
              currentScrollPosition;
          } else {
            if (this.itemCount === 0) {
              this.element.innerHTML =
                tempElement.querySelector(
                  ".shopify-section",
                ).firstElementChild.innerHTML;
            } else {
              cartNodeParent.replaceChild(
                tempElement.querySelector(".Cart"),
                this.element.querySelector(".Cart"),
              );
              this.element.querySelector(".PageHeader").innerHTML =
                tempElement.querySelector(".PageHeader").innerHTML;
            }
          }
          var cartResult = JSON.parse(
            tempElement
              .querySelector('[data-section-type="cart"]')
              .getAttribute("data-section-settings"),
          );
          var cartDot = Dom.nodeListToArray(
              document.querySelectorAll(".Header__CartDot"),
            ),
            cartQuantity = Dom.nodeListToArray(
              document.querySelectorAll(".Header__CartCount"),
            );
          this.itemCount = cartResult.itemCount;
          cartDot.forEach(function (item) {
            if (_this5.itemCount === 0) {
              item.classList.remove("is-visible");
            } else {
              item.classList.add("is-visible");
            }
          });
          cartQuantity.forEach(function (item) {
            item.textContent = _this5.itemCount;
          });
          // The count is part of the cart control's accessible name, so the
          // label has to be rebuilt whenever the count changes. Liquid renders
          // both plural forms onto the element with a [count] placeholder.
          var cartControls = document.querySelectorAll("[data-cart-label-other]");
          for (var c = 0; c < cartControls.length; c++) {
            var control = cartControls[c];
            var template =
              _this5.itemCount === 1
                ? control.getAttribute("data-cart-label-one")
                : control.getAttribute("data-cart-label-other");
            if (template) {
              control.setAttribute(
                "aria-label",
                template.replace("[count]", _this5.itemCount),
              );
            }
          }
          _this5.element.dispatchEvent(
            new CustomEvent("cart:replaceContent", {
              bubbles: !0,
              detail: { html: html, eventDetails: eventDetails },
            }),
          );
        },
      },
    ]);
    return CartSection;
  })();

  var BYOB = (function () {
    function BYOB() {
      _classCallCheck(this, BYOB);

      this.CartSection = new CartSection(
        document.querySelector("#sidebar-cart"),
        {
          attachListeners: false,
        },
      );

      this.config = {
        collectionUrl: `${window.location.pathname}?view=byob`,
      };

      this.selectors = {
        openModal: '[aria-controls="modal-byob-quick-add"]',
        closeModal: 'button[data-action="close-modal"]',
        modal: "#modal-byob-quick-add",
        modalBody: "#modal-byob-quick-add .Modal__Body",
        byobCartList: ".byob-cart-list",
        byobCartContainer: "#byobCartContainer",
        removeByobItem: "byob-remove-item",
        cartJson: 'script[data-json="cart"]',
        benefitsUnlockedSection: "#benefitsUnlockedSection",
      };

      this.modalClickHandlers = [];

      this._onProductAddedHandler = this.onProductAddedListener.bind(this);
      this._updatedByobCartListHandler = this.updatedByobCartList.bind(this);
      this._attachListenersHandler = this.attachListeners.bind(this);
      this._reAttachListenersHandler = this.reAttachListeners.bind(this);
      this._cartClickHandler = this.cartClickListener.bind(this);

      this.attachListeners();
      this.updateDiscountAmount();
    }
    _createClass(BYOB, [
      {
        key: "onUnload",
        value: function onUnload() {
          const { byobCartContainer } = this.selectors;
          const byobCartContainerEl = document.querySelector(byobCartContainer);

          document.removeEventListener(
            "product:added",
            this._onProductAddedHandler,
          );
          this.CartSection.element.removeEventListener(
            "cart:replaceContent",
            this._updatedByobCartListHandler,
          );
          document.removeEventListener(
            "collection:filters:applied",
            this._attachListenersHandler,
          );
          if (byobCartContainerEl) {
            byobCartContainerEl.removeEventListener(
              "click",
              this._cartClickHandler,
            );
          }
          this.modalClickHandlers.forEach(({ element, handler }) => {
            element.removeEventListener("click", handler);
          });
          this.modalClickHandlers = [];
        },
      },
      {
        key: "reAttachListeners",
        value: function reAttachListeners() {
          this.onUnload();
          this.attachListeners();
        },
      },
      {
        key: "attachListeners",
        value: function attachListeners() {
          const _this = this;
          const {
            openModal,
            closeModal,
            byobCartContainer,
            removeByobItem,
            modal,
          } = this.selectors;

          document.addEventListener(
            "product:added",
            this._onProductAddedHandler,
          );

          this.CartSection.element.addEventListener(
            "cart:replaceContent",
            this._updatedByobCartListHandler,
          );

          document.addEventListener(
            "collection:filters:applied",
            this._reAttachListenersHandler,
          );

          document.querySelectorAll(openModal).forEach((button) => {
            const handler = (e) => {
              e.preventDefault();
              const modalId = button.getAttribute("aria-controls");
              this.openModal(modalId, button);
            };
            button.addEventListener("click", handler);
            this.modalClickHandlers.push({ element: button, handler });
          });

          document.querySelectorAll(closeModal).forEach((button) => {
            const handler = (e) => {
              e.preventDefault();
              const modalEl = button.closest(modal);
              if (!modalEl) return;
              this.closeModal(modalEl);
            };
            button.addEventListener("click", handler);
            this.modalClickHandlers.push({ element: button, handler });
          });

          // const byobCartContainerEl = document.querySelector(byobCartContainer);
          // if(byobCartContainerEl){
          //   byobCartContainerEl.addEventListener('click', this.cartClickHandler.bind(this));
          // }
          const removeByobItemEls = document.querySelectorAll(
            "." + removeByobItem,
          );
          removeByobItemEls.forEach((el) => {
            el.addEventListener("click", this._cartClickHandler);
          });
        },
      },
      {
        key: "startAnimation",
        value: function startAnimation(button) {
          button
            .closest(".product-information")
            .querySelector(".product-img")
            .classList.add("Image--lazyLoading");
        },
      },
      {
        key: "stopAnimation",
        value: function stopAnimation() {
          document
            .querySelectorAll(".byob-product-left .product-img")
            .forEach((grid) => {
              grid.classList.remove("Image--lazyLoading");
            });
        },
      },
      /**
       * Open the modal
       * @param {string} modalId - The ID of the modal to open
       * @param {HTMLElement} button - The button that triggered the modal
       */
      {
        key: "openModal",
        value: function openModal(modalId, button) {
          const _this = this;
          const modal = document.getElementById(modalId);
          if (!modal) return;

          const productHandle = button.dataset.productHandle;
          const modalBody = modal.querySelector(this.selectors.modalBody);
          const url = `${window.location.pathname}/products/${productHandle}?view=byob`;

          this.startAnimation(button);

          fetch(url)
            .then((res) => res.text())
            .then((responseMarkup) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(responseMarkup, "text/html");
              const productJson = doc.querySelector(
                "script[data-product-json]",
              );
              const content = doc.querySelector(
                'div[data-section="product-data-section"]',
              );
              const selectedSize =
                sessionStorage.getItem("product-selected-size") ||
                content.querySelector(
                  '.SizeSwatch__Radio.MainProduct[type="radio"]:checked',
                ).value;
              const selectedSizeInput = content.querySelector(
                `input[value="${selectedSize}"]`,
              );
              if (selectedSizeInput && selectedSizeInput.disabled) {
                const firstAvailableSize = content.querySelector(
                  '.SizeSwatch__Radio.MainProduct[type="radio"]:not([disabled])',
                );
                if (firstAvailableSize) {
                  firstAvailableSize.checked = true;
                  sessionStorage.setItem(
                    "product-selected-size",
                    firstAvailableSize.value,
                  );
                }
              }

              modalBody.innerHTML = content.innerHTML;

              _this.stopAnimation();

              if (productJson) {
                const product = JSON.parse(productJson.textContent);
                gtag("event", "byob_item_viewed", {
                  handle: product.product.handle,
                  title: product.product.title,
                  product_id: product.product.id,
                });
              }

              document.dispatchEvent(
                new CustomEvent("shopify:section:reload", {
                  detail: {
                    sections: ["product"],
                  },
                }),
              );

              modal.setAttribute("aria-hidden", "false");
              document.body.classList.add("no-scroll");
            });
        },
      },

      {
        key: "closeModal",
        value: function closeModal(modal) {
          this.stopAnimation();

          modal.setAttribute("aria-hidden", "true");
          document.body.classList.remove("no-scroll");
          const modalBody = modal.querySelector(this.selectors.modalBody);

          const productJson = modalBody.querySelector(
            "script[data-product-json]",
          );
          if (productJson) {
            const product = JSON.parse(productJson.textContent);
            gtag("event", "byob_item_closed", {
              handle: product.product.handle,
              title: product.product.title,
              product_id: product.product.id,
            });
          }

          modalBody.innerHTML = "";
        },
      },
      {
        key: "onProductAddedListener",
        value: function onProductAddedListener(e) {
          const { product, variant } = e.detail;
          const productId = product.id;
          const variantId = variant.id;
          const isByob =
            e.target.querySelector(".Product__Wrapper--Byob") !== null;

          if (!isByob) return;
          // this.updatedByobCartList();

          if (productId && variantId) {
            gtag("event", "byob_item_added", {
              value: product.price / 100,
              currency: window.themeVariables?.cart?.currency || "USD",
              items: [
                {
                  properties: product.properties,
                  quantity: 1,
                  variant_id: variantId,
                  product_title: product.title,
                  variant_title: variant.title,
                  price: product.price / 100,
                  original_price: product.original_price / 100,
                  sku: product.sku,
                  product_id: productId,
                },
              ],
            });
          }
        },
      },
      {
        key: "updatedByobCartList",
        value: function updatedByobCartList(e) {
          const _this = this;
          const { byobCartContainer, modal, benefitsUnlockedSection } =
            this.selectors;
          const byobCartListEl = document.querySelector(byobCartContainer);
          const benefitsUnlockedSectionEl = document.querySelector(
            benefitsUnlockedSection,
          );
          const modalEl = document.querySelector(modal);

          if (!byobCartListEl) {
            return;
          }

          fetch(this.config.collectionUrl)
            .then((res) => res.text())
            .then((responseMarkup) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(responseMarkup, "text/html");
              byobCartListEl.innerHTML =
                doc.querySelector(byobCartContainer).innerHTML;
              // benefitsUnlockedSectionEl.innerHTML = doc.querySelector(benefitsUnlockedSection).innerHTML;
              _this.updateDiscountAmount();
              _this.closeModal(modalEl);
              this.reAttachListeners();
            });
        },
      },
      {
        key: "updateDiscountAmount",
        value: function updateDiscountAmount() {
          const { cartJson } = this.selectors;
          const cartJsonEl = document.querySelector(cartJson);
          const cartJsonData = cartJsonEl
            ? JSON.parse(cartJsonEl.textContent)
            : null;
          const priorityProcessingItem =
            cartJsonData?.items?.find(
              (item) => item.handle == "priority-processing",
            ) || false;
          const markdownObject = localStorageUtils.get("markdown_object") || [];
          const existing = markdownObject.find(
            (m) =>
              m.markdown_collections.includes("shop-all") ||
              m.markdown_collections.includes("build-your-own-bundle"),
          );
          const basePrice = 29.99;
          const discountPercentageMap = {
            4: {
              amount: 7,
              percentage: 6,
            },
            5: {
              amount: 14,
              percentage: 10,
            },
            6: {
              amount: 20,
              percentage: 11.5,
            },
            7: {
              amount: 20,
              percentage: 11.5,
            },
            8: {
              amount: 35,
              percentage: 15,
            },
          };

          const bundleDiscountedTotalElements = document.querySelector(
            `span[data-bundle-discounted-total]`,
          );
          if (bundleDiscountedTotalElements) {
            const pairCount = Number(
              bundleDiscountedTotalElements.dataset.totalPairs || 0,
            );
            const originalTotalAmount = Number(
              bundleDiscountedTotalElements.dataset.bundleTotalAmount || 0,
            );
            const totalAmount = priorityProcessingItem
              ? originalTotalAmount - priorityProcessingItem.line_price
              : originalTotalAmount;
            const promoDiscount = existing?.markdown_multiplier
              ? 100 - Number(existing.markdown_multiplier) * 100
              : 0;
            const currentDiscount =
              discountPercentageMap[Math.min(pairCount, 8)]?.percentage || 0;
            const totalDiscount = currentDiscount + promoDiscount;
            const finalDiscountAmount =
              originalTotalAmount -
              Math.floor(totalAmount * (totalDiscount / 100));

            bundleDiscountedTotalElements.innerText = `$${finalDiscountAmount / 100}`;
            bundleDiscountedTotalElements.classList.toggle(
              "hide-all",
              !(totalDiscount > 0),
            );

            const totalEl = document.querySelector("span.byob-bundle-total");
            totalEl?.classList.toggle("byob-bundle-added", totalDiscount > 0);
          }

          if (!existing) {
            return;
          }

          const promoDiscountElements = document.querySelectorAll(
            `span[data-promo-discount]`,
          );

          promoDiscountElements.forEach((el) => {
            const pairCount = Number(el.dataset.pairCount || 0);
            const currentDiscount =
              discountPercentageMap[Math.min(pairCount, 8)].percentage;
            const promoDiscount = existing?.markdown_multiplier
              ? 100 - Number(existing.markdown_multiplier) * 100
              : 0;
            const totalDiscount = currentDiscount + promoDiscount;

            let originalBundleTotal = basePrice * pairCount;
            if (el.classList.contains("savings-amount")) {
              let numericOriginalBundleTotal = Number(
                el.dataset.originalBundleTotal || 0,
              );
              numericOriginalBundleTotal =
                numericOriginalBundleTotal > 0 && priorityProcessingItem
                  ? numericOriginalBundleTotal -
                    priorityProcessingItem.line_price
                  : numericOriginalBundleTotal;
              originalBundleTotal = numericOriginalBundleTotal / 100;
            }

            const finalDiscountAmount = Math.floor(
              originalBundleTotal * (totalDiscount / 100),
            );
            el.innerText = `$${finalDiscountAmount}`;
          });
        },
      },
      {
        key: "cartClickListener",
        value: function (event) {
          event.preventDefault();
          const { removeByobItem } = this.selectors;
          const button =
            event.target.nodeName === "BUTTON"
              ? event.target
              : event.target.closest('[data-action="byob-remove-item"]');
          if (!button) return;

          if (!button.classList.contains(removeByobItem)) {
            return;
          }

          gtag("event", "byob_item_removed", {
            handle: button.dataset.productHandle,
            title: button.dataset.productTitle,
            product_id: button.dataset.productId,
          });

          button.querySelector("img").classList.add("rotate");

          this.CartSection._updateItemQuantity(event, button);
        },
      },
    ]);
    return BYOB;
  })();

  var CollectionListSection = (function () {
    function CollectionListSection(container) {
      _classCallCheck(this, CollectionListSection);
      this.element = container;
      var collectionListElement = this.element.querySelector(
        "[data-flickity-config]",
      );
      if (collectionListElement) {
        this.carousel = new Carousel(collectionListElement);
      }
    }
    _createClass(CollectionListSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.carousel) {
            this.carousel.destroy();
          }
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (this.carousel) {
            this.carousel.selectCell(
              event.target.getAttribute("data-slide-index"),
              !0,
              !event.detail.load,
            );
          }
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          if (this.carousel) {
            this.carousel.unpausePlayer();
          }
        },
      },
    ]);
    return CollectionListSection;
  })();
  var OverflowScroller = (function () {
    function OverflowScroller(element) {
      _classCallCheck(this, OverflowScroller);
      if (!element) {
        return;
      }
      this.element = element;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset = parseInt(
        window.getComputedStyle(this.element).top,
      );
      this._attachListeners();
    }
    _createClass(OverflowScroller, [
      {
        key: "destroy",
        value: function destroy() {
          window.removeEventListener("scroll", this._checkPositionListener);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._checkPositionListener = this._checkPosition.bind(this);
          window.addEventListener("scroll", this._checkPositionListener);
        },
      },
      {
        key: "_checkPosition",
        value: function _checkPosition() {
          var _this = this;
          fastdom.measure(function () {
            var bounds = _this.element.getBoundingClientRect(),
              maxTop =
                bounds.top +
                window.scrollY -
                _this.element.offsetTop +
                _this.initialTopOffset,
              minTop = _this.element.clientHeight - window.innerHeight;
            if (window.scrollY < _this.lastKnownY) {
              _this.currentTop -= window.scrollY - _this.lastKnownY;
            } else {
              _this.currentTop += _this.lastKnownY - window.scrollY;
            }
            _this.currentTop = Math.min(
              Math.max(_this.currentTop, -minTop),
              maxTop,
              _this.initialTopOffset,
            );
            _this.lastKnownY = window.scrollY;
          });
          fastdom.mutate(function () {
            _this.element.style.top = "".concat(_this.currentTop, "px");
          });
        },
      },
    ]);
    return OverflowScroller;
  })();
  var CollectionSection = (function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.toolbarElement = this.element.querySelector(".CollectionToolbar");
      this.collectionInnerElement = this.element.querySelector(
        ".CollectionInner__Products",
      );
      this.settings = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      var sortPopoverElement = document.getElementById(
        "collection-sort-popover",
      );
      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, {
          onValueChanged: this._sortByChanged.bind(this),
        });
      }
      var filterDrawerElement = document.getElementById(
        "collection-filter-drawer",
      );
      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement);
      }
      if (this.settings.filterPosition === "sidebar") {
        this.filterInnerSidebarScroller = new OverflowScroller(
          this.element.querySelector(".CollectionInner__Sidebar"),
        );
      }
      var collectionImageElement = this.element.querySelector(
        ".PageHeader__ImageWrapper",
      );
      if (
        collectionImageElement &&
        window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
      ) {
        this.parallaxInstance = new Rellax(".PageHeader__ImageWrapper", {
          speed: -7,
          center: !1,
          round: !0,
        });
      }
      new ProductItemColorSwatch(this.element.querySelector(".ProductList"));
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0,
      });
      this._setupAnimation();
      this._attachListeners();
    }
    _createClass(CollectionSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");
          if (this.sortPopover) {
            this.sortPopover.destroy();
          }
          if (this.filterDrawer) {
            this.filterDrawer.destroy();
          }
          if (this.filterInnerSidebarScroller) {
            this.filterInnerSidebarScroller.destroy();
          }
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy();
          }
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
        },
      },
      {
        key: "_setupAnimation",
        value: function _setupAnimation() {
          var _this = this;
          var forceLoadFromTop =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : !1;
          if (!window.theme.showElementStaggering) {
            return;
          }
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
          if (forceLoadFromTop) {
            this.timeline.clear();
            this.timeline.staggerFromTo(
              this.element.querySelectorAll(".ProductList .ProductItem"),
              0.35,
              { autoAlpha: 0, y: 25 },
              { autoAlpha: 1, y: 0 },
              0.15,
            );
          } else {
            this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this),
              { threshold: 0.3 },
            );
            Dom.nodeListToArray(
              this.element.querySelectorAll(".ProductList .ProductItem"),
            ).forEach(function (item) {
              _this.intersectionObserver.observe(item);
            });
          }
        },
      },
      {
        key: "_reveal",
        value: function _reveal(results) {
          var _this2 = this;
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target);
              _this2.intersectionObserver.unobserve(result.target);
            }
          });
          if (toReveal.length === 0) {
            return;
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            { autoAlpha: 0, y: 25 },
            { autoAlpha: 1, y: 0 },
            0.2,
          );
        },
      },
      {
        key: "_changeLayoutMode",
        value: function _changeLayoutMode(event, target) {
          var _this3 = this;
          var layoutType = target.getAttribute("data-grid-type"),
            newCount = parseInt(target.getAttribute("data-count"));
          var productList =
            this.collectionInnerElement.querySelector(".ProductList");
          if (productList) {
            var previousCount = parseInt(
              productList.getAttribute("data-".concat(layoutType, "-count")),
            );
            if (previousCount === newCount) {
              return;
            }
            productList.setAttribute(
              "data-".concat(layoutType, "-count"),
              newCount,
            );
            Dom.nodeListToArray(
              productList.querySelectorAll(".Grid__Cell"),
            ).forEach(function (item) {
              if (layoutType === "mobile") {
                item.classList.remove("1/".concat(previousCount, "--phone"));
                item.classList.add("1/".concat(newCount, "--phone"));
              } else {
                var previousTabletCount = previousCount === 2 ? 2 : 3,
                  newTabletCount = newCount === 2 ? 2 : 3;
                if (_this3.settings.filterPosition === "drawer") {
                  item.classList.remove(
                    "1/".concat(previousCount, "--lap-and-up"),
                  );
                  item.classList.add("1/".concat(newCount, "--lap-and-up"));
                } else {
                  item.classList.remove("1/".concat(previousCount, "--desk"));
                  item.classList.add("1/".concat(newCount, "--desk"));
                }
                item.classList.remove(
                  "1/".concat(previousTabletCount, "--tablet-and-up"),
                );
                item.classList.add(
                  "1/".concat(newTabletCount, "--tablet-and-up"),
                );
              }
              if (window.theme.showElementStaggering) {
                item.firstElementChild.style.visibility = "hidden";
              }
            });
            lazySizes.autoSizer.checkElems();
          }
          target.classList.add("is-active");
          Dom.getSiblings(target)[0].classList.remove("is-active");
          this._setupAnimation();
          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              attributes: _defineProperty(
                {},
                "collection_".concat(layoutType, "_items_per_row"),
                newCount,
              ),
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
        },
      },
      {
        key: "_sortByChanged",
        value: function _sortByChanged(sortBy) {
          var currentUrl = new URL(location.href);
          currentUrl.searchParams.set("sort_by", sortBy);
          currentUrl.searchParams.delete("page");
          this._reloadProducts(currentUrl.toString());
        },
      },
      {
        key: "_onFiltersCleared",
        value: function _onFiltersCleared(event) {
          this._reloadProducts(event.target.getAttribute("data-url"));
        },
      },
      {
        key: "_onFilterChanged",
        value: function _onFilterChanged(event) {
          var input_type = event.target.getAttribute("data-input-type");
          var input_name = event.target.getAttribute("name");
          if (input_type === "radio") {
            var checked = event.target.checked;
            if (checked) {
              var name = event.target.getAttribute("name");
              var checkboxes = this.element.querySelectorAll(
                '[name="'.concat(name, '"]'),
              );
              checkboxes.forEach(function (checkbox) {
                if (checkbox !== event.target) {
                  checkbox.checked = !1;
                }
              });
            }
          }

          //patch code
          if (input_name === "filter.v.option.size") {
            const target = event.target;
            const checked = target.checked;

            let label = null;
            let topInput = null;

            if (target.id && target.id.includes("drawer")) {
              const topId = target.id.replace("drawer", "top");
              label = document.querySelector(`label[for="${topId}"]`);
              topInput = document.getElementById(topId);
            }

            if (!checked) {
              target.checked = false;
              target.nextElementSibling?.classList.remove("active");
              label?.classList.remove("active");
              if (topInput) {
                topInput.checked = false;
              }
            } else {
              label?.classList.add("active");
            }
          }
          //patch code ends

          var formData = new FormData(event.target.closest("form"));
          var searchParamsAsString = new URLSearchParams(formData).toString();
          this._reloadProducts(
            ""
              .concat(window.location.pathname, "?")
              .concat(searchParamsAsString),
          );
        },
      },
      {
        key: "_reloadProducts",
        value: function _reloadProducts(url) {
          var _this4 = this;
          if (this.abortController) {
            this.abortController.abort();
          }
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          if (history.replaceState) {
            window.history.pushState({ path: url }, "", url);
          }
          var currentUrl = new URL(window.location);
          currentUrl.searchParams.set("section_id", this.settings.sectionId);
          try {
            this.abortController = new AbortController();
            fetch(currentUrl.toString(), {
              signal: this.abortController.signal,
            }).then(function (response) {
              response.text().then(function (content) {
                var tempElement = document.createElement("div");
                tempElement.innerHTML = content;
                _this4.collectionInnerElement.innerHTML =
                  tempElement.querySelector(
                    ".CollectionInner__Products",
                  ).innerHTML;
                var toolbarFilter = tempElement.querySelector(
                  ".CollectionToolbar__Item--filter",
                );
                if (toolbarFilter) {
                  var newToolbarFilter = _this4.element.querySelector(
                    ".CollectionToolbar__Item--filter",
                  );
                  newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                  newToolbarFilter.className = toolbarFilter.className;
                }

                var toolbarProductsCount = tempElement.querySelector(
                  ".CollectionToolbar__Item--products-count",
                );
                if (toolbarProductsCount) {
                  var newToolbarProductsCount = _this4.element.querySelector(
                    ".CollectionToolbar__Item--products-count",
                  );
                  newToolbarProductsCount.innerHTML =
                    toolbarProductsCount.innerHTML;
                  newToolbarProductsCount.className =
                    toolbarProductsCount.className;
                }

                var collectionFiltersDrawer = _this4.element.querySelector(
                    "#collection-filters-drawer-form",
                  ),
                  collectionFiltersSidebar = _this4.element.querySelector(
                    "#collection-filters-sidebar-form",
                  );
                if (collectionFiltersDrawer) {
                  var newDrawerContent = tempElement.querySelector(
                    "#collection-filters-drawer-form",
                  );
                  Array.from(
                    collectionFiltersDrawer.querySelectorAll(".Collapsible"),
                  ).forEach(function (collapsible) {
                    var newCollapsible = newDrawerContent.querySelector(
                      '[data-filter-index="'.concat(
                        collapsible.getAttribute("data-filter-index"),
                        '"]',
                      ),
                    );
                    if (
                      collapsible.firstElementChild.getAttribute(
                        "aria-expanded",
                      ) === "true"
                    ) {
                      newCollapsible.style.overflow = "visible";
                      newCollapsible.firstElementChild.setAttribute(
                        "aria-expanded",
                        "true",
                      );
                      newCollapsible.lastElementChild.style.height = "auto";
                      newCollapsible.lastElementChild.style.overflow =
                        "visible";
                    }
                  });
                  collectionFiltersDrawer.innerHTML =
                    newDrawerContent.innerHTML;
                  new ProductItemColorSwatch(
                    _this4.element.querySelector(".ProductList"),
                  );
                }
                if (collectionFiltersSidebar) {
                  var newSidebarContent = tempElement.querySelector(
                    "#collection-filters-sidebar-form",
                  );
                  Array.from(
                    collectionFiltersSidebar.querySelectorAll(".Collapsible"),
                  ).forEach(function (collapsible) {
                    var newCollapsible = newSidebarContent.querySelector(
                      '[data-filter-index="'.concat(
                        collapsible.getAttribute("data-filter-index"),
                        '"]',
                      ),
                    );
                    if (
                      collapsible.firstElementChild.getAttribute(
                        "aria-expanded",
                      ) === "true"
                    ) {
                      newCollapsible.style.overflow = "visible";
                      newCollapsible.firstElementChild.setAttribute(
                        "aria-expanded",
                        "true",
                      );
                      newCollapsible.lastElementChild.style.height = "auto";
                      newCollapsible.lastElementChild.style.overflow =
                        "visible";
                    }
                  });
                  collectionFiltersSidebar.innerHTML =
                    newSidebarContent.innerHTML;
                }
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                _this4._setupAnimation(!0);
                var elementOffset =
                  _this4.element
                    .querySelector(".CollectionMain")
                    .getBoundingClientRect().top -
                  parseInt(
                    document.documentElement.style.getPropertyValue(
                      "--header-height",
                    ),
                  );
                if (
                  Responsive.matchesBreakpoint("lap-and-up") &&
                  _this4.toolbarElement &&
                  _this4.toolbarElement.clientHeight === 0
                ) {
                  elementOffset -= 50;
                }
                const tempElementObj = $(tempElement);
                const groupListElem = tempElementObj.find("#group_list");
                if (groupListElem.length) {
                  const groupList = JSON.parse(
                    $(tempElement).find("#group_list").html() || "[]",
                  );
                  groupList.forEach((group_wrapper_item) => {
                    const group_wrapper_text = group_wrapper_item
                      .replace(/\r?\n|\r/g, "")
                      .trim();
                    if (group_wrapper_text) {
                      tempElementObj
                        .find(`.product-${group_wrapper_text}`)
                        .detach()
                        .appendTo(
                          $(`#${group_wrapper_text}`).find(
                            `.product-information`,
                          ),
                        );
                      tempElementObj
                        .find(`.color-dot-${group_wrapper_text}`)
                        .detach()
                        .appendTo(
                          $(`#${group_wrapper_text}`).find(`.color-dot-wrap`),
                        );
                      tempElementObj
                        .find(`.yoptpo-reviews-${group_wrapper_text}`)
                        .detach()
                        .appendTo(
                          $(`#${group_wrapper_text}`).find(
                            `.yoptpo-reviews-container`,
                          ),
                        );
                    }
                  });
                }
                // The group-list move above pulls product/color-dot/yotpo markup
                // out of the offscreen `tempElementObj` (the fetched copy), not
                // out of the live `.hide-all[data-group-list]` that the innerHTML
                // swap earlier in this handler just inserted into the page — so
                // that live copy still holds a full, unprocessed set of the same
                // `id="color_{{ product.id }}"` inputs already moved into the
                // grid above. Left in place, <label for="..."> resolves to
                // whichever match comes first in the DOM (the hide-all copy,
                // since it renders before the product grid), so clicking a
                // swatch in the visible grid silently toggles the invisible
                // duplicate instead of its own sibling. Empty it (not remove —
                // loadProductsFromPage's infinite-scroll guard checks that this
                // element still exists) now that its content has been used.
                var staleHideAll = _this4.collectionInnerElement.querySelector(
                  ".hide-all[data-group-list]",
                );
                if (staleHideAll) {
                  staleHideAll.innerHTML = "";
                }
                // The innerHTML swap above threw away the old [data-product-grid]
                // node along with whatever ProductGridBlock instance was bound to
                // it at page load, so its Flickity carousels (and the
                // breakpoint/color-dot listeners that (re)create them) are gone
                // for the freshly-inserted grid. Re-run that setup against the
                // new grid node — ProductGridBlock only wires itself up
                // automatically for a "single" grid type; for "grouped" (this
                // template) it normally waits for a one-time "products:grouped"
                // event that only fires on the original page load, so call
                // init() directly since the grouped markup above is already in
                // its final place by this point.
                var newProductGrid = _this4.collectionInnerElement.querySelector(
                  "[data-product-grid]",
                );
                if (newProductGrid) {
                  new ProductGridBlock(newProductGrid).init();
                }
                var wrapper = $(".Collapsible__Content-more-filters"),
                  items = wrapper.children(".Filter-Option"),
                  arr = [1, 2, 3, 0];
                items.detach();
                wrapper.append(
                  $.map(arr, function (v) {
                    return items[v];
                  }),
                );
                if (elementOffset < 0) {
                  window.scrollBy({ top: elementOffset, behavior: "smooth" });
                }

                document.dispatchEvent(
                  new CustomEvent("collection:filters:applied"),
                );
              });
            });
          } catch (exception) {}
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
          this.delegateElement.on(
            "click",
            '[data-action="change-layout-mode"]',
            this._changeLayoutModeListener,
          );
          this.delegateElement.on(
            "click",
            '[data-action="clear-filters"]',
            this._onFiltersCleared.bind(this),
          );
          this.delegateElement.on(
            "change",
            '[name^="filter."]',
            this._onFilterChanged.bind(this),
          );
          window.addEventListener("popstate", function (event) {
            if (event.state.path) {
              window.location.href = event.state.path;
            }
          });
        },
      },
    ]);
    return CollectionSection;
  })();
  var FaqSection = (function () {
    function FaqSection(element) {
      _classCallCheck(this, FaqSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this._attachListeners();
    }
    _createClass(FaqSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this._openItem(event.target);
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          this._closeItem(event.target);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            ".Faq__Question",
            this._toggleItem.bind(this),
          );
          this.delegateElement.on(
            "click",
            ".FaqSummary__Item",
            this._switchToCategory.bind(this),
          );
        },
      },
      {
        key: "_switchToCategory",
        value: function _switchToCategory(event, target) {
          target.classList.add("is-active");
          Dom.getSiblings(target, ".is-active").forEach(function (item) {
            item.classList.remove("is-active");
          });
        },
      },
      {
        key: "_toggleItem",
        value: function _toggleItem(event, target) {
          var item = target.closest(".Faq__Item");
          if (item.getAttribute("aria-expanded") === "true") {
            this._closeItem(item);
          } else {
            this._openItem(item);
          }
        },
      },
      {
        key: "_openItem",
        value: function _openItem(item) {
          var answerWrapper = item.querySelector(".Faq__AnswerWrapper");
          item.setAttribute("aria-expanded", "true");
          answerWrapper.setAttribute("aria-hidden", "false");
          Animation.slideDown(answerWrapper, !0);
          Dom.getSiblings(item, '[aria-expanded="true"]').forEach(
            function (siblingItem) {
              var siblingAnswerWrapper = siblingItem.querySelector(
                ".Faq__AnswerWrapper",
              );
              siblingItem.setAttribute("aria-expanded", "false");
              siblingAnswerWrapper.setAttribute("aria-hidden", "true");
              Animation.slideUp(siblingAnswerWrapper);
            },
          );
        },
      },
      {
        key: "_closeItem",
        value: function _closeItem(item) {
          var answerWrapper = item.querySelector(".Faq__AnswerWrapper");
          item.setAttribute("aria-expanded", "false");
          answerWrapper.setAttribute("aria-hidden", "true");
          Animation.slideUp(answerWrapper);
        },
      },
    ]);
    return FaqSection;
  })();
  var FeaturedCollectionsSection = (function () {
    function FeaturedCollectionsSection(container) {
      var _this = this;
      _classCallCheck(this, FeaturedCollectionsSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-settings"));
      this.carousels = [];
      Dom.nodeListToArray(
        this.element.querySelectorAll("[data-flickity-config]"),
      ).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });
      new ProductItemColorSwatch(this.element);
      this._setupAnimation();
      this._attachListeners();
    }
    _createClass(FeaturedCollectionsSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.carousels.forEach(function (item) {
            return item.destroy();
          });
          this.delegateElement.off("click");
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.element
            .querySelector('[aria-controls="'.concat(event.target.id, '"]'))
            .click();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="toggle-tab"]',
            this._switchTab.bind(this),
          );
        },
      },
      {
        key: "_switchTab",
        value: function _switchTab(event, target) {
          var _this2 = this;
          if (target.classList.contains("is-active")) {
            return;
          }
          target.classList.add("is-active");
          Dom.getSiblings(target, ".is-active").forEach(function (item) {
            item.classList.remove("is-active");
          });
          var tabPanelToShow = this.element.querySelector(
            "#".concat(target.getAttribute("aria-controls")),
          );
          this.timeline.eventCallback("onReverseComplete", function () {
            tabPanelToShow.setAttribute("aria-hidden", "false");
            Dom.getSiblings(
              tabPanelToShow,
              '.TabPanel[aria-hidden="false"]',
            ).forEach(function (item) {
              item.setAttribute("aria-hidden", "true");
            });
            if (Responsive.matchesBreakpoint("lap-and-up")) {
              _this2.carousels.forEach(function (carousel) {
                carousel.flickityInstance.activate();
                carousel.flickityInstance.resize();
              });
            }
            _this2.timeline.clear();
            _this2._setupAnimation();
          });
          if (
            this.options.layout === "grid" &&
            window.theme.showElementStaggering
          ) {
            this.timeline.reverse().timeScale(3);
          } else {
            this.timeline.reverse();
          }
        },
      },
      {
        key: "_setupAnimation",
        value: function _setupAnimation() {
          var _this3 = this;
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
          this.timeline = new TimelineLite({ delay: 0.5 });
          if (
            this.options.layout === "grid" &&
            window.theme.showElementStaggering
          ) {
            this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this),
            );
            Dom.nodeListToArray(
              this.element.querySelectorAll(
                '.TabPanel[aria-hidden="false"] .ProductList .ProductItem',
              ),
            ).forEach(function (item) {
              _this3.intersectionObserver.observe(item);
            });
          } else {
            var productList = this.element.querySelector(
              '.TabPanel[aria-hidden="false"] .ProductList',
            );
            if (productList) {
              this.timeline.fromTo(
                productList,
                0.6,
                { autoAlpha: 0, y: 25 },
                { autoAlpha: 1, y: 0 },
              );
            }
          }
        },
      },
      {
        key: "_reveal",
        value: function _reveal(results) {
          var _this4 = this;
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target);
              _this4.intersectionObserver.unobserve(result.target);
            }
          });
          if (toReveal.length === 0) {
            return;
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            { autoAlpha: 0, y: 25 },
            { autoAlpha: 1, y: 0 },
            0.2,
          );
        },
      },
    ]);
    return FeaturedCollectionsSection;
  })();
  var FeaturedProductSection = (function () {
    function FeaturedProductSection(container) {
      _classCallCheck(this, FeaturedProductSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );

      if (!this.options.usePlaceholder) {
        this.productVariants = new ProductVariants(container, this.options);
        this.productDots = new ProductDots(container, this.options);
        var packCont = this.element.querySelector(".pack-variant-options");
        if (packCont) {
          this.productPacks = new ProductPacks(container, this.options);
        }
      }
      var offscreenElement = this.element.querySelector(".Product__OffScreen");
      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }
      this._attachListeners();
    }
    _createClass(FeaturedProductSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");
          if (this.productVariants) {
            this.productVariants.destroy();
          }
          if (this.productDots) {
            this.productDots.destroy();
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "variant:changed",
            this._updateMainImage.bind(this),
          );
        },
      },
      {
        key: "_updateMainImage",
        value: function _updateMainImage(event) {
          var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;
          if (
            !variant ||
            !variant.featured_image ||
            (previousVariant.featured_image &&
              previousVariant.featured_image.id === variant.featured_image.id)
          ) {
            return;
          }
          var newImage = variant.featured_image;
          var mainImageContainer = this.element.querySelector(
            ".FeaturedProduct__Gallery .AspectRatio",
          );
          mainImageContainer.style.cssText = "max-width: "
            .concat(newImage.width, "px; --aspect-ratio: ")
            .concat(newImage.width / newImage.height);
          var newImageElement = document.createElement("img");
          newImageElement.classList.add("Image--lazyLoad");
          newImageElement.setAttribute(
            "data-src",
            Image.getSizedImageUrl(newImage.src, "1x1").replace(
              "_1x1.",
              "_{width}x.",
            ),
          );
          newImageElement.setAttribute(
            "data-widths",
            "[".concat(
              Image.getSupportedSizes(
                newImage,
                [200, 400, 600, 700, 800, 900, 1000],
              ).join(","),
              "]",
            ),
          );
          newImageElement.setAttribute("data-sizes", "auto");
          mainImageContainer.replaceChild(
            newImageElement,
            mainImageContainer.querySelector("img"),
          );
        },
      },
    ]);
    return FeaturedProductSection;
  })();
  var BackgroundVideoSection = (function () {
    function BackgroundVideoSection(container) {
      _classCallCheck(this, BackgroundVideoSection);
      this.element = container;
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      this._loadScript().then(this._setupPlayer.bind(this));
    }
    _createClass(BackgroundVideoSection, [
      {
        key: "_loadScript",
        value: function _loadScript() {
          var _this = this;
          return new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = !0;
            script.src =
              _this.options.videoType === "youtube"
                ? "//www.youtube.com/iframe_api"
                : "//player.vimeo.com/api/player.js";
          });
        },
      },
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.player) {
            this.player.destroy();
          }
        },
      },
      {
        key: "_setupPlayer",
        value: function _setupPlayer() {
          var _this2 = this;
          var elementToInsert = this.element.querySelector(
            ".ImageHero__VideoHolder",
          );
          var playerLoadingInterval = setInterval(function () {
            if (_this2.options.videoType === "youtube") {
              if (window.YT) {
                _this2.player = new YT.Player(elementToInsert, {
                  videoId: _this2.options.videoId,
                  playerVars: {
                    showinfo: 0,
                    controls: 0,
                    fs: 0,
                    rel: 0,
                    height: "100%",
                    width: "100%",
                    iv_load_policy: 3,
                    html5: 1,
                    loop: 1,
                    playsinline: 1,
                    modestbranding: 1,
                    disablekb: 1,
                    origin: _this2.options.requestHost,
                  },
                  events: {
                    onReady: _this2._onYouTubeReady.bind(_this2),
                    onStateChange: _this2._onYouTubeStateChange.bind(_this2),
                  },
                });
                clearInterval(playerLoadingInterval);
              }
            } else {
              if (window.Vimeo) {
                _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                  id: _this2.options.videoId,
                  autoplay: !0,
                  autopause: !1,
                  muted: !0,
                  background: !0,
                  loop: !0,
                });
                clearInterval(playerLoadingInterval);
              }
            }
          }, 50);
        },
      },
      {
        key: "_onYouTubeReady",
        value: function _onYouTubeReady(event) {
          this.player.mute();
          this.player.playVideo();
        },
      },
      {
        key: "_onYouTubeStateChange",
        value: function _onYouTubeStateChange(event) {
          if (event.data === YT.PlayerState.ENDED) {
            this.player.playVideo();
          }
        },
      },
    ]);
    return BackgroundVideoSection;
  })();
  var GiftCardSection = (function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);
      this.element = container;
      this._createQrCode();
      this._setupPrint();
    }
    _createClass(GiftCardSection, [
      {
        key: "_createQrCode",
        value: function _createQrCode() {
          var qrCodeElement = document.getElementById("QrCode");
          new QRCode(qrCodeElement, {
            text: qrCodeElement.getAttribute("data-identifier"),
            width: 120,
            height: 120,
          });
        },
      },
      {
        key: "_setupPrint",
        value: function _setupPrint() {
          var printElement = document.getElementById("PrintGiftCard");
          if (printElement) {
            printElement.addEventListener("click", function () {
              window.print();
            });
          }
        },
      },
    ]);
    return GiftCardSection;
  })();
  var HeaderSection = (function () {
    function HeaderSection(container) {
      var _this = this;
      _classCallCheck(this, HeaderSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      this.lastScrollPosition = -1;
      this.isTouch = window.matchMedia(
        "(-moz-touch-enabled: 1), (hover: none)",
      ).matches;
      if (this.options.isSticky) {
        Stickyfill.addOne(this.element.parentNode);
      }
      this.searchBar = new SearchBar();
      this._attachListeners();
      this._verifyNavigationOverlap();
      var mainLogo = this.element.querySelector(".Header__LogoImage--primary");
      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener("load", function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty(
              "--header-height",
              _this.element.clientHeight + "px",
            );
            document.documentElement.style.setProperty(
              "--header-is-not-transparent",
              _this.options.hasTransparentHeader ? 0 : 1,
            );
          });
        });
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty(
            "--header-height",
            _this.element.clientHeight + "px",
          );
          document.documentElement.style.setProperty(
            "--header-is-not-transparent",
            _this.options.hasTransparentHeader ? 0 : 1,
          );
        });
      }
      window.addEventListener(
        "pageshow",
        this._checkTransparentHeader.bind(this),
      );
      this._setupLocalizationPopovers();
    }
    _createClass(HeaderSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.element.removeEventListener(
            "mouseleave",
            this._closeNavigationListener,
          );
          this.element.removeEventListener(
            "mouseenter",
            this._focusNavigationListener,
          );
          this.element.removeEventListener(
            "focusin",
            this._focusNavigationListener,
          );
          this.delegateElement.off();
          window.removeEventListener(
            "scroll",
            this._checkTransparentHeaderListener,
          );
          window.removeEventListener(
            "resize",
            this._verifyNavigationOverlapListener,
          );
          if (this.options.isSticky) {
            Stickyfill.removeOne(this.element.parentNode);
          }
          this.searchBar.destroy();
          this.localizationPopovers.forEach(function (localizationPopover) {
            localizationPopover.destroy();
          });
        },
      },
      {
        key: "onSelect",
        value: function onSelect() {
          this._checkTransparentHeader();
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          var _this2 = this;
          var listItem = event.target.closest(".HorizontalList__Item");
          fastdom.mutate(function () {
            event.target.setAttribute("aria-hidden", "false");
            if (listItem) {
              listItem.classList.add("is-expanded");
              Dom.getSiblings(listItem, ".is-expanded").forEach(
                function (item) {
                  item.classList.remove("is-expanded");
                },
              );
            }
            _this2.element.classList.remove("Header--transparent");
          });
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          var listItem = event.target.closest(".HorizontalList__Item");
          fastdom.mutate(function () {
            event.target.setAttribute("aria-hidden", "true");
            if (listItem) {
              listItem.classList.remove("is-expanded");
            }
          });
          this._checkTransparentHeader();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._checkTransparentHeaderListener =
            this._checkTransparentHeader.bind(this);
          this._closeNavigationListener = this._closeNavigation.bind(this);
          this._focusNavigationListener = this._focusNavigation.bind(this);
          this._verifyNavigationOverlapListener =
            this._verifyNavigationOverlap.bind(this);
          this.element.addEventListener(
            "mouseleave",
            this._closeNavigationListener,
          );
          this.delegateElement.on(
            "mouseenter",
            // :not(a) so the trigger link, which now carries aria-haspopup,
            // is not treated as a panel container itself.
            ".Header__MainNav .HorizontalList__Item, [aria-haspopup]:not(a)",
            this._openMenu.bind(this),
            !0,
          );
          this.delegateElement.on(
            "focusin",
            "[data-has-panel]",
            this._openMenu.bind(this),
            !0,
          );
          this.delegateElement.on(
            "focusout",
            "[data-has-panel]",
            this._closeMenu.bind(this),
            !1,
          );
          this.delegateElement.on(
            "keydown",
            "[data-has-panel]",
            this._handleMenuKeydown.bind(this),
            !0,
          );
          this.delegateElement.on(
            "click",
            '[data-action="toggle-search"]',
            this._closeNavigationListener,
          );
          this.delegateElement.on(
            "mouseleave",
            ".DropdownMenu [aria-haspopup]",
            this._closeMenu.bind(this),
            !0,
          );
          this.delegateElement.on(
            "mouseenter",
            ".DropdownMenu [aria-haspopup]",
            this._adjustDropdownPosition.bind(this),
            !0,
          );
          if (this.isTouch) {
            this.delegateElement.on(
              "click",
              ".Header__MainNav [data-has-panel]",
              this._handleTouchMenu.bind(this),
            );
          }
          if (this.options.hasTransparentHeader) {
            this.element.addEventListener(
              "mouseenter",
              this._focusNavigationListener,
            );
            this.element.addEventListener(
              "focusin",
              this._focusNavigationListener,
            );
          }
          if (this.options.isSticky && this.options.hasTransparentHeader) {
            window.addEventListener(
              "scroll",
              this._checkTransparentHeaderListener,
            );
          }
          if (
            this.options.navigationStyle === "inline" ||
            this.options.navigationStyle === "logoLeft"
          ) {
            window.addEventListener(
              "resize",
              this._verifyNavigationOverlapListener,
            );
          }
        },
      },
      {
        key: "_setupLocalizationPopovers",
        value: function _setupLocalizationPopovers() {
          this.localizationPopovers = [];
          Dom.nodeListToArray(
            document.querySelectorAll("#header-locale-popover"),
          ).forEach(function (item, index) {
            item.id = "".concat(item.id, "-").concat(index);
          });
          Dom.nodeListToArray(
            document.querySelectorAll(
              '[aria-controls="header-locale-popover"]',
            ),
          ).forEach(function (item, index) {
            item.setAttribute(
              "aria-controls",
              "".concat(item.getAttribute("aria-controls"), "-").concat(index),
            );
          });
          Dom.nodeListToArray(
            document.querySelectorAll("#header-currency-popover"),
          ).forEach(function (item, index) {
            item.id = "".concat(item.id, "-").concat(index);
          });
          Dom.nodeListToArray(
            document.querySelectorAll(
              '[aria-controls="header-currency-popover"]',
            ),
          ).forEach(function (item, index) {
            item.setAttribute(
              "aria-controls",
              "".concat(item.getAttribute("aria-controls"), "-").concat(index),
            );
          });
          var localePopoverElement1 = document.getElementById(
            "header-locale-popover-0",
          );
          if (localePopoverElement1) {
            this.localizationPopovers.push(
              new Popover(localePopoverElement1, {
                preferredAlignment: "center",
                preferredPosition: "bottom",
                threshold: 12,
              }),
            );
          }
          var localePopoverElement2 = document.getElementById(
            "header-locale-popover-1",
          );
          if (localePopoverElement2) {
            this.localizationPopovers.push(
              new Popover(localePopoverElement2, {
                preferredAlignment: "center",
                preferredPosition: "bottom",
                threshold: 12,
              }),
            );
          }
          var currencyPopoverElement1 = document.getElementById(
            "header-currency-popover-0",
          );
          if (currencyPopoverElement1) {
            this.localizationPopovers.push(
              new Popover(currencyPopoverElement1, {
                preferredAlignment: "center",
                preferredPosition: "bottom",
                threshold: 12,
              }),
            );
          }
          var currencyPopoverElement2 = document.getElementById(
            "header-currency-popover-1",
          );
          if (currencyPopoverElement2) {
            this.localizationPopovers.push(
              new Popover(currencyPopoverElement2, {
                preferredAlignment: "center",
                preferredPosition: "bottom",
                threshold: 12,
              }),
            );
          }
        },
      },
      {
        key: "_focusNavigation",
        value: function _focusNavigation() {
          var _this3 = this;
          fastdom.mutate(function () {
            if (!_this3.isTouch || Responsive.matchesBreakpoint("desk")) {
              _this3.element.classList.remove("Header--transparent");
            }
          });
        },
      },
      {
        key: "_closeNavigation",
        value: function _closeNavigation() {
          var _this4 = this;
          fastdom.mutate(function () {
            Dom.nodeListToArray(
              _this4.element.querySelectorAll(".is-expanded"),
            ).forEach(function (item) {
              item.classList.remove("is-expanded");
            });
            Dom.nodeListToArray(
              _this4.element.querySelectorAll(
                '.Header__MainNav [aria-hidden="false"]',
              ),
            ).forEach(function (item) {
              item.setAttribute("aria-hidden", "true");
            });
            Dom.nodeListToArray(
              _this4.element.querySelectorAll(
                '.Header__MainNav a[aria-expanded="true"]',
              ),
            ).forEach(function (item) {
              item.setAttribute("aria-expanded", "false");
            });
          });
          if (this.options.hasTransparentHeader) {
            this._checkTransparentHeader();
          }
        },
      },
      {
        key: "_openMenu",
        value: function _openMenu(event, target) {
          if (event.type === "mouseenter" && target !== event.target) {
            return;
          }
          // Escape returns focus to the trigger, which fires focusin on this
          // same <li> and would reopen the panel Escape just closed.
          if (this._suppressOpenFor === target) {
            return;
          }
          fastdom.mutate(function () {
            target.classList.add("is-expanded");
            var trigger = target.querySelector(":scope > a[aria-haspopup]");
            if (trigger) {
              trigger.setAttribute("aria-expanded", "true");
            }
            Dom.nodeListToArray(
              target.children,
              '.Header__MainNav [aria-hidden="true"]',
            ).forEach(function (item) {
              item.setAttribute("aria-hidden", "false");
            });
            Dom.getSiblings(target, ".is-expanded").forEach(function (item) {
              item.classList.remove("is-expanded");
              var siblingTrigger = item.querySelector(
                ":scope > a[aria-haspopup]",
              );
              if (siblingTrigger) {
                siblingTrigger.setAttribute("aria-expanded", "false");
              }
              Dom.nodeListToArray(
                item.children,
                '.Header__MainNav [aria-hidden="false"]',
              ).forEach(function (item) {
                item.setAttribute("aria-hidden", "true");
              });
            });
          });
        },
      },
      {
        key: "_closeMenu",
        value: function _closeMenu(event, target) {
          if (event.type === "mouseleave" && target !== event.target) {
            return;
          }
          // focusout bubbles from descendants, so tabbing from the trigger into
          // its own panel fired close-then-reopen on every Tab and thrashed
          // aria-hidden. Ignore it while focus stays inside this item.
          if (
            event.type === "focusout" &&
            event.relatedTarget &&
            target.contains(event.relatedTarget)
          ) {
            return;
          }
          fastdom.mutate(function () {
            target.classList.remove("is-expanded");
            var trigger = target.querySelector(":scope > a[aria-haspopup]");
            if (trigger) {
              trigger.setAttribute("aria-expanded", "false");
            }
            Dom.nodeListToArray(
              target.children,
              '.Header__MainNav [aria-hidden="false"]',
            ).forEach(function (item) {
              item.setAttribute("aria-hidden", "true");
            });
          });
        },
      },
      {
        key: "_handleMenuKeydown",
        value: function _handleMenuKeydown(event, target) {
          if (event.key !== "Escape" && event.key !== "Esc") {
            return;
          }
          if (!target.classList.contains("is-expanded")) {
            return;
          }
          var trigger = target.querySelector(":scope > a[aria-haspopup]");
          // focus() fires focusin synchronously, so the suppression flag has to
          // be set around the call rather than relying on fastdom queue order.
          this._suppressOpenFor = target;
          if (trigger) {
            trigger.focus();
          }
          this._suppressOpenFor = null;
          this._closeMenu(event, target);
        },
      },
      {
        key: "_adjustDropdownPosition",
        value: function _adjustDropdownPosition(event, target) {
          var nestedMenus = Dom.nodeListToArray(
              target.querySelectorAll(".DropdownMenu"),
            ),
            shouldOpenLeft = !1;
          fastdom.measure(function () {
            var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right;
            nestedMenus.forEach(function (item) {
              if (rightEdge + item.offsetWidth > windowWidth) {
                shouldOpenLeft = !0;
              }
            });
          });
          fastdom.mutate(function () {
            if (shouldOpenLeft) {
              nestedMenus.forEach(function (item) {
                item.classList.add("DropdownMenu--reversed");
              });
            } else {
              nestedMenus.forEach(function (item) {
                item.classList.remove("DropdownMenu--reversed");
              });
            }
          });
        },
      },
      {
        key: "_handleTouchMenu",
        value: function _handleTouchMenu(event, target) {
          if (!target.classList.contains("is-expanded")) {
            event.preventDefault();
          }
        },
      },
      {
        key: "_verifyNavigationOverlap",
        value: function _verifyNavigationOverlap() {
          var _this5 = this;
          var isOverlapping = !1,
            mainTopMenu = this.element.querySelector(".Header__MainNav");
          fastdom.measure(function () {
            if (mainTopMenu) {
              var firstNavElementHeight = Dom.outerHeightWithMargin(
                  mainTopMenu.querySelector(".HorizontalList__Item"),
                ),
                mainNavHeight = mainTopMenu.scrollHeight;
              if (mainNavHeight > firstNavElementHeight) {
                isOverlapping = !0;
              }
            }
          });
          this.element.classList.remove(
            "Header--logoLeft",
            "Header--inline",
            "Header--center",
          );
          this.element.classList.add(
            "Header--".concat(this.options.navigationStyle),
          );
          this.element.clientWidth;
          fastdom.mutate(function () {
            if (isOverlapping) {
              _this5.element.classList.remove(
                "Header--".concat(_this5.options.navigationStyle),
              );
              _this5.element.classList.add("Header--center");
              if (mainTopMenu) {
                var itemTopSet = new Set();
                Array.from(
                  mainTopMenu.querySelectorAll(".HorizontalList__Item"),
                ).forEach(function (item) {
                  itemTopSet.add(item.getBoundingClientRect().top);
                });
                isOverlapping = itemTopSet.size > 1;
              }
            } else {
              _this5.element.classList.add(
                "Header--".concat(_this5.options.navigationStyle),
              );
              _this5.element.classList.remove("Header--center");
            }
            var logo = _this5.element.querySelector(".Header__FlexItem--logo");
            logo.classList.toggle(
              "Header__FlexItem--increaseSpace",
              isOverlapping,
            );
            _this5.element.classList.add("Header--initialized");
            fastdom.measure(function () {
              document.documentElement.style.setProperty(
                "--header-height",
                _this5.element.clientHeight + "px",
              );
            });
          });
        },
      },
      {
        key: "_checkTransparentHeader",
        value: function _checkTransparentHeader() {
          var _this6 = this;
          if (!this.options.hasTransparentHeader) {
            return;
          }
          var scrollThreshold = 10;
          fastdom.measure(function () {
            _this6.lastScrollPosition = window.pageYOffset;
          });
          fastdom.mutate(function () {
            if (_this6.lastScrollPosition <= scrollThreshold) {
              _this6.element.classList.add("Header--transparent");
            } else {
              _this6.element.classList.remove("Header--transparent");
            }
          });
        },
      },
    ]);
    return HeaderSection;
  })();
  var FooterSection = (function () {
    function FooterSection(container) {
      _classCallCheck(this, FooterSection);
      this.element = container;
      var localePopoverElement = document.getElementById(
        "footer-locale-popover",
      );
      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: "center",
          preferredPosition: "top",
          threshold: 12,
        });
      }
      var currencyPopoverElement = document.getElementById(
        "footer-currency-popover",
      );
      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: "center",
          preferredPosition: "top",
          threshold: 12,
        });
      }
    }
    _createClass(FooterSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.localePopover) {
            this.localePopover.destroy();
          }
          if (this.currencyPopover) {
            this.currencyPopover.destroy();
          }
        },
      },
    ]);
    return FooterSection;
  })();
  var ImageWithTextBlockSection = (function () {
    function ImageWithTextBlockSection(container) {
      _classCallCheck(this, ImageWithTextBlockSection);
      this.element = container;
    }
    _createClass(ImageWithTextBlockSection, [
      { key: "onUnload", value: function onUnload() {} },
    ]);
    return ImageWithTextBlockSection;
  })();
  var LoginSection = (function () {
    function LoginSection(container) {
      _classCallCheck(this, LoginSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.timelineLite = new TimelineLite();
      this.customerLoginForm = this.element.querySelector("#customer_login");
      this.recoverPasswordForm = this.element.querySelector(
        "#recover_customer_password",
      );
      this.delegateElement.on(
        "click",
        '[data-action="toggle-recover-form"]',
        this._showRecoverPassword.bind(this),
      );
    }
    _createClass(LoginSection, [
      {
        key: "_showRecoverPassword",
        value: function _showRecoverPassword() {
          var isLoginActive = this.customerLoginForm.style.display === "block";
          if (isLoginActive) {
            this.timelineLite
              .fromTo(
                this.customerLoginForm,
                0.5,
                { autoAlpha: 1, display: "block", y: 0 },
                { autoAlpha: 0, y: 20, display: "none" },
              )
              .fromTo(
                this.recoverPasswordForm,
                0.5,
                { autoAlpha: 0, display: "none", y: 20 },
                { autoAlpha: 1, display: "block", y: 0, delay: 0.25 },
              );
          } else {
            this.timelineLite
              .fromTo(
                this.recoverPasswordForm,
                0.5,
                { autoAlpha: 1, display: "block", y: 0 },
                { autoAlpha: 0, y: 20, display: "none" },
              )
              .fromTo(
                this.customerLoginForm,
                0.5,
                { autoAlpha: 0, display: "none", y: 20 },
                { autoAlpha: 1, display: "block", y: 0, delay: 0.25 },
              );
          }
        },
      },
    ]);
    return LoginSection;
  })();
  var MapSection = (function () {
    function MapSection(element) {
      _classCallCheck(this, MapSection);
      this.element = element;
      this.options = JSON.parse(element.getAttribute("data-section-settings"));
      if (this.options.apiKey && this.options.mapAddress) {
        this._loadScript().then(this._initMap.bind(this));
      }
    }
    _createClass(MapSection, [
      {
        key: "_loadScript",
        value: function _loadScript() {
          var _this = this;
          return new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = !0;
            script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(
              _this.options.apiKey,
            );
          });
        },
      },
      {
        key: "_initMap",
        value: function _initMap() {
          var _this2 = this;
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            { address: this.options.mapAddress },
            function (results, status) {
              if (status !== google.maps.GeocoderStatus.OK) {
                if (Shopify.designMode);
              } else {
                var mapOptions = {
                  zoom: _this2.options.zoom,
                  center: results[0].geometry.location,
                  draggable: !1,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                };
                var map = new google.maps.Map(
                    _this2.element.querySelector(".FeaturedMap__GMap"),
                    mapOptions,
                  ),
                  center = map.getCenter();
                map.setCenter(center);
                var icon = {
                  path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                  fillColor: _this2.options.markerColor,
                  fillOpacity: 1,
                  anchor: new google.maps.Point(15, 55),
                  strokeWeight: 0,
                  scale: 0.6,
                };
                new google.maps.Marker({
                  map: map,
                  position: map.getCenter(),
                  icon: icon,
                });
                var styledMapType = new google.maps.StyledMapType(
                  JSON.parse(
                    _this2.element.querySelector("[data-gmap-style]").innerHTML,
                  ),
                );
                map.mapTypes.set("styled_map", styledMapType);
                map.setMapTypeId("styled_map");
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(map, "resize");
                  map.setCenter(center);
                });
              }
            },
          );
        },
      },
    ]);
    return MapSection;
  })();
  var NewsletterPopupSection = (function () {
    function NewsletterPopupSection(element) {
      _classCallCheck(this, NewsletterPopupSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute("data-section-settings"));
      try {
        if (
          window.location.hash === "#newsletter-popup" &&
          window.theme.pageType !== null
        ) {
          this._openPopup();
        } else if (
          !this.options.showOnlyOnce ||
          (this.options.showOnlyOnce &&
            localStorage.getItem("themePopup") === null)
        ) {
          setTimeout(
            this._openPopup.bind(this),
            this.options.apparitionDelay * 1000,
          );
        }
      } catch (error) {}
      this._attachListeners();
    }
    _createClass(NewsletterPopupSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
        },
      },
      {
        key: "onSelect",
        value: function onSelect() {
          this._openPopup();
        },
      },
      {
        key: "onDeselect",
        value: function onDeselect() {
          this._closePopup();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="close-popup"]',
            this._closePopup.bind(this),
          );
        },
      },
      {
        key: "_openPopup",
        value: function _openPopup() {
          this.element.setAttribute("aria-hidden", "false");
          localStorage.setItem("themePopup", "true");
        },
      },
      {
        key: "_closePopup",
        value: function _closePopup() {
          this.element.setAttribute("aria-hidden", "true");
        },
      },
    ]);
    return NewsletterPopupSection;
  })();
  var ProductRecommendationsSection = (function () {
    function ProductRecommendationsSection(container) {
      _classCallCheck(this, ProductRecommendationsSection);
      this.element = container;
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      if (this.options.useRecommendations) {
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      } else {
        this._createSlideshow();
      }
    }
    _createClass(ProductRecommendationsSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (!this.carousel) return;
          this.carousel.destroy();
        },
      },
      {
        key: "_loadRecommendations",
        value: function _loadRecommendations() {
          var _this = this;
          var url = ""
            .concat(window.routes.productRecommendationsUrl, "?section_id=")
            .concat(
              this.element.getAttribute("data-section-id"),
              "&product_id=",
            )
            .concat(this.options.productId, "&limit=")
            .concat(this.options.recommendationsCount);
          return fetch(url).then(function (response) {
            return response.text().then(function (content) {
              var container = document.createElement("div");
              container.innerHTML = content;
              _this.element.querySelector(".ProductRecommendations").innerHTML =
                container.querySelector(".ProductRecommendations").innerHTML;
              // tracking.js starts the "PDP Recommended" impression tracking
              // on this — the cards only exist once the fetch has landed.
              _this.element.dispatchEvent(
                new CustomEvent("product-recommendations:loaded", {
                  bubbles: true,
                }),
              );
            });
          });
        },
      },
      {
        key: "_createSlideshow",
        value: function _createSlideshow() {
          var _this = this;
          var flickityElement = this.element.querySelector(
            "[data-flickity-config]",
          );
          if (!flickityElement) {
            return;
          }
          new ProductItemColorSwatch(this.element);
          setTimeout(() => {
            window.MarkdownPricePro.run();
            requestAnimationFrame(() => {
              window.MarkdownPricePro.run({ overwriteOthers: true, skipSubtract: true });
              requestAnimationFrame(() => {
                _this.carousel = new Carousel(flickityElement);
                // Trigger Yotpo to scan and render badges for the AJAX-loaded
                // recommendation cards — they were added after Yotpo's initial scan.
                onYotpoReady(function () {
                  var api = new Yotpo.API(yotpo);
                  api.refreshWidgets();
                });
                // ResizeObserver catches any height change (Yotpo badge injection,
                // etc.) after Flickity init and tells it to remeasure cell heights.
                if (window.ResizeObserver) {
                  var ro = new ResizeObserver(function () {
                    if (_this.carousel) _this.carousel.resize();
                  });
                  flickityElement.querySelectorAll(".Carousel__Cell").forEach(function (cell) {
                    ro.observe(cell);
                  });
                  // Disconnect after 10s — all async content should be loaded by then
                  setTimeout(function () { ro.disconnect(); }, 10000);
                }
              });
            });
          }, 100);
        },
      },
    ]);
    return ProductRecommendationsSection;
  })();
  var ProductSection = (function () {
    function ProductSection(container) {
      var _this = this;
      _classCallCheck(this, ProductSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]");
      this.productVariants = new ProductVariants(container, this.options);
      this.ProductDots = null;
      this.ProductSizes = null;

      if (themeVariables?.template != "product.gift-card") {
        this.productDots = new ProductDots(container, this.options);
        this.ProductSizes = new ProductSizes(container, this.options);
      }
      var packCont = this.element.querySelector(".pack-variant-options");
      try {
        if (packCont) {
          this.productPacks = new ProductPacks(container, this.options);
        }
      } catch (error) {
        console.log(error);
      }
      this.productReviews = new ProductReviews(container);
      var productSlideshowElement = this.element.querySelector(
        ".Product__Slideshow",
      );
      if (productSlideshowElement) {
        this.productSlideshow = new Carousel(
          productSlideshowElement,
          {
            onSelect: this._onImageChanged.bind(this),
            onSettle: this._onImageSettled.bind(this),
          },
          { draggable: !Responsive.matchesBreakpoint("supports-hover") },
        );
        this.mediaList = {};
        this.previouslySelectedMedia = null;
        productSlideshowElement
          .querySelectorAll('[data-media-type="model"]')
          .forEach(function (model) {
            _this.mediaList[model.getAttribute("data-media-id")] =
              new ProductModel(model, _this.options.stackProductImages);
          });
        productSlideshowElement
          .querySelectorAll(
            '[data-media-type="video"], [data-media-type="external_video"]',
          )
          .forEach(function (video) {
            _this.mediaList[video.getAttribute("data-media-id")] =
              new ProductVideo(
                video,
                _this.options.stackProductImages,
                _this.options.enableVideoLooping,
              );
          });
        if (this.options.stackProductImages) {
          this.slideshowNavDots = this.element.querySelector(
            ".Product__SlideshowNav--dots",
          );
          this.slideshowNavDotsItems = this.slideshowNavDots
            ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll("a"))
            : [];
        }
        if (this.options.showThumbnails) {
          this.slideshowNavThumbnails = this.element.querySelector(
            ".Product__SlideshowNav--thumbnails",
          );
          this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails
            ? Dom.nodeListToArray(
                this.slideshowNavThumbnails.querySelectorAll(
                  ".Product__SlideshowNavImage",
                ),
              )
            : [];
        }
        this.slideshowImages = Dom.nodeListToArray(
          productSlideshowElement.querySelectorAll(".Carousel__Cell"),
        );
        this._setupSlideshowMobileNav();
      }
      this.productWrapperElement =
        this.element.querySelector(".Product__Wrapper");
      this.productInfoElement = this.element.querySelector(".Product__Info");
      this.productAsideElement = this.element.querySelector(".Product__Aside");
      this.productGalleryElement =
        this.element.querySelector(".Product__Gallery");
      this.quickNav = this.element.querySelector(".Product__QuickNav");
      if (this.options.enableImageZoom) {
        this.imageZoomInstance = new ProductImageZoom(
          this.element,
          this.productSlideshow,
        );
      }
      Stickyfill.addOne(this.productInfoElement);
      var offscreenElement = this.element.querySelector(".Product__OffScreen");
      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }
      this._setupDeviceFeatures();
      this._attachListeners();
    }
    _createClass(ProductSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");
          this.productReviews.destroy();
          if (this.productVariants) {
            this.productVariants.destroy();
          }
          if (this.productDots) {
            this.productDots.destroy();
          }
          if (this.ProductSizes) {
            this.ProductSizes.destroy();
          }
          if (this.productSlideshow) {
            this.productSlideshow.destroy();
          }
          if (this.options.enableImageZoom) {
            this.imageZoomInstance.destroy();
          }
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }
          if (this.quickNav) {
            window.removeEventListener("scroll", this._checkQuickNavListener);
          }
          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }
          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }
          if (window.ResizeObserver && this.productInfoResizeObserver) {
            this.productInfoResizeObserver.disconnect();
          }
          Stickyfill.removeOne(this.productInfoElement);
          document.removeEventListener(
            "breakpoint:changed",
            this._onBreakpointChangedListener,
          );
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onBreakpointChangedListener =
            this._setupDeviceFeatures.bind(this);
          this._checkQuickNavListener = this._checkQuickNav.bind(this);
          this.delegateElement.on(
            "click",
            '[data-action="toggle-social-share"]',
            this._toggleSocialShare.bind(this),
          );
          this.delegateElement.on(
            "variant:changed",
            this._updateSlideshowImage.bind(this),
          );
          this.delegateElement.on(
            "scrollspy:target:changed",
            this._onScrollTargetChanged.bind(this),
          );
          this.delegateElement.on(
            "click",
            ".acc__title",
            this._onAccordionChanged.bind(this),
          );
          this.delegateElement.on(
            "keydown",
            ".acc__title",
            this._onAccordionKeydown.bind(this),
          );
          this._setupAccordionAccessibility();
          this.delegateElement.on(
            "model:played",
            this._onMediaPlayed.bind(this),
          );
          this.delegateElement.on(
            "video:played",
            this._onMediaPlayed.bind(this),
          );
          this.delegateElement.on(
            "model:paused",
            this._onMediaPaused.bind(this),
          );
          this.delegateElement.on(
            "video:paused",
            this._onMediaPaused.bind(this),
          );
          this.delegateElement.on(
            "click",
            'button[data-action="add-to-bag"]',
            this.addToBag.bind(this),
          );
          document.addEventListener(
            "breakpoint:changed",
            this._onBreakpointChangedListener,
          );
          if (this.quickNav) {
            window.addEventListener("scroll", this._checkQuickNavListener);
          }
          if (!this.options.stackProductImages && this.options.showThumbnails) {
            this.delegateElement.on(
              "click",
              ".Product__SlideshowNavImage",
              this._switchToImage.bind(this),
            );
          }
        },
      },
      {
        key: "_setupSlideshowMobileNav",
        value: function _setupSlideshowMobileNav() {
          var _this2 = this;
          this.slideshowMobileNav = this.element.querySelector(
            ".Product__SlideshowMobileNav",
          );
          if (this.slideshowMobileNav) {
            var slideshowMobileNavDelegate = new domDelegate.Delegate(
              this.slideshowMobileNav,
            );
            slideshowMobileNavDelegate.on(
              "click",
              ".dot",
              function (event, element) {
                _this2._slideWillChange();
                _this2.productSlideshow.selectCell(
                  parseInt(element.getAttribute("data-index")),
                );
              },
            );
            slideshowMobileNavDelegate.on(
              "click",
              ".Product__SlideshowNavArrow",
              function (event, element) {
                _this2._slideWillChange();
                if (element.getAttribute("data-direction") === "next") {
                  _this2.productSlideshow.next();
                } else {
                  _this2.productSlideshow.previous();
                }
              },
            );
          }
        },
      },
      {
        key: "_updateSlideshowImage",
        value: function _updateSlideshowImage(event) {
          var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;
          if (
            !variant ||
            !variant.featured_media ||
            (previousVariant &&
              previousVariant.featured_media &&
              previousVariant.featured_media.id === variant.featured_media.id)
          ) {
            return;
          }
          this._slideWillChange();
          if (
            Responsive.matchesBreakpoint("pocket") ||
            !this.options.stackProductImages
          ) {
            for (
              var i = 0;
              i !== this.productSlideshow.flickityInstance.cells.length;
              ++i
            ) {
              var cellElement =
                  this.productSlideshow.flickityInstance.cells[i].element,
                mediaId = parseInt(cellElement.getAttribute("data-media-id"));
              if (mediaId === variant.featured_media.id) {
                this.productSlideshow.selectCell(
                  parseInt(cellElement.getAttribute("data-media-position")) - 1,
                );
              }
            }
          } else {
            document
              .querySelector(
                '[href="#Media'.concat(variant.featured_media.id, '"]'),
              )
              .click();
          }
        },
      },
      {
        key: "_onMediaPlayed",
        value: function _onMediaPlayed(event) {
          this.productSlideshow.getFlickityInstance().options.draggable = !1;
          this.productSlideshow.getFlickityInstance().unbindDrag();
          if (
            this.previouslySelectedMedia &&
            this.previouslySelectedMedia !== event.target
          ) {
            this.mediaList[
              this.previouslySelectedMedia.getAttribute("data-media-id")
            ].hasBeenDeselected();
          }
          if (this.options.stackProductImages) {
            this.previouslySelectedMedia = event.target;
          }
        },
      },
      {
        key: "_onMediaPaused",
        value: function _onMediaPaused() {
          this.productSlideshow.getFlickityInstance().options.draggable =
            !Responsive.matchesBreakpoint("supports-hover");
          this.productSlideshow.getFlickityInstance().bindDrag();
        },
      },
      {
        key: "_handleMedia",
        value: function _handleMedia(item) {
          if (
            this.previouslySelectedMedia &&
            this.previouslySelectedMedia !== item
          ) {
            switch (
              this.previouslySelectedMedia.getAttribute("data-media-type")
            ) {
              case "video":
              case "external_video":
              case "model":
                this.mediaList[
                  this.previouslySelectedMedia.getAttribute("data-media-id")
                ].hasBeenDeselected();
            }
            if (
              this.previouslySelectedMedia.getAttribute("data-media-type") ===
                "model" &&
              this.viewInSpaceElement
            ) {
              this.viewInSpaceElement.setAttribute(
                "data-shopify-model3d-id",
                this.viewInSpaceElement.getAttribute(
                  "data-shopify-model3d-default-id",
                ),
              );
            }
          }
          switch (item.getAttribute("data-media-type")) {
            case "video":
            case "external_video":
            case "model":
              this.mediaList[
                item.getAttribute("data-media-id")
              ].hasBeenSelected();
              break;
          }
          if (
            item.getAttribute("data-media-type") === "model" &&
            this.viewInSpaceElement
          ) {
            this.viewInSpaceElement.setAttribute(
              "data-shopify-model3d-id",
              item.getAttribute("data-media-id"),
            );
          }
          this.previouslySelectedMedia = item;
        },
      },
      {
        key: "_onScrollTargetChanged",
        value: function _onScrollTargetChanged(event) {
          if (this.options.stackProductImages) {
            this.slideshowNavDotsItems.forEach(function (item) {
              return item.classList.remove("is-selected");
            });
            this.slideshowNavDotsItems[
              parseInt(
                event.detail.newTarget.getAttribute("data-media-position"),
              ) - 1
            ].classList.add("is-selected");
            if (this.options.showThumbnails) {
              this.slideshowNavThumbnailsItems.forEach(function (item) {
                return item.classList.remove("is-selected");
              });
              this.slideshowNavThumbnailsItems[
                parseInt(
                  event.detail.newTarget.getAttribute("data-media-position"),
                ) - 1
              ].classList.add("is-selected");
            }
          }
        },
      },
      {
        key: "_onAccordionChanged",
        value: function _onAccordionChanged(event, target) {
          var dropDown = $(target).closest(".acc__card").find(".acc__panel");
          $(target)
            .closest(".acc")
            .find(".acc__panel")
            .not(dropDown)
            .slideUp();
          $(target)
            .closest(".acc")
            .find(".acc__title")
            .not(target)
            .removeClass("active")
            .attr("aria-expanded", "false");
          if ($(target).hasClass("active")) {
            $(target).removeClass("active").attr("aria-expanded", "false");
          } else {
            $(target).addClass("active").attr("aria-expanded", "true");
          }
          dropDown.stop(!1, !0).slideToggle();
        },
      },
      {
        key: "_onAccordionKeydown",
        value: function _onAccordionKeydown(event, target) {
          if (
            event.key === "Enter" ||
            event.key === " " ||
            event.keyCode === 13 ||
            event.keyCode === 32
          ) {
            event.preventDefault();
            this._onAccordionChanged(event, target);
          }
        },
      },
      {
        key: "_setupAccordionAccessibility",
        value: function _setupAccordionAccessibility() {
          var sectionId = this.element.id || "product-section";
          $(this.element)
            .find(".acc__title")
            .each(function (index) {
              var $title = $(this);
              var $panel = $title.closest(".acc__card").find(".acc__panel");
              var panelId = sectionId + "-acc-panel-" + index;
              $panel.attr("id", panelId);
              $title.attr({
                role: "button",
                tabindex: "0",
                "aria-controls": panelId,
                "aria-expanded": $title.hasClass("active") ? "true" : "false",
              });
            });
        },
      },
      {
        key: "_switchToImage",
        value: function _switchToImage(event, target) {
          event.preventDefault();
          this._slideWillChange();
          for (
            var i = 0;
            i !== this.productSlideshow.flickityInstance.cells.length;
            ++i
          ) {
            var cellElement =
                this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute("data-media-id"));
            if (mediaId === parseInt(target.getAttribute("data-media-id"))) {
              this.productSlideshow.selectCell(
                parseInt(cellElement.getAttribute("data-media-position")) - 1,
              );
            }
          }
        },
      },
      {
        key: "_checkQuickNav",
        value: function _checkQuickNav() {
          var _this3 = this;
          var showAsideQuickNav = !1;
          fastdom.measure(function () {
            showAsideQuickNav =
              window.scrollY >=
              _this3.productAsideElement.offsetTop -
                _this3.productAsideElement.clientHeight;
          });
          fastdom.mutate(function () {
            if (showAsideQuickNav) {
              _this3.quickNav.classList.add("is-flipped");
            } else {
              _this3.quickNav.classList.remove("is-flipped");
            }
          });
        },
      },
      {
        key: "_toggleSocialShare",
        value: function _toggleSocialShare(event, target) {
          target.classList.toggle("is-active");
          target.classList.toggle("RoundButton--secondaryState");
          target.setAttribute(
            "aria-expanded",
            target.getAttribute("aria-expanded") === "true" ? "false" : "true",
          );
          target.nextElementSibling.setAttribute(
            "aria-hidden",
            target.nextElementSibling.getAttribute("aria-hidden") === "true"
              ? "false"
              : "true",
          );
        },
      },
      {
        key: "_onImageChanged",
        value: function _onImageChanged(event, cell) {
          if (Responsive.matchesBreakpoint("pocket")) {
            var productGalleryActionListElement = this.element.querySelector(
              ".Product__Gallery .Product__ActionList",
            );
            if (productGalleryActionListElement) {
              if (cell.classList.contains("Product__SlideItem--image")) {
                productGalleryActionListElement.classList.remove("is-hidden");
              } else {
                productGalleryActionListElement.classList.add("is-hidden");
              }
            }
          }
          if (!this.options.stackProductImages && this.options.showThumbnails) {
            var mediaId = cell.getAttribute("data-media-id");
            this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
              if (thumbnail.getAttribute("data-media-id") === mediaId) {
                thumbnail.classList.add("is-selected");
              } else {
                thumbnail.classList.remove("is-selected");
              }
            });
          }
          if (this.slideshowMobileNav) {
            var selectedIndex =
              parseInt(cell.getAttribute("data-media-position")) - 1;
            Dom.nodeListToArray(
              this.slideshowMobileNav.querySelectorAll(".dot"),
            ).forEach(function (item, index) {
              if (index === selectedIndex) {
                item.classList.add("is-selected");
              } else {
                item.classList.remove("is-selected");
              }
            });
          }
        },
      },
      {
        key: "_onImageSettled",
        value: function _onImageSettled(index, cell) {
          this._handleMedia(cell);
          if (Responsive.matchesBreakpoint("lap-and-up")) {
            var slides = this.element.querySelectorAll(
              ".Product__SlideItem:not(.is-selected)",
            );
            slides.forEach(function (slide) {
              slide.classList.add("Product__SlideItem--hidden");
            });
          }
        },
      },
      {
        key: "_slideWillChange",
        value: function _slideWillChange() {
          if (Responsive.matchesBreakpoint("lap-and-up")) {
            var slides = this.element.querySelectorAll(".Product__SlideItem");
            slides.forEach(function (slide) {
              slide.classList.remove("Product__SlideItem--hidden");
            });
          }
        },
      },
      {
        key: "addToBag",
        value: function addToBag(event) {
          var _this4 = this;
          if (!this.options.useAjaxCart) {
            return;
          }
          event.preventDefault();
          var addToCartButton = event.srcElement;
          var variant_id = addToCartButton.dataset.variantId;
          addToCartButton.setAttribute("disabled", "disabled");
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          var _priceAbProps =
            typeof getPriceAbLineItemProperties === "function"
              ? getPriceAbLineItemProperties()
              : {
                  _price_ab: document.body.classList.contains("price-ab-regular")
                    ? "b"
                    : "a",
                  _customer_type:
                    document.body.classList.contains("show-retention-banner") ||
                    /(?:^|; )WW_PR_kStatus=/.test(document.cookie)
                      ? "RET"
                      : "ACQ",
                };
          // Labor Day: tag eligible items with `_labor_day: 1` at add time so
          // the checkout rule can target them — done in the add request itself
          // to avoid a follow-up /cart/change.js call. Eligible = this product
          // is currently showing the 25% markdown badge in its section.
          // try {
          //   var _laborBadge = _this4.element.querySelector(".discount-label");
          //   if (_laborBadge && /\b25\b/.test(_laborBadge.textContent || "")) {
          //     _priceAbProps._labor_day = "1";
          //   }
          // } catch (e) {}
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify({
              items: [
                {
                  id: variant_id,
                  quantity: 1,
                  properties: _priceAbProps,
                },
              ],
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            if (response.ok) {
              addToCartButton.removeAttribute("disabled");
              response.json().then(function (product) {
                _this4.element.dispatchEvent(
                  new CustomEvent("product:added", {
                    bubbles: !0,
                    detail: { product, variant: variant_id, quantity: 1 },
                  }),
                );
              });
            } else {
              response.json().then(function (content) {
                addToCartButton.removeAttribute("disabled");
                addToCartButton.insertAdjacentElement(
                  "afterend",
                  errorMessageElement,
                );
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
          event.preventDefault();
        },
      },
      {
        key: "_setupDeviceFeatures",
        value: function _setupDeviceFeatures(event) {
          var _this4 = this;
          var currentBreakpoint = event
              ? event.detail.currentBreakpoint
              : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;
          if (currentBreakpoint === previousBreakpoint) {
            return;
          }
          if (currentBreakpoint === "phone" || currentBreakpoint === "tablet") {
            if (this.carouselNavScrollSpy) {
              this.carouselNavScrollSpy.destroy();
            }
            if (this.productInfoScroller) {
              this.productInfoScroller.destroy();
            }
            if (this.productThumbnailsScroller) {
              this.productThumbnailsScroller.destroy();
            }
            if (this.productAsideElement) {
              this.productAsideElement.style.minHeight = null;
            } else {
              this.productWrapperElement.style.minHeight = null;
            }
            this.productInfoElement.parentNode.style.maxHeight = null;
          } else {
            if (this.slideshowImages && this.slideshowImages.length > 1) {
              var offsetTop = 0;
              if (this.options.stackProductImages && this.slideshowNavDots) {
                offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
              }
              if (
                this.options.showThumbnails &&
                Responsive.matchesBreakpoint("desk")
              ) {
                offsetTop = 250;
              }
              this.carouselNavScrollSpy = new ScrollSpy(
                this.element,
                this.slideshowImages,
                { rootMargin: "-".concat(offsetTop, "px 0px 0px 0px") },
              );
            }
            var productInfoStyles = window.getComputedStyle(
                this.productInfoElement,
              ),
              productInfoPadding =
                parseInt(productInfoStyles.paddingTop) +
                parseInt(productInfoStyles.paddingBottom),
              productGalleryHeight = this.productGalleryElement
                ? parseInt(this.productGalleryElement.scrollHeight)
                : 0;
            var calculateMinHeight = function calculateMinHeight() {
              if (_this4.productAsideElement) {
                _this4.productAsideElement.style.minHeight = "".concat(
                  _this4.productInfoElement.scrollHeight -
                    productInfoPadding -
                    productGalleryHeight,
                  "px",
                );
                _this4.productInfoElement.closest(
                  ".Product__InfoWrapper",
                ).style.maxHeight =
                  _this4.productAsideElement.offsetTop +
                  _this4.productInfoElement.scrollHeight -
                  productInfoPadding +
                  "px";
              } else {
                _this4.productWrapperElement.style.minHeight = "".concat(
                  _this4.productInfoElement.scrollHeight -
                    parseInt(productInfoStyles.paddingTop),
                  "px",
                );
              }
            };
            calculateMinHeight();
            if (window.ResizeObserver) {
              this.productInfoResizeObserver = new ResizeObserver(function () {
                calculateMinHeight();
              });
              this.productInfoResizeObserver.observe(this.productInfoElement);
            }
            this.productInfoScroller = new OverflowScroller(
              this.productInfoElement,
            );
            if (this.options.showThumbnails && this.slideshowNavThumbnails) {
              this.productThumbnailsScroller = new OverflowScroller(
                this.slideshowNavThumbnails,
              );
            }
          }
        },
      },
    ]);
    return ProductSection;
  })();
  var RecentlyViewedProductsSection = (function () {
    function RecentlyViewedProductsSection(container) {
      _classCallCheck(this, RecentlyViewedProductsSection);
      this.element = container;
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings"),
      );
      new ProductItemColorSwatch(this.element);
      this._fetchProducts();
    }
    _createClass(RecentlyViewedProductsSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.carousel) {
            this.carousel.destroy();
          }
        },
      },
      {
        key: "_fetchProducts",
        value: function _fetchProducts() {
          var _this = this;
          var queryString = this._getSearchQueryString();
          if (queryString === "") {
            return;
          }
          fetch(
            ""
              .concat(window.routes.searchUrl, "?section_id=")
              .concat(
                this.element.getAttribute("data-section-id"),
                "&type=product&q=",
              )
              .concat(queryString),
            { credentials: "same-origin", method: "GET" },
          ).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement("div");
              tempElement.innerHTML = content;
              _this.element.innerHTML =
                tempElement.querySelector(".Section").innerHTML;
              _this.element.parentNode.style.display = "block";
              _this.carousel = new Carousel(
                _this.element.querySelector("[data-flickity-config]"),
              );
            });
          });
        },
      },
      {
        key: "_getSearchQueryString",
        value: function _getSearchQueryString() {
          var items = JSON.parse(
            localStorage.getItem("recentlyViewedProducts") || "[]",
          );
          if (items.includes(this.options.productId)) {
            items.splice(items.indexOf(this.options.productId), 1);
          }
          return items
            .map(function (item) {
              return "id:" + item;
            })
            .join(" OR ");
        },
      },
    ]);
    return RecentlyViewedProductsSection;
  })();
  var SectionContainer = (function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);
      this.constructors = [];
      this.instances = [];
      this._attachListeners();
    }
    _createClass(SectionContainer, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this),
          );
          document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this),
          );
          document.addEventListener(
            "shopify:section:reload",
            this._reload.bind(this),
          );
          document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this),
          );
          document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this),
          );
          document.addEventListener(
            "shopify:section:reorder",
            this._onReorder.bind(this),
          );
          document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this),
          );
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this),
          );
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this),
          );
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this),
          );
        },
      },
      {
        key: "register",
        value: function register(type, constructor) {
          var _this = this;
          this.constructors[type] = constructor;
          Dom.nodeListToArray(
            document.querySelectorAll("[data-section-type=".concat(type, "]")),
          ).forEach(function (container) {
            _this._createInstance(container, constructor);
          });
        },
      },
      {
        key: "_reload",
        value: function _reload(event) {
          var _this = this;
          var sections = event.detail.sections;
          if (!sections.length) {
            return;
          }
          sections.forEach(function (section) {
            var container = document.querySelector(
              "[data-section-type=".concat(section, "]"),
            );
            if (!container) {
              return;
            }
            document.dispatchEvent(
              new CustomEvent("shopify:section:unload", {
                detail: { sectionId: container.dataset.sectionId },
              }),
            );
            setTimeout(function () {
              _this.register(section, _this.constructors[section]);
              if (
                section === "product" ||
                section === "product-recommendations"
              ) {
                onYotpoReady(() => {
                  var api = new Yotpo.API(yotpo);
                  api.refreshWidgets();
                });
              }
            }, 100);

            document.dispatchEvent(
              new CustomEvent("shopify:section:reloaded", {
                detail: {
                  section,
                  container,
                },
              }),
            );
          });
        },
      },
      {
        key: "_findInstance",
        value: function _findInstance(array, key, value) {
          for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return array[i];
            }
          }
        },
      },
      {
        key: "_removeInstance",
        value: function _removeInstance(array, key, value) {
          var i = array.length;
          while (i--) {
            if (array[i][key] === value) {
              array.splice(i, 1);
              break;
            }
          }
          return array;
        },
      },
      {
        key: "_onSectionLoad",
        value: function _onSectionLoad(event) {
          var container = event.target.querySelector("[data-section-id]");
          if (container) {
            this._createInstance(container);
          }
        },
      },
      {
        key: "_onSectionUnload",
        value: function _onSectionUnload(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (!instance) {
            return;
          }
          if (typeof instance.onUnload === "function") {
            instance.onUnload(event);
          }
          this.instances = this._removeInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
        },
      },
      {
        key: "_onSelect",
        value: function _onSelect(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (instance && typeof instance.onSelect === "function") {
            instance.onSelect(event);
          }
        },
      },
      {
        key: "_onDeselect",
        value: function _onDeselect(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (instance && typeof instance.onDeselect === "function") {
            instance.onDeselect(event);
          }
        },
      },
      {
        key: "_onReorder",
        value: function _onReorder(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (instance && typeof instance.onReorder === "function") {
            instance.onReorder(event);
          }
        },
      },
      {
        key: "_onBlockSelect",
        value: function _onBlockSelect(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (instance && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(event);
          }
        },
      },
      {
        key: "_onBlockDeselect",
        value: function _onBlockDeselect(event) {
          var instance = this._findInstance(
            this.instances,
            "id",
            event.detail.sectionId,
          );
          if (instance && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(event);
          }
        },
      },
      {
        key: "_createInstance",
        value: function _createInstance(container, constructor) {
          var id = container.getAttribute("data-section-id"),
            type = container.getAttribute("data-section-type");
          constructor = constructor || this.constructors[type];
          if (typeof constructor === "undefined") {
            return;
          }
          var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container,
          });
          this.instances.push(instance);
        },
      },
    ]);
    return SectionContainer;
  })();
  var SearchSection = (function () {
    function SearchSection(container) {
      _classCallCheck(this, SearchSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this._setupAnimation();
    }
    _createClass(SearchSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        },
      },
      {
        key: "_setupAnimation",
        value: function _setupAnimation() {
          var _this = this;
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
          this.timeline = new TimelineLite({ delay: 0.5 });
          if (window.theme.showElementStaggering) {
            this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this),
            );
            Dom.nodeListToArray(
              this.element.querySelectorAll(
                ".ProductList .ProductItem, .ArticleList .ArticleItem",
              ),
            ).forEach(function (item) {
              _this.intersectionObserver.observe(item);
            });
          }
        },
      },
      {
        key: "_reveal",
        value: function _reveal(results) {
          var _this2 = this;
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target);
              _this2.intersectionObserver.unobserve(result.target);
            }
          });
          if (toReveal.length === 0) {
            return;
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.6,
            { autoAlpha: 0, y: 25 },
            { autoAlpha: 1, y: 0 },
            0.2,
          );
        },
      },
    ]);
    return SearchSection;
  })();
  var ShopNowSection = (function () {
    function ShopNowSection(container) {
      _classCallCheck(this, ShopNowSection);
      this.element = container;
      this.carousel = new Carousel(
        this.element.querySelector("[data-flickity-config]"),
      );
      new ProductItemColorSwatch(this.element);
    }
    _createClass(ShopNowSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.carousel.destroy();
        },
      },
    ]);
    return ShopNowSection;
  })();
  var ShopTheLookSection = (function () {
    function ShopTheLookSection(container) {
      _classCallCheck(this, ShopTheLookSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.usePocketMode = Responsive.matchesBreakpoint("pocket");
      this.pocketActivatorButton = this.element.querySelector(
        '[data-action="open-look"]',
      );
      this._createOuterCarousel();
      this._createPocketPopovers();
      this._attachListeners();
    }
    _createClass(ShopTheLookSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.outerCarousel.destroy();
          this.innerCarousels.forEach(function (item) {
            item.forEach(function (innerItem) {
              return innerItem.destroy();
            });
          });
          this.popovers.forEach(function (item) {
            return item.destroy();
          });
          this.delegateElement.off();
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.outerCarousel.selectCell(
            event.target.getAttribute("data-slide-index"),
            !0,
            !event.detail.load,
          );
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            ".ShopTheLook__Dot",
            this._onDotClicked.bind(this),
          );
        },
      },
      {
        key: "_createPocketPopovers",
        value: function _createPocketPopovers() {
          var _this = this;
          this.popovers = [];
          Dom.nodeListToArray(
            this.element.querySelectorAll(".Popover"),
          ).forEach(function (popover) {
            _this.popovers.push(
              new Popover(popover, {
                activator: _this.pocketActivatorButton,
                showOverlay: !1,
                onOpen: _this._openPocketZoom.bind(_this),
                onClose: _this._closePocketZoom.bind(_this),
              }),
            );
          });
        },
      },
      {
        key: "_createOuterCarousel",
        value: function _createOuterCarousel() {
          var _this2 = this;
          this.outerCarousel = new Carousel(
            this.element.querySelector(".ShopTheLook"),
            { onSelect: this._onLookChanged.bind(this) },
          );
          this.innerCarousels = new Array(
            this.outerCarousel.flickityInstance.cells.length,
          );
          for (var i = 0; i !== this.innerCarousels.length; ++i) {
            this.innerCarousels[i] = [];
          }
          Dom.nodeListToArray(
            this.element.querySelectorAll(".ShopTheLook__ProductList"),
          ).forEach(function (item) {
            var lookIndex = parseInt(item.getAttribute("data-look-index"));
            _this2.innerCarousels[lookIndex].push(
              new Carousel(item, {
                onSelect: _this2._onProductChanged.bind(_this2),
              }),
            );
            item.insertBefore(
              item.querySelector(".flickity-viewport"),
              item.querySelector(".ShopTheLook__ViewButton"),
            );
          });
          this.outerCarousel.resize();
        },
      },
      {
        key: "_onLookChanged",
        value: function _onLookChanged(selectedIndex, selectedCell) {
          this.pocketActivatorButton.setAttribute(
            "aria-controls",
            "".concat(selectedCell.getAttribute("id"), "-popover"),
          );
        },
      },
      {
        key: "_onProductChanged",
        value: function _onProductChanged(selectedIndex, selectedCell) {
          var lookItem = this.outerCarousel.getSelectedCell(),
            activeDot = null;
          Dom.nodeListToArray(
            lookItem.querySelectorAll(".ShopTheLook__Dot"),
          ).forEach(function (dot, index) {
            dot.classList.remove("is-active");
            if (index === selectedIndex) {
              dot.classList.add("is-active");
              activeDot = dot;
            }
          });
          lookItem
            .querySelector(".ShopTheLook__ViewButton")
            .setAttribute(
              "href",
              selectedCell.getAttribute("data-product-url"),
            );
          lookItem.dispatchEvent(
            new CustomEvent("product:changed", { detail: { dot: activeDot } }),
          );
        },
      },
      {
        key: "_onDotClicked",
        value: function _onDotClicked(event, target) {
          var shouldAnimateCarousel = !1,
            hasOnePopoverOpen = !1,
            lookIndex = this.outerCarousel.getSelectedIndex();
          this.popovers.forEach(function (item) {
            if (item.isOpen) {
              hasOnePopoverOpen = !0;
              shouldAnimateCarousel = !0;
            }
          });
          this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
            innerCarousel.selectCell(
              parseInt(target.getAttribute("data-product-index")) - 1,
              !1,
              shouldAnimateCarousel,
            );
          });
          if (this.usePocketMode && !hasOnePopoverOpen) {
            this.popovers[lookIndex].open();
          }
        },
      },
      {
        key: "_openPocketZoom",
        value: function _openPocketZoom(popover) {
          var _this3 = this;
          this._calculateImageTransform(popover);
          fastdom.mutate(function () {
            document.getElementById("shopify-section-header").style.cssText =
              "transform: translateY(-100%); transition: transform 0.3s ease-in-out;";
            _this3.outerCarousel.flickityInstance.unbindDrag();
            _this3.outerCarousel.flickityInstance.element.classList.add(
              "is-zoomed",
            );
            _this3.outerCarousel.getSelectedCell().classList.add("is-expanded");
          });
        },
      },
      {
        key: "_calculateImageTransform",
        value: function _calculateImageTransform(openPopover) {
          var _this4 = this;
          var selectedCell = this.outerCarousel.getSelectedCell();
          fastdom.measure(function () {
            var scale =
                window.innerWidth /
                (selectedCell.offsetWidth -
                  parseInt(window.getComputedStyle(selectedCell).paddingLeft) *
                    2),
              heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
              hiddenImageHeight = Math.round(
                Math.max(
                  heightAfterScale -
                    (window.innerHeight - openPopover.element.offsetHeight),
                  0,
                ),
              ),
              visibleImageHeight = heightAfterScale - hiddenImageHeight,
              minTranslateY = Math.round(
                -(
                  selectedCell.getBoundingClientRect().top -
                  (heightAfterScale - selectedCell.offsetHeight) / 2
                ),
              ),
              maxTranslateY = Math.round(minTranslateY - hiddenImageHeight);
            _this4._calculateTransformForDotListener = function (event) {
              var dotTopPosition = Math.round(
                  (event.detail.dot.offsetTop +
                    event.detail.dot.offsetHeight / 2) *
                    scale,
                ),
                offsetToMove = Math.round(
                  dotTopPosition - visibleImageHeight / 2,
                ),
                translateY = Math.min(
                  Math.max(minTranslateY - offsetToMove, maxTranslateY),
                  minTranslateY,
                );
              fastdom.mutate(function () {
                _this4.outerCarousel.flickityInstance.viewport.style.transform =
                  "translate3d(0, "
                    .concat(Math.round(translateY), "px, 0) scale(")
                    .concat(scale, ")");
              });
            };
            selectedCell.addEventListener(
              "product:changed",
              _this4._calculateTransformForDotListener,
            );
            selectedCell.dispatchEvent(
              new CustomEvent("product:changed", {
                detail: {
                  dot: selectedCell.querySelector(
                    ".ShopTheLook__Dot.is-active",
                  ),
                },
              }),
            );
          });
        },
      },
      {
        key: "_closePocketZoom",
        value: function _closePocketZoom() {
          var _this5 = this;
          var selectedCell = this.outerCarousel.getSelectedCell();
          selectedCell.removeEventListener(
            "product:changed",
            this._calculateTransformForDotListener,
          );
          fastdom.mutate(function () {
            document.getElementById("shopify-section-header").style.cssText =
              "transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;";
            _this5.outerCarousel.flickityInstance.bindDrag();
            _this5.outerCarousel.flickityInstance.element.classList.remove(
              "is-zoomed",
            );
            _this5.outerCarousel.flickityInstance.viewport.style.transform =
              null;
            selectedCell.classList.remove("is-expanded");
          });
        },
      },
    ]);
    return ShopTheLookSection;
  })();
  var SidebarMenuSection = (function () {
    function SidebarMenuSection(container) {
      _classCallCheck(this, SidebarMenuSection);
      this.element = container;
      this.sidebarDrawer = new Drawer(container);
    }
    _createClass(SidebarMenuSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.sidebarDrawer.destroy();
        },
      },
      {
        key: "onSelect",
        value: function onSelect() {
          this.sidebarDrawer.open();
        },
      },
      {
        key: "onDeselect",
        value: function onDeselect() {
          this.sidebarDrawer.close();
        },
      },
    ]);
    return SidebarMenuSection;
  })();
  var SlideshowSection = (function () {
    function SlideshowSection(container) {
      _classCallCheck(this, SlideshowSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.slideshow = new Carousel(
        this.element.querySelector("[data-flickity-config]"),
        { onSelect: this._onSlideChanged.bind(this) },
      );
      this.selectedSlide = null;
      this.shouldAnimate = !0;
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0,
      });
      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(
          this.slideshow.flickityInstance.selectedCell.element,
          !0,
        );
      }
      this._attachListeners();
    }
    _createClass(SlideshowSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.slideshow.destroy();
          this.timeline.kill();
          this.delegateElement.off();
          document.removeEventListener(
            "breakpoint:changed",
            this._onBreakpointChangedListener,
          );
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.stopPlayer();
          }
          this.shouldAnimate = !event.detail.load;
          this.slideshow.selectCell(
            event.target.getAttribute("data-slide-index"),
            !1,
            !event.detail.load,
          );
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          this.shouldAnimate = !0;
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.playPlayer();
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onBreakpointChangedListener =
            this._onBreakpointChanged.bind(this);
          this.delegateElement.on(
            "mouseenter",
            ".Button",
            this._pauseSlideshow.bind(this),
            !0,
          );
          this.delegateElement.on(
            "mouseleave",
            ".Button",
            this._resumeSlideshow.bind(this),
            !0,
          );
          document.addEventListener(
            "breakpoint:changed",
            this._onBreakpointChangedListener,
          );
        },
      },
      {
        key: "_pauseSlideshow",
        value: function _pauseSlideshow() {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.pausePlayer();
          }
        },
      },
      {
        key: "_resumeSlideshow",
        value: function _resumeSlideshow() {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.unpausePlayer();
          }
        },
      },
      {
        key: "_onSlideChanged",
        value: function _onSlideChanged(index, element) {
          this._transitionToSlide(element);
        },
      },
      {
        key: "_transitionToSlide",
        value: function _transitionToSlide(slide) {
          var _this = this;
          this.timeline.clear();
          if (this.selectedSlide) {
            this._slideLeave(this.selectedSlide);
            this.timeline.addLabel("enter", this.shouldAnimate ? "-=0.4" : 0);
          }
          this._lazyLoadNextImage();
          this.timeline.fromTo(
            slide,
            this.selectedSlide && this.shouldAnimate ? 0.3 : 0,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: Cubic.easeInOut },
            "enter",
          );
          if (
            this.slideshow.flickityInstance.options.autoPlay &&
            this.slideshow.flickityInstance.player.state === "playing"
          ) {
            this.slideshow.flickityInstance.pausePlayer();
          }
          Dom.nodeListToArray(
            slide.querySelectorAll(".Slideshow__Image"),
          ).forEach(function (image) {
            if (
              image.classList.contains("Image--lazyLoading") ||
              image.classList.contains("Image--lazyLoad")
            ) {
              image.addEventListener(
                "lazyloaded",
                _this._slideEnter.bind(_this, slide),
              );
            } else {
              _this._slideEnter(slide);
            }
          });
          this.selectedSlide = slide;
        },
      },
      {
        key: "_slideLeave",
        value: function _slideLeave(slide) {
          var content = slide.querySelector(".SectionHeader"),
            buttonWrapper = slide.querySelector(
              ".SectionHeader__ButtonWrapper",
            );
          this.timeline.fromTo(
            slide,
            this.shouldAnimate ? 0.3 : 0,
            { autoAlpha: 1 },
            {
              autoAlpha: 0,
              ease: Cubic.easeInOut,
              delay: this.shouldAnimate ? 0.35 : 0,
            },
          );
          if (content) {
            this.timeline.fromTo(
              content,
              this.shouldAnimate ? 0.4 : 0,
              { autoAlpha: 1, y: 0 },
              { autoAlpha: 0, y: 20, ease: Cubic.easeIn },
              0,
            );
          }
          if (buttonWrapper) {
            this.timeline.fromTo(
              buttonWrapper,
              this.shouldAnimate ? 0.4 : 0,
              { autoAlpha: 1, y: 0 },
              { autoAlpha: 0, y: 10, ease: Cubic.easeIn },
              0,
            );
          }
        },
      },
      {
        key: "_slideEnter",
        value: function _slideEnter(slide) {
          var images = slide.querySelectorAll(".Slideshow__Image"),
            content = slide.querySelector(".SectionHeader"),
            buttonWrapper = slide.querySelector(
              ".SectionHeader__ButtonWrapper",
            );
          if (
            this.slideshow.flickityInstance.options.autoPlay &&
            this.slideshow.flickityInstance.player.state === "paused"
          ) {
            this.slideshow.flickityInstance.unpausePlayer();
          }
          if (
            window.CSS &&
            window.CSS.supports("(object-fit: cover) or (-o-object-fit: cover)")
          ) {
            if (window.theme.showImageZooming) {
              this.timeline.fromTo(
                images,
                this.shouldAnimate ? 1.2 : 0,
                { opacity: 0, scale: 1.2 },
                { opacity: 1, scale: 1, ease: Quad.easeOut },
                "enter",
              );
            } else {
              this.timeline.fromTo(
                images,
                this.shouldAnimate ? 1.2 : 0,
                { opacity: 0 },
                { opacity: 1, ease: Quad.easeOut },
                "enter",
              );
            }
          }
          if (content) {
            this.timeline.fromTo(
              content,
              this.shouldAnimate ? 0.8 : 0,
              { autoAlpha: 0, y: 30 },
              {
                autoAlpha: 1,
                y: 0,
                delay: this.shouldAnimate ? 0.8 : 0,
                ease: Cubic.easeOut,
              },
              "enter",
            );
          }
          if (buttonWrapper) {
            this.timeline.fromTo(
              buttonWrapper,
              this.shouldAnimate ? 0.8 : 0,
              { autoAlpha: 0, y: 20 },
              {
                autoAlpha: 1,
                y: 0,
                delay: this.shouldAnimate ? 0.8 : 0,
                ease: Cubic.easeOut,
              },
              "enter",
            );
          }
        },
      },
      {
        key: "_lazyLoadNextImage",
        value: function _lazyLoadNextImage() {
          var currentIndex = this.slideshow.flickityInstance.selectedIndex,
            breakpoint = Responsive.getCurrentBreakpoint();
          if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
            var nextCellElement =
                this.slideshow.flickityInstance.cells[currentIndex + 1].element,
              imageContainers = Dom.nodeListToArray(
                nextCellElement.querySelectorAll(".Slideshow__ImageContainer"),
              ),
              imageToReveal = null;
            if (breakpoint === "phone") {
              imageToReveal = imageContainers[0];
            } else {
              imageToReveal = imageContainers[1];
            }
            if (
              window.lazySizes &&
              imageToReveal &&
              imageToReveal.classList.contains("Image--lazyLoad")
            ) {
              lazySizes.loader.unveil(imageToReveal.firstElementChild);
            }
          }
        },
      },
      {
        key: "_onBreakpointChanged",
        value: function _onBreakpointChanged(event) {
          if (
            (event.detail.previousBreakpoint === "phone" &&
              event.detail.currentBreakpoint !== "phone") ||
            (event.detail.previousBreakpoint !== "phone" &&
              event.detail.currentBreakpoint === "phone")
          ) {
            this.selectedSlide = null;
            this._transitionToSlide(
              this.slideshow.flickityInstance.selectedElement,
            );
          }
        },
      },
    ]);
    return SlideshowSection;
  })();
  var TestimonialsSection = (function () {
    function TestimonialsSection(container) {
      _classCallCheck(this, TestimonialsSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.navItems = Dom.nodeListToArray(
        this.element.querySelectorAll(".TestimonialNav__Item"),
      );
      this.carousel = new Carousel(
        this.element.querySelector(".TestimonialList"),
        { onSelect: this._testimonialChanged.bind(this) },
      );
      this._setupAutoplayToggle();
      this._enhancePageDots();
      this._attachListeners();
    }
    _createClass(TestimonialsSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.carousel.destroy();
          this.delegateElement.off("click");
        },
      },
      {
        key: "_setupAutoplayToggle",
        value: function _setupAutoplayToggle() {
          var _this = this;
          this.autoplayToggle = this.element.querySelector(
            "[data-testimonial-autoplay]",
          );
          this.isPaused = false;
          // Checked before the toggle, not after: the button is behind a theme
          // setting that is off by default, but honouring an OS-level request
          // for reduced motion should not depend on that setting.
          if (
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            this._setPaused(true);
          }
          if (!this.autoplayToggle) {
            return;
          }
          this.autoplayToggle.addEventListener("click", function () {
            _this._setPaused(!_this.isPaused);
          });
        },
      },
      {
        key: "_setPaused",
        value: function _setPaused(paused) {
          this.isPaused = paused;
          if (paused) {
            this.carousel.pausePlayer();
          } else {
            this.carousel.unpausePlayer();
          }
          if (!this.autoplayToggle) {
            return;
          }
          this.autoplayToggle.setAttribute(
            "aria-pressed",
            paused ? "true" : "false",
          );
          var label = this.autoplayToggle.getAttribute(
            paused ? "data-label-play" : "data-label-pause",
          );
          if (label) {
            this.autoplayToggle.setAttribute("aria-label", label);
          }
        },
      },
      {
        key: "_enhancePageDots",
        value: function _enhancePageDots() {
          // Flickity builds page dots as bare <li>: no role, no tabindex, no
          // accessible name. They were unreachable by keyboard and announced
          // as empty list items ("blank"), which is also what made the gap
          // between this section and the one below read as nothing.
          var dots = this.element.querySelectorAll(".flickity-page-dots .dot");
          if (!dots.length) {
            return;
          }
          var list = this.element.querySelector(".TestimonialList");
          var template = list && list.getAttribute("data-label-slide");
          var onKeydown = function onKeydown(event) {
            if (
              event.key !== "Enter" &&
              event.key !== " " &&
              event.key !== "Spacebar"
            ) {
              return;
            }
            // role="button" implies Enter/Space activate it, but an <li> has
            // no native behaviour to inherit.
            event.preventDefault();
            event.currentTarget.click();
          };
          for (var i = 0; i < dots.length; i++) {
            dots[i].setAttribute("role", "button");
            dots[i].setAttribute("tabindex", "0");
            if (template) {
              dots[i].setAttribute(
                "aria-label",
                template
                  .replace("[n]", i + 1)
                  .replace("[total]", dots.length),
              );
            }
            dots[i].addEventListener("keydown", onKeydown);
          }
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.carousel.selectCell(
            event.target.getAttribute("data-slide-index"),
            !0,
          );
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          this.carousel.unpausePlayer();
        },
      },
      {
        key: "_testimonialClicked",
        value: function _testimonialClicked(event, target) {
          this.carousel.pausePlayer();
          this.carousel.selectCell(parseInt(target.getAttribute("data-index")));
          this.carousel.unpausePlayer();
        },
      },
      {
        key: "_testimonialChanged",
        value: function _testimonialChanged(newIndex) {
          this.navItems.forEach(function (item, index) {
            item.classList.remove("is-selected");
            if (newIndex === index) {
              item.classList.add("is-selected");
            }
          });
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          // dom-delegate binds a real click listener on the section root, and
          // Chrome marks every descendant as clickable when an ancestor has
          // one — which is why NVDA announced this section's heading as
          // "clickable" despite the <h2> itself having no handler, no tabindex
          // and cursor:auto.
          //
          // .TestimonialNav__Item is not rendered by home-testimonials.liquid
          // at all (leftover from an earlier version of the section), so this
          // delegate never matched anything. Only bind it if that nav is
          // actually present.
          if (!this.navItems.length) {
            return;
          }
          this.delegateElement.on(
            "click",
            ".TestimonialNav__Item",
            this._testimonialClicked.bind(this),
          );
        },
      },
    ]);
    return TestimonialsSection;
  })();

  var ProductGridBlock = (function () {
    function ProductGridBlock(container) {
      _classCallCheck(this, ProductGridBlock);

      const enableSecondaryImage = container?.dataset?.enableSecondaryImage;
      if (!enableSecondaryImage) {
        return;
      }

      const gridType = container.dataset.gridType;

      this.element = container;

      this._carousels = [];

      this.defaultOptions = {
        imagesLoaded: true,
        prevNextButtons: false,
        wrapAround: false,
        dragThreshold: 8,
        pageDots: true,
        contain: true,
        cellAlign: "left",
        draggable: true,
        resize: true,
      };

      this._onBreakpointChange = this.updateDisplayForBreakpoint.bind(this);
      this._onColorDotChanged = this.updateOnColorDotChanged.bind(this);

      if (gridType == "single") {
        this.init();
      } else {
        document.addEventListener("products:grouped", this.init.bind(this));
      }
    }

    _createClass(ProductGridBlock, [
      {
        key: "init",
        value: function init() {
          var _this = this;
          document.removeEventListener(
            "breakpoint:changed",
            this._onBreakpointChange,
          );
          document.removeEventListener(
            "color-dot:changed",
            this._onColorDotChanged,
          );
          this.updateDisplayForBreakpoint();
          document.addEventListener(
            "breakpoint:changed",
            this._onBreakpointChange,
          );
          document.addEventListener(
            "color-dot:changed",
            this._onColorDotChanged,
          );
        },
      },
      {
        key: "checkImageReady",
        value: function checkImageReady(carousel) {
          if (!carousel) return;
          const _this = this;
          const image = carousel.querySelector(".product-main-image img");
          if (!image) return;
          const handleImageReady = () => {
            _this.updateCarousel(carousel);
          };

          // Set the onload handler FIRST (before checking complete)
          image.onload = handleImageReady;

          // Check if image is already complete AND has dimensions
          if (image.complete && image.naturalWidth > 0) {
            // Image is already loaded, but use decode() for safety if available
            if (image.decode) {
              image
                .decode()
                .then(handleImageReady)
                .catch(() => handleImageReady()); // Fallback if decode fails
            } else {
              // For older browsers, use a small timeout to ensure rendering
              setTimeout(handleImageReady, 0);
            }
          }
        },
      },
      {
        key: "updateOnColorDotChanged",
        value: function updateOnColorDotChanged(event) {
          const carousel = event.detail && event.detail.carousel;
          if (!carousel || !this.element.contains(carousel)) {
            return;
          }
          const flickity = Flickity.data(carousel);
          if (
            flickity &&
            carousel.querySelectorAll(".carousel-cell").length == 1
          ) {
            flickity.destroy();
            return;
          }
          this.checkImageReady(carousel);
        },
      },
      {
        key: "updateDisplayForBreakpoint",
        value: function updateDisplayForBreakpoint() {
          var _this = this;
          Dom.nodeListToArray(
            this.element.querySelectorAll(".product-images-container.carousel"),
          ).forEach(function (item) {
            var cells = item.querySelectorAll(".carousel-cell");
            if (!cells.length || cells.length < 2) {
              return;
            }
            if (Flickity.data(item)) {
              return;
            }
            _this.checkImageReady(item);
          });
        },
      },
      {
        key: "updateCarousel",
        value: function updateCarousel(c) {
          var atDesk = Responsive.matchesBreakpoint("desk");
          var flickity = Flickity.data(c);

          if (atDesk) {
            try {
              if (flickity) {
                flickity.destroy();
              }
            } catch (err) {
              console.warn("Error destroying carousel on desk:", err);
            }
          } else {
            if (!flickity) {
              try {
                var flickity = new Flickity(c, this.defaultOptions);

                flickity.on("select", () => {
                  try {
                    var selectedCell = flickity.selectedElement;

                    if (!selectedCell) {
                      return;
                    }

                    const viewport = selectedCell.closest(".flickity-viewport");
                    const productUrlEl = selectedCell.closest(".product-url");

                    if (!viewport || !productUrlEl) return;

                    if (
                      selectedCell.classList.contains("product-secondary-image")
                    ) {
                      selectedCell.style.opacity = 1;
                      viewport.style.height =
                        flickity.maxCellHeight + 30 + "px";
                      productUrlEl.style.padding = "0";
                    } else {
                      viewport.style.height = flickity.maxCellHeight + "px";
                      productUrlEl.style.padding =
                        window.themeVariables.template == "collection.byob"
                          ? "20px"
                          : "10px 15px";
                    }
                  } catch (err) {
                    console.warn("onSelect error in ProductGridBlock:", err);
                  }
                });

                // flickity.reloadCells();
                // flickity.resize();
              } catch (err) {
                console.warn("Error reinitializing carousel off desk:", err);
              }
            } else {
              try {
                // flickity.reloadCells();
                // flickity.resize();
                flickity.select(0, false, true);
              } catch (err) {
                console.warn("Error resizing flickity on non-desk:", err);
              }
            }
          }
        },
      },
      {
        key: "onUnload",
        value: function onUnload() {
          document.removeEventListener(
            "breakpoint:changed",
            this._onBreakpointChange,
          );
          document.removeEventListener(
            "color-dot:changed",
            this._onColorDotChanged,
          );

          this._carousels.forEach(function (c) {
            try {
              c.carousel.flickityInstance.destroy();
            } catch (err) {
              console.warn("Error destroying carousel in onUnload:", err);
            }
          });
          this._carousels = [];
        },
      },
    ]);

    return ProductGridBlock;
  })();

  new ProductGridBlock(document.querySelector("[data-product-grid]"));

  var LogoListSection = (function () {
    function LogoListSection(container) {
      let requestId;
      let marqueeSlider = document.querySelector(".marquee-slider");
      let marqueeSlide = document.querySelector(".logo-list__item");
      // This is a continuous ticker, not a slideshow: play() nudges x every
      // frame and there are no discrete slides to move between. Flickity's
      // defaults were adding interaction affordances that only produced noise
      // for screen reader users -
      //   accessibility: puts tabindex="0" on the strip, so it was a focusable
      //     div with no accessible name and announced as "blank". Arrow keys
      //     would fight the ticker anyway.
      //   draggable: binds click/drag handlers, and Chrome flags every
      //     descendant as clickable when an ancestor has one - which is why the
      //     first logo announced as "clickable".
      // The logos themselves stay in the accessibility tree and read normally.
      let mainTicker = new Flickity(".marquee-slider", {
        accessibility: !1,
        draggable: !1,
        resize: !0,
        wrapAround: !0,
        prevNextButtons: !1,
        pageDots: !1,
        percentPosition: !0,
        setGallerySize: !0,
      });
      mainTicker.x = 0;
      play();
      function play() {
        mainTicker.x -= 0.5;
        mainTicker.settle(mainTicker.x);
        requestId = window.requestAnimationFrame(play);
      }
      function pause() {
        if (requestId) {
          window.cancelAnimationFrame(requestId);
          requestId = undefined;
        }
      }

      marqueeSlider.addEventListener("mouseenter", () => pause());
      marqueeSlider.addEventListener("mouseleave", () => play());
    }
    return LogoListSection;
  })();
  var TimelineSection = (function () {
    function TimelineSection(container) {
      _classCallCheck(this, TimelineSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.items = Dom.nodeListToArray(
        this.element.querySelectorAll(".Timeline__Item"),
      );
      this.navItems = Dom.nodeListToArray(
        this.element.querySelectorAll(".Timeline__NavItem"),
      );
      this._attachListeners();
    }
    _createClass(TimelineSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.navItems[
            parseInt(event.target.getAttribute("data-index"))
          ].click();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            ".Timeline__NavItem",
            this._clickOnNavItem.bind(this),
          );
        },
      },
      {
        key: "_clickOnNavItem",
        value: function _clickOnNavItem(event, target) {
          var newItem = this.items[parseInt(target.getAttribute("data-index"))];
          if (newItem.classList.contains("is-selected")) {
            return;
          }
          var isContentLarger = !1,
            navWrapper = target.parentNode,
            scrollableOffset = 0;
          fastdom.measure(function () {
            var scrollableWidth = navWrapper.scrollWidth,
              visibleWidth = navWrapper.offsetWidth;
            isContentLarger = visibleWidth < scrollableWidth;
            if (isContentLarger) {
              var beginBound = target.offsetLeft,
                endBound = beginBound + target.offsetWidth,
                closerToLeft = beginBound <= visibleWidth - endBound;
              var itemToUse = null;
              if (closerToLeft) {
                itemToUse = target.previousElementSibling || target;
              } else {
                itemToUse = target.nextElementSibling || target;
              }
              var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                itemEndBound = itemBeginBound + itemToUse.offsetWidth;
              if (itemEndBound > visibleWidth) {
                scrollableOffset = itemEndBound - visibleWidth;
              } else if (itemBeginBound < 0) {
                scrollableOffset = itemBeginBound;
              }
            }
          });
          fastdom.mutate(function () {
            if (isContentLarger) {
              navWrapper.scrollBy({
                behavior: "smooth",
                left: scrollableOffset,
              });
            }
            target.classList.add("is-selected");
            Dom.getSiblings(target, ".is-selected").forEach(function (item) {
              item.classList.remove("is-selected");
            });
            newItem.classList.add("is-selected");
            Dom.getSiblings(newItem, ".is-selected").forEach(function (item) {
              item.classList.remove("is-selected");
            });
          });
        },
      },
    ]);
    return TimelineSection;
  })();
  var PriceRange = (function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);
    var _super = _createSuper(PriceRange);
    function PriceRange() {
      _classCallCheck(this, PriceRange);
      return _super.apply(this, arguments);
    }
    _createClass(PriceRange, [
      {
        key: "connectedCallback",
        value: function connectedCallback() {
          var _this = this;
          this.rangeLowerBound = this.querySelector(
            ".price-range__range-group input:first-child",
          );
          this.rangeHigherBound = this.querySelector(
            ".price-range__range-group input:last-child",
          );
          this.textInputLowerBound = this.querySelector(
            ".price-range__input:first-child input",
          );
          this.textInputHigherBound = this.querySelector(
            ".price-range__input:last-child input",
          );
          this.textInputLowerBound.addEventListener("focus", function () {
            return _this.textInputLowerBound.select();
          });
          this.textInputHigherBound.addEventListener("focus", function () {
            return _this.textInputHigherBound.select();
          });
          this.textInputLowerBound.addEventListener("change", function (event) {
            event.target.value = Math.max(
              Math.min(
                parseInt(event.target.value),
                parseInt(_this.textInputHigherBound.value || event.target.max) -
                  1,
              ),
              event.target.min,
            );
            _this.rangeLowerBound.value = event.target.value;
            _this.rangeLowerBound.parentElement.style.setProperty(
              "--range-min",
              "".concat(
                (parseInt(_this.rangeLowerBound.value) /
                  parseInt(_this.rangeLowerBound.max)) *
                  100,
                "%",
              ),
            );
          });
          this.textInputHigherBound.addEventListener(
            "change",
            function (event) {
              event.target.value = Math.min(
                Math.max(
                  parseInt(event.target.value),
                  parseInt(
                    _this.textInputLowerBound.value || event.target.min,
                  ) + 1,
                ),
                event.target.max,
              );
              _this.rangeHigherBound.value = event.target.value;
              _this.rangeHigherBound.parentElement.style.setProperty(
                "--range-max",
                "".concat(
                  (parseInt(_this.rangeHigherBound.value) /
                    parseInt(_this.rangeHigherBound.max)) *
                    100,
                  "%",
                ),
              );
            },
          );
          this.rangeLowerBound.addEventListener("change", function (event) {
            _this.textInputLowerBound.value = event.target.value;
            _this.textInputLowerBound.dispatchEvent(
              new Event("change", { bubbles: !0 }),
            );
          });
          this.rangeHigherBound.addEventListener("change", function (event) {
            _this.textInputHigherBound.value = event.target.value;
            _this.textInputHigherBound.dispatchEvent(
              new Event("change", { bubbles: !0 }),
            );
          });
          this.rangeLowerBound.addEventListener("input", function (event) {
            event.target.value = Math.min(
              parseInt(event.target.value),
              parseInt(_this.textInputHigherBound.value || event.target.max) -
                1,
            );
            event.target.parentElement.style.setProperty(
              "--range-min",
              "".concat(
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                  100,
                "%",
              ),
            );
            _this.textInputLowerBound.value = event.target.value;
          });
          this.rangeHigherBound.addEventListener("input", function (event) {
            event.target.value = Math.max(
              parseInt(event.target.value),
              parseInt(_this.textInputLowerBound.value || event.target.min) + 1,
            );
            event.target.parentElement.style.setProperty(
              "--range-max",
              "".concat(
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                  100,
                "%",
              ),
            );
            _this.textInputHigherBound.value = event.target.value;
          });
        },
      },
    ]);
    return PriceRange;
  })(_wrapNativeSuper(HTMLElement));
  window.customElements.define("price-range", PriceRange);

  var GiftCardRecipient = (function (_HTMLElement) {
    _inherits(GiftCardRecipient, _HTMLElement);
    var _super = _createSuper(GiftCardRecipient);
    function GiftCardRecipient() {
      _classCallCheck(this, GiftCardRecipient);
      return _super.apply(this, arguments);
    }
    _createClass(GiftCardRecipient, [
      {
        key: "connectedCallback",
        value: function connectedCallback() {
          var _this = this;
          var properties = Array.from(
            this.querySelectorAll('[name*="properties"]'),
          );
          var checkboxPropertyName =
            "properties[__shopify_send_gift_card_to_recipient]";
          this.recipientCheckbox = properties.find(function (input) {
            return input.name === checkboxPropertyName;
          });
          this.recipientOtherProperties = properties.filter(function (input) {
            return input.name !== checkboxPropertyName;
          });
          this.recipientFieldsContainer = this.querySelector(
            ".gift-card-recipient__fields",
          );
          this.offsetProperty = this.querySelector(
            '[name="properties[__shopify_offset]"]',
          );
          if (this.offsetProperty) {
            this.offsetProperty.value = new Date()
              .getTimezoneOffset()
              .toString();
          }
          this.recipientSendOnProperty = this.querySelector(
            '[name="properties[Send on]"]',
          );
          var minDate = new Date();
          var maxDate = new Date();
          maxDate.setDate(minDate.getDate() + 90);
          if (this.recipientSendOnProperty) {
            this.recipientSendOnProperty.setAttribute(
              "min",
              this.formatDate(minDate),
            );
            this.recipientSendOnProperty.setAttribute(
              "max",
              this.formatDate(maxDate),
            );
          }
          if (this.recipientCheckbox) {
            this.recipientCheckbox.addEventListener(
              "change",
              this.synchronizeProperties.bind(this),
            );
          }
          this.synchronizeProperties();
        },
      },
      {
        key: "synchronizeProperties",
        value: function synchronizeProperties() {
          var _this = this;
          if (!this.recipientCheckbox) return;
          this.recipientOtherProperties.forEach(function (property) {
            property.disabled = !_this.recipientCheckbox.checked;
          });
          if (this.recipientFieldsContainer) {
            this.recipientFieldsContainer.toggleAttribute(
              "hidden",
              !this.recipientCheckbox.checked,
            );
          }
        },
      },
      {
        key: "formatDate",
        value: function formatDate(date) {
          var offset = date.getTimezoneOffset();
          var offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
          return offsetDate.toISOString().split("T")[0];
        },
      },
    ]);
    return GiftCardRecipient;
  })(_wrapNativeSuper(HTMLElement));
  window.customElements.define("gift-card-recipient", GiftCardRecipient);

  (function () {
    new Collapsible();
    new Modal();
    new Responsive();
    if (
      window.theme.pageType !== "password" &&
      window.theme.pageType !== "gift_card"
    ) {
      new LoadingBar();
    }
    var sections = new SectionContainer();
    sections.register("header", HeaderSection);
    sections.register("footer", FooterSection);
    sections.register("sidebar-menu", SidebarMenuSection);
    sections.register("cart", CartSection);
    sections.register("newsletter-popup", NewsletterPopupSection);
    sections.register("slideshow", SlideshowSection);
    sections.register("collection-list", CollectionListSection);
    sections.register("article-list", ArticleList);
    sections.register("featured-product", FeaturedProductSection);
    sections.register("image-with-text-block", ImageWithTextBlockSection);
    sections.register("timeline", TimelineSection);
    sections.register("map", MapSection);
    sections.register("featured-collections", FeaturedCollectionsSection);
    sections.register("shop-the-look", ShopTheLookSection);
    sections.register("testimonials", TestimonialsSection);
    sections.register("logolist", LogoListSection);
    sections.register("background-video", BackgroundVideoSection);
    sections.register("product", ProductSection);
    sections.register("product-recommendations", ProductRecommendationsSection);
    sections.register("collection", CollectionSection);
    sections.register("collection", BYOB);
    sections.register("article-list", ArticleList);
    sections.register("article", ArticleSection);
    sections.register("faq", FaqSection);
    sections.register("login", LoginSection);
    sections.register("addresses", AddressesSection);
    sections.register("gift-card", GiftCardSection);
    sections.register("search", SearchSection);
    sections.register(
      "recently-viewed-products",
      RecentlyViewedProductsSection,
    );
    sections.register("shop-now", ShopNowSection);
    Flickity.defaults.dragThreshold = 7;
    (function () {
      var touchingCarousel = !1,
        touchStartCoords;
      document.body.addEventListener("touchstart", function (e) {
        if (e.target.closest(".flickity-slider")) {
          touchingCarousel = !0;
        } else {
          touchingCarousel = !1;
          return;
        }
        touchStartCoords = { x: e.touches[0].pageX, y: e.touches[0].pageY };
      });
      document.body.addEventListener(
        "touchmove",
        function (e) {
          if (!(touchingCarousel && e.cancelable)) {
            return;
          }
          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y,
          };
          if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold)
            e.preventDefault();
        },
        { passive: !1 },
      );
    })();
    (function () {
      Dom.nodeListToArray(document.querySelectorAll(".Rte table")).forEach(
        function (table) {
          table.outerHTML =
            '<div class="TableWrapper">' + table.outerHTML + "</div>";
        },
      );
      Dom.nodeListToArray(document.querySelectorAll(".Rte iframe")).forEach(
        function (iframe) {
          if (
            iframe.src.indexOf("youtube") !== -1 ||
            iframe.src.indexOf("youtu.be") !== -1 ||
            iframe.src.indexOf("vimeo") !== -1
          ) {
            iframe.outerHTML =
              '<div class="VideoWrapper">' + iframe.outerHTML + "</div>";
            iframe.src = iframe.src;
          }
        },
      );
    })();
    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
        announcementBar = document.querySelector(".AnnouncementBar");
      documentDelegate.on(
        "click",
        '[href^="#"], [data-href]',
        function (event, target) {
          var selector = target.hasAttribute("href")
            ? target.getAttribute("href")
            : target.getAttribute("data-href");
          if (selector === "#" || selector === "#main") {
            return;
          }
          var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute("data-offset") || 0);
          if (announcementBar) {
            offset -= announcementBar.clientHeight;
          }
          if (target.hasAttribute("data-focus-on-click")) {
            var prevScrollY = window.pageYOffset;
            element.focus({ preventScroll: !0 });
            if (window.pageYOffset !== prevScrollY) {
              window.scrollTo(window.pageXOffset, prevScrollY);
            }
            element.focus();
          }
          window.scrollTo({
            behavior: "smooth",
            top: element.offsetTop - offset,
          });
          event.preventDefault();
        },
      );
    })();
    (function () {
      var windowWidth = window.innerWidth,
        headerSection = document.getElementById("shopify-section-header");
      window.addEventListener("resize", function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }
          windowWidth = newWidth;
          document.documentElement.style.setProperty(
            "--window-height",
            window.innerHeight + "px",
          );
          if (headerSection) {
            document.documentElement.style.setProperty(
              "--header-height",
              headerSection.clientHeight + "px",
            );
          }
        });
      });
    })();
    (function () {
      function handleFirstTab(event) {
        if (event.keyCode === 9) {
          document.body.classList.add("is-tabbing");
          window.removeEventListener("keydown", handleFirstTab);
        }
      }
      window.addEventListener("keydown", handleFirstTab);
    })();
    if (window.theme.showPageTransition) {
      PageTransition.getInstance();
    }
  })();
});

class FreeShippingManager {
  constructor() {
    this.cartAttributes = window.themeVariables.cart?.attributes || {};
    this.defaultThreshold = THEME_SETTINGS.cart_free_shipping_threshold || 6500;
    // Tracks the threshold currently reflected in the UI. Seeded to the
    // default so that, with no variant class, unrelated body-class changes
    // are recognised as no-ops.
    this.currentThreshold = this.defaultThreshold;

    this.abTestClasses = [
      "free_shipping_over70_active",
      "free_shipping_over75_active",
    ];

    this.initObserver();
    this.initEventListeners();
    this.applyInitialState();
  }

  // The MutationObserver only fires on later class *changes*. When the A/B
  // tool injects the variant class before this runs (or it's server-rendered
  // onto <body>), no mutation fires — so process whatever class is already
  // present at startup.
  applyInitialState() {
    const { threshold } = this.getShippingSettings(document.body);
    this.currentThreshold = threshold;
    // Body class is the source of truth. Reconcile the persisted cart
    // attribute against it: this both applies a variant class present at load
    // AND clears a stale attribute left from a previous arm (so a reload with
    // no class reverts to the $65 default). A missing attribute counts as the
    // default, so a fresh visitor with no class does nothing.
    const stored = this.cartAttributes.shipping_threshold_abtest;
    const effective = stored ? stored * 1 : this.defaultThreshold;
    if (effective !== threshold) {
      this.updateUI(document.body);
      this.cartAttributes.shipping_threshold_abtest = threshold;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { shipping_threshold_abtest: threshold },
        }),
      });
    }
    // Tag any items already in the cart with the current arm.
    this.syncLineItemProperties();
  }

  // Shared: refresh the UI for the active arm and persist the value once
  // (only when it changed). Used by both the initial check and the observer.
  applyThreshold(element) {
    const { threshold } = this.getShippingSettings(element);
    // Skip when nothing changed, so unrelated body-class toggles (drawer
    // open/close, etc.) don't cause repeated UI work or cart POSTs.
    if (threshold === this.currentThreshold) return;
    this.currentThreshold = threshold;
    this.updateUI(element);
    if (this.cartAttributes.shipping_threshold_abtest != threshold) {
      this.cartAttributes.shipping_threshold_abtest = threshold;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { shipping_threshold_abtest: threshold },
        }),
      });
    }
    this.syncLineItemProperties();
  }

  // Map the active threshold to the A/B/C arm code the checkout function reads.
  getArmCode(threshold) {
    if (threshold === 7000) return "B";
    if (threshold === 7500) return "C";
    return "A";
  }

  // Stamp every cart line with `_shipping_test: <arm>` so the checkout
  // function can apply the matching free-shipping discount. The underscore
  // prefix keeps it hidden from the customer. Idempotent — only lines whose
  // value differs are updated, which also prevents any change.js feedback loop.
  async syncLineItemProperties() {
    const armCode = this.getArmCode(this.currentThreshold);
    let cart;
    try {
      cart = await fetch("/cart.js").then((r) => r.json());
    } catch (e) {
      return;
    }
    if (!cart || !cart.items) return;
    for (const item of cart.items) {
      const props = item.properties || {};
      if (props._shipping_test === armCode) continue;
      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.key,
            // MUST send quantity — change.js with `properties` but no
            // `quantity` resets the line to 1 (e.g. a 3-pack dropped to 1
            // when Priority Processing was toggled and cart:replaceContent
            // re-ran this sync).
            quantity: item.quantity,
            properties: Object.assign({}, props, { _shipping_test: armCode }),
          }),
        });
      } catch (e) {
        /* ignore individual line failures */
      }
    }
  }

  getShippingSettings(element) {
    // A/B/C thresholds (all share a 2+ minimum quantity):
    //   no class = $65 (A / default), over70 = $70 (B), over75 = $75 (C).
    if (element.classList.contains("free_shipping_over70_active")) {
      return { threshold: 7000, quantity: 2 };
    } else if (element.classList.contains("free_shipping_over75_active")) {
      return { threshold: 7500, quantity: 2 };
    }
    return { threshold: this.defaultThreshold, quantity: 2 };
  }

  updateUI(element) {
    const { threshold, quantity } = this.getShippingSettings(element);

    // Update amount remaining
    document.querySelectorAll("[data-free-shipping-amount]").forEach((el) => {
      if (el.getAttribute("data-cart-total-price")) {
        const cartTotal = parseInt(el.getAttribute("data-cart-total-price"));
        const remaining = (threshold - cartTotal) / 100;
        el.innerText = `$${remaining}`;
      } else {
        el.innerText = `$${threshold / 100}`;
      }
    });

    // Update quantity required
    document.querySelectorAll("[data-free-shipping-quantity]").forEach((el) => {
      el.innerText = `${quantity}+`;
    });

    // Update remaining quantity
    document
      .querySelectorAll("[data-free-shipping-remaining-quantity]")
      .forEach((el) => {
        const byobQty = parseInt(el.getAttribute("data-byob-quantity") || 0);
        el.innerText = quantity - byobQty;
      });

    // Update free shipping text on PDP below CTA
    if (window.themeVariables.template.includes("product")) {
      this.updatePDPUI(document.querySelector(".pro-main-price"));
    }

    // Progress bar & UI state changes
    const progressBar = document.querySelector(".progress-bar");
    if (progressBar) {
      const progressBarWidth =
        (parseInt(progressBar.getAttribute("data-cart-total-price")) /
          threshold) *
        100;
      const freeShippingUnlocked = progressBarWidth >= 100;

      progressBar.style.width = progressBarWidth + "%";
      progressBar.setAttribute("data-progress-bar-width", progressBarWidth);
      document.querySelector(
        '.free-shipping-amount-container[data-free-shipping-eligible="true"]',
      ).style.display = freeShippingUnlocked ? "flex" : "none";
      document.querySelector(
        '.free-shipping-amount-container[data-free-shipping-eligible="false"]',
      ).style.display = freeShippingUnlocked ? "none" : "flex";
      document
        .querySelector(".Cart__ShippingNotice .Drawer__Container")
        .classList.toggle("earned-free-shipping", !freeShippingUnlocked);

      document.querySelectorAll(".free-shipping-tag").forEach((element) => {
        element.style.display = freeShippingUnlocked ? "flex" : "none";
      });

      if (
        document.querySelector(
          ".byob-free-shipping-message [data-free-shipping-message]",
        )
      ) {
        document.querySelector(
          '.byob-free-shipping-message [data-free-shipping-message="true"]',
        ).style.display = freeShippingUnlocked ? "none" : "block";
        document.querySelector(
          '.byob-free-shipping-message [data-free-shipping-message="false"]',
        ).style.display = freeShippingUnlocked ? "block" : "none";
      }
    }
  }

  updatePDPUI(priceElement) {
    if (!priceElement) return;
    const { threshold, quantity } = this.getShippingSettings(document.body);
    const cartFreeShippingThreshold = threshold / 100;
    const percentSavingTags = [
      "ankle-socks",
      "orbit-ankle-aerolite-plus",
      "aerolite-plus-collection",
      "midcalf",
      "value-packs",
    ];
    const productForm = priceElement.closest(".ProductForm");
    const productMasterJson = JSON.parse(
      productForm.querySelector("[data-product-json]").innerHTML,
    );
    const productJson = productMasterJson.product;
    const packsInventoryJson = productMasterJson.inventories;
    const selectedSize =
      sessionStorage.getItem("product-selected-size") ||
      productForm.querySelector(
        '.SizeSwatch__Radio.MainProduct[type="radio"]:checked',
      )?.value;
    let selectedPack =
      sessionStorage.getItem("selectedPack") ||
      productForm.querySelector('.pack-variant-options [type="radio"]:checked')
        ?.value;
    if (productJson.type != "1-Pack") {
      selectedPack =
        productJson.type == "3-Pack" || productJson.type == "4-Pack"
          ? "3_pack"
          : "5_pack";
    }
    const productTags = productJson.tags;
    const selectedVariant =
      productJson.variants.find(function (variant) {
        return variant.title === selectedSize;
      }) || productJson.variants[0];
    const inventory_quantity =
      packsInventoryJson[selectedVariant.id]?.inventory_quantity ?? 0;
    const isEligibleForPercentSaving = productTags.some((tag) =>
      percentSavingTags.includes(tag),
    );

    const productPriceEl =
      priceElement.querySelector(".money.markdown-price") ||
      priceElement.querySelector(".ProductMeta__Price");
    const productPrice = parseInt(
      productPriceEl.innerText.replace(/[^0-9]/g, ""),
    );

    const defaultShippingText = productPrice < threshold
      ? `Free Shipping over <span data-free-shipping-amount>$${cartFreeShippingThreshold}</span>.`
      : "These socks ship free.";

    const packSavingsLabel =
      !isEligibleForPercentSaving && productTags.includes("ny-socks-25")
        ? "Additional pack savings"
        : "Includes 10% pack savings";

    const shippingText = {
      "1_pack": defaultShippingText,
      "3_pack": defaultShippingText,
      "5_pack": productTags.includes("outlet-collection") ? defaultShippingText : `${packSavingsLabel}${productPrice >= threshold ? " and free shipping" : ""}.`,
    };

    let regularShippingText = shippingText[selectedPack];
    if (productTags.includes("delayed-shipping")) {
      regularShippingText =
        (selectedPack === "3_pack" ? shippingText["1_pack"] : regularShippingText) + "<br>";
    }

    productForm.querySelector(".shipping-eligibility-block p").innerHTML = regularShippingText;
    const preorderDataEl = document.getElementById('PreorderQuantities-' + productJson.id);
    const preorderData = preorderDataEl ? JSON.parse(preorderDataEl.textContent || '{}') : {};
    const variantPreorderData = preorderData[selectedVariant.id];
    let isPreorderVariant = variantPreorderData && variantPreorderData.pre_order;

    if(isPreorderVariant && variantPreorderData && variantPreorderData.mod_inventory_quantity > variantPreorderData.preorder_threshold){
      isPreorderVariant = false;
      variantPreorderData.available = false;
    }

    const delayedShippingEl = productForm.querySelector('.pdp-delayed-shipping');
    if (delayedShippingEl) delayedShippingEl.style.display = isPreorderVariant && variantPreorderData?.ships_on_date ? 'inline-flex' : 'none';

    const propInput = document.getElementById('delayed-shipping-prop-' + productJson.id);
    if (propInput) propInput.disabled = !isPreorderVariant || !variantPreorderData?.ships_on_date;

    const preorderSuffix = productForm.querySelector('.ProductForm__PreorderSuffix');
    if (preorderSuffix) preorderSuffix.style.display = isPreorderVariant && variantPreorderData?.ships_on_date ? 'inline' : 'none';

    if (!productForm.querySelector(".pack-variant-options")) {
      return;
    }

    productForm
      .querySelectorAll('.pack-variant-options [type="radio"]')
      .forEach((el) => {
        el.removeAttribute("checked");
      });
    productForm
      .querySelector(
        `.pack-variant-options [type="radio"][value="${selectedPack}"]`,
      )
      .setAttribute("checked", "checked");

    const packUnitCounts = { "1_pack": 1, "3_pack": 3, "5_pack": 5 };

    // Some products (e.g. Last Chance) apply a DIFFERENT discount rate per
    // pack size, so a pack's real price can't be estimated by linearly
    // scaling whichever pack's price happens to be currently displayed —
    // that silently assumes a single uniform rate and gives a different
    // (wrong) estimate for the same button depending on which pack is
    // selected. The real rate per pack size is read straight from
    // MarkdownPricePro's registered markdowns (single source of truth —
    // never hardcode a rate here) and is 1 (no discount) when nothing
    // matches, so this behaves exactly as before for every other product.
    const isOutletProduct = productTags.includes("outlet-collection");
    const productCollections = (
      priceElement.getAttribute("data-product-coll") || ""
    ).split(",");
    const packMultiplier = (packUnits) =>
      MarkdownPricePro.getMultiplierForPackSize(productCollections, packUnits);

    const selectedPackUnits = packUnitCounts[selectedPack];
    const baseUnitPrice =
      productPrice / selectedPackUnits / packMultiplier(selectedPackUnits);

    productForm.querySelectorAll('.pack-variant-options [type="radio"]')
    .forEach((button) => {

      const packOfferTag = button.nextElementSibling.querySelector('.pack-offer-tag');

      if(button.value == '1_pack' || !button.nextElementSibling || !packOfferTag) return;

      const currentPackUnits = packUnitCounts[button.value];
      const estimatedPackPrice =
        baseUnitPrice * currentPackUnits * packMultiplier(currentPackUnits);

      packOfferTag.classList.toggle("hide-all", estimatedPackPrice < threshold);

      if (button.value == '5_pack' && isOutletProduct && estimatedPackPrice >= threshold) {
        packOfferTag.classList.remove("hide-all");
        packOfferTag.textContent = "SHIPS FREE";
      }
      
    });
  }

  initObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          // Re-apply on ANY body class change so that adding a variant class,
          // swapping between arms, and REMOVING all of them (revert to the
          // $65 default) are all handled. applyThreshold no-ops when the
          // computed threshold hasn't actually changed, so unrelated toggles
          // are cheap. Never disconnect.
          this.applyThreshold(document.body);
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  initEventListeners() {
    const self = this;
    document.addEventListener("cart:replaceContent", () => {
      this.updateUI(document.body);
      // Newly added items won't have the property yet — stamp them.
      this.syncLineItemProperties();
    });

    document.addEventListener("pack:changed", () => {
      this.updateUI(document.body);
    });

    // Update free shipping text on PDP below CTA
    if (window.themeVariables.template.includes("product")) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" &&
            mutation.target.classList.contains("pro-main-price")
          ) {
            self.updatePDPUI(mutation.target);
          }
        });
      });
      observer.observe(
        document.querySelector(
          'div[data-section="product-data-section"][data-page-type="product"]',
        ),
        { subtree: true, childList: true, characterData: true },
      );
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new FreeShippingManager();

  // Toggle .sortMenu active state on .sort-title click
  document.addEventListener("click", function (event) {
    if (event.target.closest(".sort-title")) {
      const clickedTitle = event.target.closest(".sort-title");
      const currentMenu = clickedTitle.closest(".sortMenu");

      document.querySelectorAll(".sortMenu").forEach((menu) => {
        if (menu !== currentMenu) {
          menu.classList.remove("active");
        }
      });

      currentMenu.classList.toggle("active");
    }
  });

  // Remove .active class on .cancel-btn click
  document.addEventListener("click", function (event) {
    if (event.target.closest(".cancel-btn")) {
      event.preventDefault();
      const cancelBtn = event.target.closest(".cancel-btn");
      const sortMenu = cancelBtn.closest(".sortMenu");
      if (sortMenu) sortMenu.classList.remove("active");
    }
  });

  // Send GA event on filter change
  document.addEventListener("change", function (event) {
    if (event.target.matches(".Filter-Option input")) {
      const category = event.target.getAttribute("data-category");
      const value = event.target.value;

      if (typeof ga === "function") {
        ga("send", "event", {
          eventCategory: "Filters",
          eventAction: category,
          eventLabel: value,
        });
      }
    }
  });

  document.addEventListener("click", function (event) {
    const isInsideSortMenu = event.target.closest(".sortMenu");

    if (!isInsideSortMenu) {
      document.querySelectorAll(".sortMenu.active").forEach((menu) => {
        menu.classList.remove("active");
      });
    }
  });

  const klaviyo_form_trigger = document.querySelector(".klaviyo_form_trigger");
  if (klaviyo_form_trigger) {
    klaviyo_form_trigger.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "TFNQ6f"]);
    });
  }

  // Sidebar menu: expand/collapse nested submenus (parent > child > grandchild)
  document.addEventListener("click", function (e) {
    const toggle = e.target.closest('[data-action="toggle-submenu"]');
    if (!toggle) return;
    const sidebarMenu = toggle.closest("#new-sidebar-menu");
    if (!sidebarMenu) return;

      e.preventDefault();
      e.stopPropagation();

      const parentLi = toggle.parentElement;
      if (!parentLi) return;

      // Close sibling submenus at the same level so only one is open per level
      const siblingLis = parentLi.parentElement
        ? parentLi.parentElement.children
        : [];
      for (let i = 0; i < siblingLis.length; i++) {
        const sibling = siblingLis[i];
        if (sibling === parentLi) continue;
        if (
          sibling.classList.contains("has-submenu") ||
          sibling.classList.contains("has-subsubmenu")
        ) {
          sibling.classList.remove("open");
          const siblingBtn = sibling.querySelector(
            ':scope > [data-action="toggle-submenu"]'
          );
          if (siblingBtn) siblingBtn.setAttribute("aria-expanded", "false");
        }
      }

      const isOpen = parentLi.classList.toggle("open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");

      // When collapsing a parent, also collapse any open descendants
      if (!isOpen) {
        const openDescendants = parentLi.querySelectorAll(".open");
        openDescendants.forEach(function (el) {
          el.classList.remove("open");
          const btn = el.querySelector(':scope > [data-action="toggle-submenu"]');
          if (btn) btn.setAttribute("aria-expanded", "false");
        });
    }
  });

  /* OLD new-sidebar open/close logic — replaced by toggle handler below
  const newSidebarEl = document.getElementById("new-sidebar-menu");
  if (newSidebarEl) {
    const openNewSidebar = function () {
      newSidebarEl.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("no-scroll");
    };
    const closeNewSidebar = function () {
      newSidebarEl.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("no-scroll");
    };

    document.addEventListener("click", function (e) {
      const opener = e.target.closest(
        '[data-action="open-drawer"][data-drawer-id="new-sidebar-menu"]'
      );
      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        openNewSidebar();
        return;
      }
      const closer = e.target.closest(
        '[data-action="close-drawer"][data-drawer-id="new-sidebar-menu"]'
      );
      if (closer) {
        e.preventDefault();
        e.stopPropagation();
        closeNewSidebar();
      }
    });

    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape" && newSidebarEl.getAttribute("aria-hidden") === "false") {
        closeNewSidebar();
      }
    });
  }
  */

  // New sidebar menu: hamburger toggles open/close; icon swaps via aria-expanded
  const newSidebarEl = document.getElementById("new-sidebar-menu");
  if (newSidebarEl) {
    const getHeaderEl = function () {
      return document.getElementById("shopify-section-header");
    };

    const positionBelowHeader = function () {
      const header = getHeaderEl();
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      newSidebarEl.style.setProperty("--new-sidebar-top", bottom + "px");
    };

    const setToggleState = function (expanded) {
      const toggles = document.querySelectorAll('[data-action="toggle-new-sidebar"]');
      toggles.forEach(function (btn) {
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
    };

    // Opening the menu flipped aria-expanded and made the panel visible, but
    // left focus on <body> - so a screen reader user got no sign it had opened.
    let sidebarLastFocused = null;

    const openNewSidebar = function () {
      sidebarLastFocused =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
      positionBelowHeader();
      newSidebarEl.setAttribute("aria-hidden", "false");
      // inert has to come off before focus(), or the call is ignored.
      newSidebarEl.removeAttribute("inert");
      setToggleState(true);
      newSidebarEl.focus();
    };

    const closeNewSidebar = function () {
      // Move focus out before inert goes back on, otherwise it lands on <body>
      // and the user loses their place entirely.
      if (
        sidebarLastFocused &&
        document.body.contains(sidebarLastFocused) &&
        sidebarLastFocused.getClientRects().length > 0
      ) {
        sidebarLastFocused.focus();
      }
      sidebarLastFocused = null;
      newSidebarEl.setAttribute("aria-hidden", "true");
      newSidebarEl.setAttribute("inert", "");
      setToggleState(false);
    };

    document.addEventListener("click", function (e) {
      const toggle = e.target.closest('[data-action="toggle-new-sidebar"]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        if (newSidebarEl.getAttribute("aria-hidden") === "false") {
          closeNewSidebar();
        } else {
          openNewSidebar();
        }
        return;
      }

      // Close the sidebar if the user opens search or cart from the header
      if (newSidebarEl.getAttribute("aria-hidden") === "false") {
        const closesSidebar = e.target.closest(
          '[data-action="toggle-search"], [data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
        );
        if (closesSidebar) {
          closeNewSidebar();
        }
      }
    });

    document.addEventListener("keyup", function (e) {
      if (
        e.key === "Escape" &&
        newSidebarEl.getAttribute("aria-hidden") === "false"
      ) {
        closeNewSidebar();
      }
    });

    window.addEventListener("resize", function () {
      if (newSidebarEl.getAttribute("aria-hidden") === "false") {
        positionBelowHeader();
      }
    });
  }

  // A/B test: close any open drawer if the variant class flips mid-session
  // so we don't leave a phantom-open panel from the wrong variant.
  if (typeof MutationObserver !== "undefined") {
    let lastIsLegacy = document.body.classList.contains("nav-variant-legacy");

    const onVariantFlip = function () {
      const newSidebar = document.getElementById("new-sidebar-menu");
      if (newSidebar && newSidebar.getAttribute("aria-hidden") === "false") {
        newSidebar.setAttribute("aria-hidden", "true");
        document
          .querySelectorAll('[data-action="toggle-new-sidebar"]')
          .forEach(function (btn) {
            btn.setAttribute("aria-expanded", "false");
          });
      }
      const legacySidebar = document.getElementById("sidebar-menu");
      if (legacySidebar && legacySidebar.getAttribute("aria-hidden") === "false") {
        legacySidebar.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("no-scroll");
      }
    };

    const variantObserver = new MutationObserver(function () {
      const isLegacy = document.body.classList.contains("nav-variant-legacy");
      if (isLegacy !== lastIsLegacy) {
        lastIsLegacy = isLegacy;
        onVariantFlip();
      }
    });
    variantObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // A/B test: PDP upsell — no-show template.
  // Convert Experience adds `pdp-upsell-b` to body asynchronously, so we
  // watch for the class change and immediately apply show/hide rather than
  // relying solely on CSS recalc timing.
  if (typeof MutationObserver !== "undefined") {
    var applyUpsellVariant = function () {
      var isB = document.body.classList.contains("pdp-upsell-b");
      var wrapperA = document.querySelector(".upsell-item-wrapper--pdp-ab-a");
      var wrapperB = document.querySelector(".upsell-item-wrapper--pdp-ab-b");
      if (wrapperA) wrapperA.style.display = isB ? "none" : "";
      if (wrapperB) wrapperB.style.display = isB ? "" : "none";
    };

    // Apply immediately in case the class is already present at script run time.
    applyUpsellVariant();

    var upsellVariantObserver = new MutationObserver(function () {
      applyUpsellVariant();
    });
    upsellVariantObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  /**
   * Prevent the colour/fabric/support-level swatch labels from scrolling
   * the page when clicked.
   *
   * Each swatch is a native <label for="..."> pointing at a real, but
   * visually-hidden, <input type="radio">. The hiding technique for these
   * three specifically is `position: absolute; width: 0; height: 0;`
   * (product-color-dots.liquid, fabric-technology.liquid,
   * support-level.liquid) — unlike the size and pack swatches, which hide
   * their inputs some other way but keep them real-sized and in flow.
   *
   * A native label click activates its associated control as part of the
   * click event's OWN default action, and that activation unconditionally
   * scrolls the (now-focused) control into view — it is not conditional on
   * whether focus actually changed. Pre-focusing the control ourselves on
   * pointerdown (an earlier attempt at this fix) does not help: instrumenting
   * it showed the scroll lands before that earlier focus() call even runs,
   * confirming the scroll is intrinsic to the label's click activation, not
   * a side effect of a focus *change* we could pre-empt. Because these
   * controls sit high up the product form, that scroll landed near the top
   * of the page on every colour, fabric or support level change, regardless
   * of how far down the shopper had scrolled.
   *
   * Fix: take over activation entirely. `preventDefault()` on the label's
   * click suppresses the native behaviour outright (both the scroll and the
   * check-toggle), then we replicate exactly what it would have done —
   * toggle `checked` and dispatch `change` so every existing handler (colour
   * dots, fabric cards, support-level cards) still fires unchanged — finishing
   * with a `preventScroll` focus purely so the control still reports as
   * focused for keyboard/AT users, without the jump. A disabled control (sold
   * out colour dots) is left alone: native activation on those is already a
   * no-op, so there is nothing to intercept.
   *
   * Scoped to click, not to focus generally — Tab-driven keyboard navigation
   * between swatches should still scroll a newly-focused one into view; that
   * is the browser doing exactly what a keyboard user needs.
   */
  document.addEventListener(
    "click",
    function (event) {
      var label = event.target.closest(
        "label.color-dot[for], label.fabric-tech-card[for], label.support-level-card[for]",
      );
      if (!label) return;
      var control = document.getElementById(label.getAttribute("for"));
      if (!control || control.disabled) return;

      event.preventDefault();
      if (!control.checked) {
        control.checked = true;
        control.dispatchEvent(new Event("change", { bubbles: true }));
      }
      control.focus({ preventScroll: true });
    },
    true,
  );


  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-scroll-to]")) {
      event.preventDefault();
      const target = event.target.closest("[data-scroll-to]");
      const targetId = target.getAttribute("data-scroll-to");
      if (targetId.startsWith("class:")) {
        const targetClass = targetId.split(":")[1];        
        const targetElements = document.getElementsByClassName(targetClass);
        if (targetElements.length > 0) {
          targetElements[0].scrollIntoView({ behavior: "smooth" });
        }
      } else {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  });
});
